(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[833],{

/***/ 9039:
/***/ (function(module) {

module.exports = "/_next/static/videos/mainvisual-video-L-62e507838df196cc3609d0dc119b608e.mp4";

/***/ }),

/***/ 1464:
/***/ (function(module) {

module.exports = "/_next/static/videos/mainvisual-video-M-6b8188c982bc2c56c6e40f3be90d4bc1.mp4";

/***/ }),

/***/ 6976:
/***/ (function(module) {

module.exports = "/_next/static/videos/mainvisual-video-S-9a63670c27ae7156f1eb5c4c46536908.mp4";

/***/ }),

/***/ 9540:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/content1@2x.fc02ee6e.png","height":1088,"width":1088,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAMFBMVEVFRldeY3aHi6JucoZ1eIyFiJuAgpMkJjRXVmRITGAuMkNdXm2RlKpnan48PEifqL/8z5OCAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOklEQVR4nAXBhwHAMAjAMLPJIP3/20osOaoilwU+bpeqbROiVD2PTy+7Wy1leKJxcgWY+5wd0J0J+QM2pgGD+KLrrwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 7388:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/content2@2x.d5f0d97e.png","height":1088,"width":1088,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAKlBMVEUsQmgqNFEgJ0AaHzUlLkoXGi0sPl1DXok0OVM8Q1wwTn1bYXlSWnJ4hKD5esB4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOElEQVR4nBXKuRHAMAwEsT1+ImW7/3Y9zBCAdAtVQbqtFm7dKrxnnhGkKVpccndxMb4JzsHj1eIHJUQBG+LI4L4AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 5744:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/content3@2x.da6bf090.png","height":1088,"width":1088,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAaVBMVEUVXpEKOF4iT3UpX4lOZ4ZkgZ4KSHUdYJEWVIQahsIgl9ZBXX9hfZRdYF9yi6Myd6IFhcw4Z44Va50Kb6hHXXcFeLsFZJVaaniZi6KjqsQyhLMAeb5Hfqg8eqUjaptoptBVcpQ5peB7t9y1EcYSAAAACXBIWXMAAAsTAAALEwEAmpwYAAAARUlEQVR4nAXBhwGAIBAAsRN4ioqIvbf9hzRB52xMVRmuI4k80nDe5futSw1tm+pZBvy4xzj1CkK5hdABTiscFpz32KL4AYHBAwWdrqTgAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 7027:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/content4@2x.d142a199.png","height":1088,"width":1088,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAG1BMVEUkMUknNU8uPFUyQl1yeYk0T3OqrbRWYXUkXJQhtnVKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMElEQVR4nEXLWQoAMAwC0Yymy/1PXJIW6o8PxIgfcdszo6lcHhTF2DWDbDeQ3wGIAwtqAFg8P76xAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 4656:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/content5@2x.e29f9ff4.png","height":1088,"width":1088,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAVFBMVEUYJUk/SGY0QWgpL0g6Qk4tOFw8QV1TVmosNksnMVAwMj1RU2AcLF83OEZiZWt6fJPJy9mMjqZDTkxWQ0U1OlU/PDqpmaANHVOUm6+HhJKpq7t0dYYjunpCAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQklEQVR4nAXBBwLAIAgEsENRwK3d7f//2QS+5qd9s0NTf41kQlyhyDJwxoJK98B2WMDlGhKr+J0XlCxKZgWAEAD7AWSHAmBv9EO3AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 7302:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/bluedot-logo-c.5c7bd623.svg","height":36,"width":229});

/***/ }),

/***/ 5564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XY": function() { return /* binding */ MainVisualOuterContainer; },
/* harmony export */   "Yo": function() { return /* binding */ ImgBackgroundWrapper; },
/* harmony export */   "px": function() { return /* binding */ PageOuterContainer; },
/* harmony export */   "rO": function() { return /* binding */ MainVisualInnerContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var components_Home_BannerItems__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2486);
/* harmony import */ var components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6627);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5505);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: ",
        ";\n  .target-img {\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  overflow-x: hidden;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  justify-content: center;\n  display: flex;\n  align-items: center;\n  width: 100vw;\n  width: 100%;\n  height: calc(var(--vh, 1vh) * 75);\n  color: #fff;\n  background: linear-gradient(\n    0deg,\n    rgba(21, 35, 70, 0.9),\n    rgba(21, 35, 70, 0.9)\n  );\n\n  @media screen and (max-width: 904px) {\n    height: calc(var(--vh, 1vh) * 100);\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  ",
        "\n  .main-typo {\n    color: #fff;\n    animation: ",
        " 1.5s 0.3s cubic-bezier(0.4, 0, 0.2, 1) backwards;\n    margin-bottom: 16px;\n  }\n  .main-typo span {\n    color: #2564ce;\n  }\n  .en-wrapper-pc {\n    display: block;\n  }\n  .en-wrapper-mo {\n    display: none;\n  }\n  .desc-text-wrapper {\n    overflow-y: hidden;\n  }\n  .desc-text-wrapper .anim-wrapper {\n    animation: ",
        " 1.5s 0.8s cubic-bezier(0.4, 0, 0.2, 1) backwards;\n  }\n\n  @media screen and (max-width: 1239px) {\n    .main-typo {\n      margin-bottom: 16px;\n    }\n  }\n\n  @media screen and (max-width: 599px) {\n    .en-wrapper-pc {\n      display: none;\n    }\n    .en-wrapper-mo {\n      display: block;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



/**
 * Next/Image 컴포넌트를 감싸는 역할을 한다. (position 기준)
 * @param {boolean} isNormalUse - 배경으로 사용하는지 아닌지 여부
 */ var ImgBackgroundWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "CommonWrappers__ImgBackgroundWrapper",
    componentId: "sc-82d48e2a-0"
})(_templateObject(), function(param) {
    var isNormalUse = param.isNormalUse;
    return isNormalUse ? 0 : -1;
});
var PageOuterContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "CommonWrappers__PageOuterContainer",
    componentId: "sc-82d48e2a-1"
})(_templateObject1());
var MainVisualOuterContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "CommonWrappers__MainVisualOuterContainer",
    componentId: "sc-82d48e2a-2"
})(_templateObject2());
var MainVisualInnerContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "CommonWrappers__MainVisualInnerContainer",
    componentId: "sc-82d48e2a-3"
})(_templateObject3(), components_Layout__WEBPACK_IMPORTED_MODULE_2__/* .gridSystemPadding */ .DA, components_Home_BannerItems__WEBPACK_IMPORTED_MODULE_1__/* .txtAnimation */ .Xn, components_Home_BannerItems__WEBPACK_IMPORTED_MODULE_1__/* .txtAnimation */ .Xn);


/***/ }),

/***/ 2587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(5505);
/* harmony import */ var _locale_en__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4614);
/* harmony import */ var _locale_ko__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4804);
/* harmony import */ var assets_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1089);
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6627);
/* harmony import */ var _public_asset_bluedot_logo_c_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7302);
/* harmony import */ var components_Popup_index__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(763);
/* harmony import */ var hooks_useContactModal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2921);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var global_styles__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9059);
/* harmony import */ var dropdown__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7622);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 56px 0 72px;\n  ",
        "\n  .pri-pol-btn {\n    color: ",
        ";\n    padding: 0;\n    margin: 0 0 8px 0;\n  }\n  .top-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n  .logo-wrapper {\n    width: 230px;\n    height: 36px;\n  }\n  .top-left-wrapper {\n    display: flex;\n    align-items: center;\n  }\n  .footer-h5 {\n    margin-left: 70px;\n    color: ",
        ";\n  }\n  .top-right-wrapper {\n    display: flex;\n    align-items: center;\n    .sns-link {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 48px;\n      height: 48px;\n    }\n    .sns-link.notion {\n      margin-right: 16px;\n    }\n  }\n  .bottom-container {\n    color: ",
        ";\n    margin-top: 24px;\n    margin-left: 299px;\n    .footer-h5 {\n      display: none;\n    }\n  }\n  .location-wrapper {\n    display: flex;\n    align-items: flex-start;\n    margin-bottom: 24px;\n    svg {\n      margin-top: 4px;\n      margin-right: 11px;\n    }\n    .location-text {\n      margin-top: 2px;\n    }\n  }\n  .info-wrapper {\n    display: flex;\n    align-items: left;\n    margin-bottom: 40px;\n    white-space: nowrap;\n    flex-direction: column;\n    gap: 16px;\n\n    dl {\n      display: flex;\n    }\n    dt {\n      width: 40px;\n      margin-right: 8px;\n    }\n    dd {\n      /* safari text color 적용 이슈 */\n      -webkit-text-fill-color: ",
        ";\n      letter-spacing: -0.05rem;\n      margin-right: 16px;\n    }\n    .tel div {\n      display: flex;\n    }\n    dd + dd {\n      margin-left: 16px;\n    }\n    .s-dt {\n      color: ",
        ";\n      margin-right: 8px;\n    }\n\n    .s-dt-mt .s-dt-hr {\n      margin-left: 8px;\n    }\n\n    @media screen and (max-width: 1239px) {\n      .tel,\n      .fax {\n        margin-top: 2px;\n      }\n    }\n  }\n  .border {\n    flex-shrink: 0;\n    background: ",
        ";\n    display: block;\n    width: 1px;\n    height: 14px;\n    margin: 0 16px;\n  }\n\n  .copyright {\n    display: block;\n    color: ",
        ";\n  }\n  @media screen and (max-width: 1410px) {\n    .info-wrapper {\n      flex-direction: column;\n      align-items: flex-start;\n    }\n    .border {\n      display: none;\n    }\n  }\n  /*  */\n  @media screen and (max-width: 1239px) and (min-width: 905px) {\n    .bottom-container {\n      margin-left: 222px;\n    }\n    .logo-wrapper {\n      width: 153px;\n      height: 24px;\n    }\n  }\n\n  @media screen and (max-width: 904px) and (min-width: 600px) {\n    .footer-h5 {\n      display: none;\n    }\n    .bottom-container {\n      margin-left: 0;\n      .footer-h5 {\n        margin-left: 0;\n        margin-bottom: 24px;\n        display: block;\n      }\n    }\n    .logo-wrapper {\n      width: 153px;\n      height: 24px;\n    }\n    .tel {\n      flex-direction: column;\n    }\n    .sales-w {\n      margin-top: 8px;\n    }\n    .email-w dt {\n      margin-bottom: 8px;\n    }\n    .email-w,\n    .fax {\n      display: flex;\n      flex-direction: column;\n    }\n    .email-w dt,\n    .email-w dd + dd,\n    .tel div + div {\n      margin-left: 0;\n      margin-top: 8px;\n    }\n    .fax dt {\n      margin-bottom: 8px;\n    }\n  }\n  @media screen and (max-width: 599px) {\n    padding: 32px 0;\n    .top-container {\n      flex-wrap: wrap;\n    }\n    .top-left-wrapper,\n    .top-right-wrapper {\n      width: 100%;\n    }\n    .top-right-wrapper {\n      margin-top: 16px;\n    }\n    .tel {\n      flex-direction: column;\n    }\n    .sales-w {\n      margin-top: 8px;\n    }\n    .email-w dt {\n      margin-bottom: 8px;\n    }\n    .email-w,\n    .fax {\n      display: flex;\n      flex-direction: column;\n    }\n    .email-w dt,\n    .email-w dd + dd,\n    .tel div + div {\n      margin-left: 0;\n      margin-top: 8px;\n    }\n    .fax dt {\n      margin-bottom: 8px;\n    }\n  }\n  @media screen and (max-width: 600px) and (min-width: 361px) {\n    .footer-h5 {\n      display: none;\n    }\n    .bottom-container {\n      margin-left: 0;\n      .footer-h5 {\n        margin-left: 0;\n        margin-bottom: 24px;\n        display: block;\n      }\n    }\n    .logo-wrapper {\n      width: 153px;\n      height: 24px;\n    }\n  }\n  @media screen and (max-width: 360px) {\n    .footer-h5 {\n      display: none;\n    }\n    .bottom-container {\n      margin-left: 0;\n      .footer-h5 {\n        margin-left: 0;\n        margin-bottom: 24px;\n        display: block;\n      }\n    }\n    .top-container {\n      flex-wrap: wrap;\n      margin-top: 16px;\n      .top-left-wrapper,\n      .top-right-wrapper {\n        width: 100%;\n      }\n      .top-right-wrapper {\n        margin-top: 16px;\n      }\n    }\n    .logo-wrapper {\n      width: 153px;\n      height: 24px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var Footer = function() {
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    var t = locale === "en" ? _locale_en__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z : _locale_ko__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z;
    var ref = (0,hooks_useContactModal__WEBPACK_IMPORTED_MODULE_9__/* .usePrivatePolicyModal */ .p)(), handleClosePrivatePolicyModal = ref.handleClosePrivatePolicyModal, isPrivatePolicyModalOpen = ref.isPrivatePolicyModalOpen;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FooterContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "top-container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "top-left-wrapper",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "logo-wrapper",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                    src: _public_asset_bluedot_logo_c_svg__WEBPACK_IMPORTED_MODULE_7__/* ["default"].src */ .Z.src,
                                    alt: "bluedot inc."
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_11__.H5, {
                                className: "footer-h5",
                                as: "h2",
                                children: t.footer.companyName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "top-right-wrapper",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                href: "https://www.linkedin.com/company/bluedot-io",
                                className: "sns-link",
                                "aria-label": locale === "en" ? "Go to the Linked in page of bluedot inc." : "블루닷 링크드인 페이지로 이동하기.",
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(assets_icons__WEBPACK_IMPORTED_MODULE_5__/* .LinkedInIcon */ .nI, {
                                    color: global_styles__WEBPACK_IMPORTED_MODULE_11__/* .GRAY50 */ .mu
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                href: "https://www.notion.so/blue-dot/DeepField-SR-AI-based-Super-Resolution-Accelerated-by-FPGA-af4d1ab39f374db3a927c0cbd10a96c0",
                                className: "sns-link notion",
                                target: "_blank",
                                "aria-label": locale === "en" ? "Go to the notion page of bluedot inc." : "블루닷 노션 페이지로 이동하기.",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(assets_icons__WEBPACK_IMPORTED_MODULE_5__/* .NotionIcon */ .Uy, {
                                    color: global_styles__WEBPACK_IMPORTED_MODULE_11__/* .GRAY50 */ .mu
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(dropdown__WEBPACK_IMPORTED_MODULE_12__/* .Dropdown */ .L, {
                                disabled: false,
                                onChange: function() {},
                                changeStyle: true,
                                isPositionFixed: false,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(dropdown__WEBPACK_IMPORTED_MODULE_12__/* .Dropdown.Toggle */ .L.Toggle, {
                                        children: "Family Site"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(dropdown__WEBPACK_IMPORTED_MODULE_12__/* .Dropdown.OptionList */ .L.OptionList, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(dropdown__WEBPACK_IMPORTED_MODULE_12__/* .Dropdown.OptionItem */ .L.OptionItem, {
                                            role: "link",
                                            selected: false,
                                            disabled: false,
                                            value: "Kokoon",
                                            label: "Kokoon",
                                            tabIndex: -1,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                href: "https://www.kokoon.cloud",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                style: {
                                                    display: "block",
                                                    height: "100%"
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_11__/* .ButtonText2 */ .zg, {
                                                    children: "Kokoon"
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "bottom-container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_11__.H5, {
                        className: "footer-h5",
                        as: "h2",
                        children: t.footer.companyName
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "location-wrapper",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(assets_icons__WEBPACK_IMPORTED_MODULE_5__/* .LocationIcon */ ._t, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_11__/* .BodyTextM */ .OV, {
                                className: "location-text",
                                children: t.footer.address
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "info-wrapper",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("dl", {
                                className: "email-w",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_11__/* .BodyTextMStrong */ .X9, {
                                        as: "dt",
                                        children: "MAIL"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_11__/* .BodyTextM */ .OV, {
                                        as: "dd",
                                        children: "contact@blue-dot.io"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_11__/* .BodyTextM */ .OV, {
                                        as: "dd",
                                        children: "hr@blue-dot.io"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_11__/* .BodyTextM */ .OV, {
                                        as: "dd",
                                        children: "mkt@blue-dot.io"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("dl", {
                                className: "tel",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_11__/* .BodyTextMStrong */ .X9, {
                                        as: "dt",
                                        children: "TEL"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "sales-w",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_11__/* .BodyTextMStrong */ .X9, {
                                                className: "s-dt",
                                                children: "Sales"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_11__/* .BodyTextM */ .OV, {
                                                as: "dd",
                                                color: global_styles__WEBPACK_IMPORTED_MODULE_11__/* .GRAY50 */ .mu,
                                                children: "+82 2 6205 0814"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_11__/* .BodyTextMStrong */ .X9, {
                                                className: "s-dt s-dt-ir",
                                                children: "HR/IR"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_11__/* .BodyTextM */ .OV, {
                                                as: "dd",
                                                color: global_styles__WEBPACK_IMPORTED_MODULE_11__/* .GRAY50 */ .mu,
                                                children: "+82 2 6205 0812"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_11__/* .BodyTextMStrong */ .X9, {
                                                className: "s-dt",
                                                children: "Marketing"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_11__/* .BodyTextM */ .OV, {
                                                as: "dd",
                                                color: global_styles__WEBPACK_IMPORTED_MODULE_11__/* .GRAY50 */ .mu,
                                                children: "+82 2 6205 0811"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("dl", {
                                className: "fax",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_11__/* .BodyTextMStrong */ .X9, {
                                        as: "dt",
                                        children: "FAX"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_11__/* .BodyTextM */ .OV, {
                                        as: "dd",
                                        color: global_styles__WEBPACK_IMPORTED_MODULE_11__/* .GRAY50 */ .mu,
                                        children: "+82 2 6205 0815"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_10___default()), {
                        href: {
                            pathname: "/privacy-policy"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_11__/* .BodyTextMStrong */ .X9, {
                            as: "a",
                            className: "pri-pol-btn",
                            children: locale === "en" ? "Privacy policy" : "개인정보처리방침"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_11__/* .BodyTextM */ .OV, {
                        as: "small",
                        className: "copyright",
                        children: "\xa9 2022. BLUEDOT INC. all rights reserved."
                    })
                ]
            }),
            isPrivatePolicyModalOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Popup_index__WEBPACK_IMPORTED_MODULE_8__/* .PrivatePolicyPopup */ .VR, {
                handleClosePrivatePolicy: handleClosePrivatePolicyModal
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Footer);
var FooterContainer = styled_components__WEBPACK_IMPORTED_MODULE_13__/* ["default"].footer.withConfig */ .ZP.footer.withConfig({
    displayName: "Footer__FooterContainer",
    componentId: "sc-17ddcbb5-0"
})(_templateObject(), _Layout__WEBPACK_IMPORTED_MODULE_6__/* .gridSystemMargin */ .nR, global_styles__WEBPACK_IMPORTED_MODULE_11__/* .GRAY50 */ .mu, global_styles__WEBPACK_IMPORTED_MODULE_11__/* .GRAY10 */ .Ir, global_styles__WEBPACK_IMPORTED_MODULE_11__/* .GRAY50 */ .mu, global_styles__WEBPACK_IMPORTED_MODULE_11__/* .GRAY50 */ .mu, global_styles__WEBPACK_IMPORTED_MODULE_11__/* .GRAY60 */ .Ts, global_styles__WEBPACK_IMPORTED_MODULE_11__/* .GRAY80 */ .OD, global_styles__WEBPACK_IMPORTED_MODULE_11__/* .GRAY70 */ .Q2);


/***/ }),

/***/ 9220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Buttons; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var hooks_useContactModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2921);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5505);
/* harmony import */ var _locale_en__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4614);
/* harmony import */ var _locale_ko__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4804);
/* harmony import */ var assets_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1089);
/* harmony import */ var global_styles_MainButton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8920);
/* harmony import */ var global_styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9059);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 156px;\n  height: 48px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var SrButtons = function() {
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().locale;
    var t = locale === "en" ? _locale_en__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z : _locale_ko__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonsMainButton, {
                buttonType: "default",
                tag: "a",
                href: "https://www.kokoon.cloud",
                target: "_blank",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(assets_icons__WEBPACK_IMPORTED_MODULE_7__/* .GoToIcon */ .A5, {}),
                text: t.buttonText.tryDemo
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: t.lnb.srLink,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonsMainButton, {
                    buttonType: "default",
                    tag: "a",
                    text: t.buttonText.learnMore
                })
            })
        ]
    });
};
var VmafButtons = function() {
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().locale;
    var t = locale === "en" ? _locale_en__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z : _locale_ko__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z;
    var handleMoveToContactUsPage = (0,hooks_useContactModal__WEBPACK_IMPORTED_MODULE_2__/* .useContactModal */ .s)().handleMoveToContactUsPage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonsMainButton, {
                text: t.buttonText.contactUs,
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(assets_icons__WEBPACK_IMPORTED_MODULE_7__/* .ContactBtnIcon */ .iJ, {
                    width: "16",
                    height: "14"
                }),
                buttonType: "default",
                onClick: handleMoveToContactUsPage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: t.lnb.vmafLink,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonsMainButton, {
                    buttonType: "default",
                    tag: "a",
                    text: t.buttonText.learnMore,
                    icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(assets_icons__WEBPACK_IMPORTED_MODULE_7__/* .GoToIcon */ .A5, {})
                })
            })
        ]
    });
};
var PQOButtons = function() {
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().locale;
    var t = locale === "en" ? _locale_en__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z : _locale_ko__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z;
    var handleMoveToContactUsPage = (0,hooks_useContactModal__WEBPACK_IMPORTED_MODULE_2__/* .useContactModal */ .s)().handleMoveToContactUsPage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonsMainButton, {
                text: t.buttonText.contactUs,
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(assets_icons__WEBPACK_IMPORTED_MODULE_7__/* .ContactBtnIcon */ .iJ, {
                    width: "16",
                    height: "14"
                }),
                buttonType: "default",
                onClick: handleMoveToContactUsPage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: t.lnb.pqoLink,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonsMainButton, {
                    buttonType: "default",
                    tag: "a",
                    text: t.buttonText.learnMore,
                    icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(assets_icons__WEBPACK_IMPORTED_MODULE_7__/* .GoToIcon */ .A5, {})
                })
            })
        ]
    });
};
var AvifButtons = function() {
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().locale;
    var t = locale === "en" ? _locale_en__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z : _locale_ko__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z;
    var handleMoveToContactUsPage = (0,hooks_useContactModal__WEBPACK_IMPORTED_MODULE_2__/* .useContactModal */ .s)().handleMoveToContactUsPage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonsMainButton, {
                text: t.buttonText.contactUs,
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(assets_icons__WEBPACK_IMPORTED_MODULE_7__/* .ContactBtnIcon */ .iJ, {
                    width: "16",
                    height: "14"
                }),
                buttonType: "default",
                onClick: handleMoveToContactUsPage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: t.lnb.avifLink,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonsMainButton, {
                    buttonType: "default",
                    tag: "a",
                    icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(assets_icons__WEBPACK_IMPORTED_MODULE_7__/* .NormalArrowIcon */ .LS, {
                        color: global_styles__WEBPACK_IMPORTED_MODULE_9__.BB
                    }),
                    text: t.buttonText.learnMore
                })
            })
        ]
    });
};
var Av1Buttons = function() {
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().locale;
    var t = locale === "en" ? _locale_en__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z : _locale_ko__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z;
    var handleMoveToContactUsPage = (0,hooks_useContactModal__WEBPACK_IMPORTED_MODULE_2__/* .useContactModal */ .s)().handleMoveToContactUsPage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonsMainButton, {
                text: t.buttonText.contactUs,
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(assets_icons__WEBPACK_IMPORTED_MODULE_7__/* .ContactBtnIcon */ .iJ, {
                    width: "16",
                    height: "14"
                }),
                buttonType: "default",
                onClick: handleMoveToContactUsPage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: t.lnb.av1Link,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonsMainButton, {
                    buttonType: "default",
                    tag: "a",
                    icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(assets_icons__WEBPACK_IMPORTED_MODULE_7__/* .GoToIcon */ .A5, {}),
                    text: t.buttonText.learnMore
                })
            })
        ]
    });
};
var Buttons = [
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SrButtons, {}, "sr"),
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(VmafButtons, {}, "vmaf"),
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PQOButtons, {}, "pq"),
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AvifButtons, {}, "avif"),
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Av1Buttons, {}, "av1"), 
];
// GNB menu btn=Default
// GNB menu btn=Hover & Active
// GNB menu btn=default-c
// GNB menu btn=Hover & Active- c
var ButtonsMainButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(global_styles_MainButton__WEBPACK_IMPORTED_MODULE_8__/* .MainButton */ .c).withConfig({
    displayName: "ProductButton__ButtonsMainButton",
    componentId: "sc-9e4334c-0"
})(_templateObject());


/***/ }),

/***/ 6402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dR": function() { return /* reexport */ BasicDropdown; },
  "Fk": function() { return /* reexport */ BasicInput; },
  "ok": function() { return /* reexport */ BypassBlock; },
  "AI": function() { return /* reexport */ ContactButton; },
  "x_": function() { return /* reexport */ CustomizedCheckbox; },
  "Lt": function() { return /* reexport */ Dropdown; },
  "xE": function() { return /* reexport */ ScrollButton; },
  "Tt": function() { return /* reexport */ TechBox; }
});

// UNUSED EXPORTS: BasicLNB, BasicPopup, Buttons, DropDownContainer, DropdownModal, OptionBtnText, ScrollButtonContainer

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(2228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../packages/global-styles/index.ts
var global_styles = __webpack_require__(9059);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ./components/Global/BasicCheckbox/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n0% {\n  opacity:0;\n  transform:  rotate(480deg);\n}\n100% {\n  \n  opacity:1;\n  transform:  rotate(0);\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  color: ",
        ";\n  font-size: 1.3rem;\n  line-height: 2rem;\n  font-weight: 500;\n  label {\n    position: relative;\n    flex-shrink: 0;\n    cursor: ",
        ";\n  }\n\n  input[type='checkbox'] {\n    position: absolute;\n  }\n  input[type='checkbox'] + label {\n    position: relative;\n    display: flex;\n    align-items: center;\n  }\n\n  input[type='checkbox'] + label::before {\n    content: '';\n    position: relative;\n    display: inline-block;\n    margin-right: 10px;\n    width: 20px;\n    height: 20px;\n    background: transparent;\n    border: 2px solid #525f6f;\n    border-radius: 50%;\n    transition: 0.15s all ease-in-out;\n    flex-shrink: 0;\n  }\n\n  input[type='checkbox']:checked + label::before {\n    background: #00438e;\n    border: 2px solid #00438e;\n    color: #fff;\n  }\n\n  input[type='checkbox']:focus-visible + label::before {\n    outline: #0e80ff solid 2px;\n    box-shadow: 0 0px 8px #0e80ff;\n  }\n\n  input[type='checkbox']:focus-visible + label::after {\n    top: ",
        ";\n    left: ",
        ";\n  }\n\n  input[type='checkbox']:active + label::before {\n    outline: none;\n    box-shadow: none;\n  }\n\n  input[type='checkbox']:disabled + label::before {\n    background: transparent;\n    border: 2px solid #bec6cf;\n  }\n\n  input[type='checkbox']:checked + label::after {\n    content: '';\n    animation: ",
        " 0.2s ease-in-out;\n    position: absolute;\n    top: ",
        ";\n    left: ",
        ";\n    border-left: 2px solid #fff;\n    border-bottom: 2px solid #fff;\n    width: 11px;\n    height: 6px;\n    transform: rotate(-45deg);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var CustomizedCheckbox = function(param) {
    var labelComponent = param.labelComponent, className = param.className, isChecked = param.isChecked, onClick = param.onClick, htmlId = param.htmlId, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, onKeyDown = param.onKeyDown, name = param.name, top = param.top, left = param.left;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomizedCheckboxContainer, {
        className: className,
        top: top,
        left: left,
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                "aria-checked": isChecked,
                type: "checkbox",
                name: name,
                id: htmlId,
                checked: isChecked,
                onKeyDown: function(e) {
                    e.stopPropagation();
                    if (e.code === "Enter" || e.code === "Space") onKeyDown();
                },
                className: "a11y-hidden",
                disabled: disabled,
                "aria-disabled": disabled,
                readOnly: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                onClick: onClick,
                onKeyDown: onKeyDown,
                htmlFor: htmlId,
                style: {
                    color: disabled ? "#bec6cf" : "unset"
                },
                children: labelComponent
            })
        ]
    });
};
var spinUp = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var CustomizedCheckboxContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BasicCheckbox__CustomizedCheckboxContainer",
    componentId: "sc-2b38b9f5-0"
})(_templateObject1(), global_styles/* GRAY30 */.zm, function(param) {
    var disabled = param.disabled;
    return disabled ? "not-allowed" : "pointer";
}, function(param) {
    var top = param.top;
    return top || "11px";
}, function(param) {
    var left = param.left;
    return left || "12px";
}, spinUp, function(param) {
    var top = param.top;
    return top || "6px";
}, function(param) {
    var left = param.left;
    return left || "4px";
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var src_sliced_to_array = __webpack_require__(6383);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/assets/icons.tsx
var icons = __webpack_require__(1089);
;// CONCATENATED MODULE: ./hooks/useCloseModalClickOutside.ts

var useCloseModalClickOutside_useCloseModalClickOutside = function(node) {
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    (0,react.useEffect)(function() {
        var closeModal = function(e) {
            var target = e.target;
            if (node.current && !node.current.contains(target)) setIsOpen(false);
        };
        var closeModalESC = function(e) {
            if (e.code === "Escape") setIsOpen(false);
        };
        if (isOpen) {
            window.addEventListener("click", closeModal);
            window.addEventListener("keydown", closeModalESC);
        }
        return function() {
            window.removeEventListener("click", closeModal);
            window.removeEventListener("keydown", closeModalESC);
        };
    }, [
        isOpen,
        node
    ]);
    return [
        isOpen,
        setIsOpen
    ];
};

;// CONCATENATED MODULE: ./components/Common/MainDropdown.tsx


function MainDropdown_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n  0% {\n    opacity: 0;\n    transform: translateY(-10%);\n  } 100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"
    ]);
    MainDropdown_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MainDropdown_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin-left: 16px;\n  white-space: nowrap;\n  .select {\n    height: 36px;\n    padding: 8px 16px;\n    border-radius: 24px;\n    border: 1px solid ",
        ";\n    color: ",
        ";\n    display: flex;\n    align-items: center;\n    svg {\n      margin-left: 0.8rem;\n    }\n  }\n"
    ]);
    MainDropdown_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: calc(100% + 6px);\n  width: 100%;\n  background: #ffffff;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 16px;\n  padding: 16px 0;\n  animation: ",
        " 0.1s ease-in-out;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 500;\n  width: 100%;\n  display: block;\n  text-align: center;\n  padding: 8px 0;\n  color: ",
        ";\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var MainDropdown = function(param) {
    var itemTag = param.itemTag, dropdownItems = param.dropdownItems;
    var modalRef = useRef();
    var ref = _sliced_to_array(useCloseModalClickOutside(modalRef), 2), isDropdownOpen = ref[0], setIsDropdownOpen = ref[1];
    var handleToggleOpen = function() {
        return setIsDropdownOpen(function(isDropdownOpen) {
            return !isDropdownOpen;
        });
    };
    return /*#__PURE__*/ _jsxs(MainDropdownContainer, {
        ref: modalRef,
        children: [
            /*#__PURE__*/ _jsxs("button", {
                className: "select",
                onClick: handleToggleOpen,
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        children: "family site"
                    }),
                    /*#__PURE__*/ _jsx(DownArrowIcon, {
                        color: BB
                    })
                ]
            }),
            isDropdownOpen && /*#__PURE__*/ _jsx(MainDropdownModalContainer, {
                children: dropdownItems.map(function(item) {
                    return /*#__PURE__*/ _jsx("li", {
                        children: /*#__PURE__*/ _jsx(ItemSelect, {
                            className: "item-select-btn",
                            onClick: itemTag === "button" ? function() {
                                item.onClick();
                                setIsDropdownOpen(false);
                            } : function() {
                                setIsDropdownOpen(false);
                            },
                            href: itemTag === "a" ? item.href : undefined,
                            as: itemTag || "button",
                            target: itemTag === "a" ? "_blank" : undefined,
                            children: /*#__PURE__*/ _jsx(ButtonText2, {
                                children: item.label
                            })
                        })
                    }, item.value);
                })
            })
        ]
    });
};
/* harmony default export */ var Common_MainDropdown = ((/* unused pure expression or super */ null && (MainDropdown)));
var openAnim = (0,styled_components_browser_esm/* keyframes */.F4)(MainDropdown_templateObject());
var MainDropdownContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MainDropdown__MainDropdownContainer",
    componentId: "sc-274a9331-0"
})(MainDropdown_templateObject1(), global_styles/* GRAY80 */.OD, global_styles.BB);
var MainDropdownModalContainer = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "MainDropdown__MainDropdownModalContainer",
    componentId: "sc-274a9331-1"
})(_templateObject2(), openAnim);
var ItemSelect = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "MainDropdown__ItemSelect",
    componentId: "sc-274a9331-2"
})(_templateObject3(), global_styles/* GRAY70 */.Q2, global_styles.BB);

;// CONCATENATED MODULE: ./components/Global/BasicDropdown.tsx


function BasicDropdown_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n              transform: rotate(180deg);\n            "
    ]);
    BasicDropdown_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BasicDropdown_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n              transform: rotate(0deg);\n            "
    ]);
    BasicDropdown_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BasicDropdown_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: ",
        ";\n\n  button {\n    width: ",
        ";\n    padding: 10px 16px;\n    text-align: left;\n    border-radius: 4px;\n    background: #fff;\n    color: ",
        ";\n  }\n\n  .option-list {\n    padding: 8px 0;\n    overflow: hidden;\n    border-radius: 4px;\n    background: #fff;\n    position: absolute;\n    left: 0;\n    top: 100%;\n    width: ",
        ";\n    border: 1px solid ",
        ";\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n    animation: ",
        " 0.1s ease-in-out;\n  }\n\n  .dd-o-btn {\n    background: transparent;\n    color: ",
        ";\n  }\n  .dd-o-btn:hover {\n    color: ",
        ";\n    background: ",
        ";\n  }\n\n  .selected {\n    .dd-o-btn {\n      color: ",
        ";\n    }\n  }\n\n  .dd-tg-btn {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border: 1px solid ",
        ";\n    color: ",
        ";\n    svg {\n      ",
        ";\n    }\n  }\n"
    ]);
    BasicDropdown_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var BasicDropdown = function(param) {
    var value = param.value, options = param.options, onClickOptions = param.onClickOptions, width = param.width, height = param.height;
    var modalRef = (0,react.useRef)();
    var ref = (0,src_sliced_to_array/* default */.Z)(useCloseModalClickOutside_useCloseModalClickOutside(modalRef), 2), isOpen = ref[0], setIsOpen = ref[1];
    var handleToggleOpen = function() {
        return setIsOpen(function(isOpen) {
            return !isOpen;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BasicDropDownContainer, {
        width: width,
        height: height,
        isOpen: isOpen,
        onClick: function(e) {
            e.preventDefault();
            handleToggleOpen();
        },
        ref: modalRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "dd-tg-btn",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextM */.OV, {
                        children: value
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DownArrowIcon */.G6, {
                        color: global_styles/* GRAY50 */.mu
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "option-list",
                children: options.map(function(option) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        onClick: function() {
                            return onClickOptions(option);
                        },
                        className: value === option ? "selected option" : "option",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "dd-o-btn",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextM */.OV, {
                                children: option
                            })
                        })
                    }, option);
                })
            })
        ]
    });
};
/* harmony default export */ var Global_BasicDropdown = ((/* unused pure expression or super */ null && (BasicDropdown)));
var BasicDropDownContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BasicDropdown__BasicDropDownContainer",
    componentId: "sc-dd1944b1-0"
})(BasicDropdown_templateObject2(), function(param) {
    var width = param.width;
    return width || "fit-content";
}, function(param) {
    var width = param.width;
    return width || "100%";
}, global_styles/* GRAY50 */.mu, function(param) {
    var width = param.width;
    return width || "100%";
}, global_styles/* GRAY80 */.OD, openAnim, global_styles/* GRAY50 */.mu, global_styles.BB, global_styles/* GRAYBG */.lm, global_styles.BB, global_styles/* GRAY50 */.mu, global_styles.BB, function(param) {
    var isOpen = param.isOpen;
    return isOpen ? (0,styled_components_browser_esm/* css */.iv)(BasicDropdown_templateObject()) : (0,styled_components_browser_esm/* css */.iv)(BasicDropdown_templateObject1());
});

;// CONCATENATED MODULE: ./components/Global/BasicInput.tsx

function BasicInput_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      cursor: not-allowed;\n      background: ",
        ";\n      color: ",
        ";\n    "
    ]);
    BasicInput_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BasicInput_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #ffffff;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  padding: 10px 16px;\n  color: ",
        ";\n  font-family: 'Noto Sans KR', sans-serif;\n  line-height: 175%;\n  font-size: 16px;\n  letter-spacing: -1%;\n  font-weight: 400;\n  @media screen and (max-width: 599px) {\n    font-size: 15px;\n  }\n  ::placeholder {\n    font-family: 'Noto Sans KR', sans-serif;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 28px;\n    letter-spacing: -0.01em;\n    color: ",
        ";\n  }\n  ",
        ";\n"
    ]);
    BasicInput_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var BasicInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    displayName: "BasicInput",
    componentId: "sc-d0ab9616-0"
})(BasicInput_templateObject1(), global_styles/* GRAY80 */.OD, global_styles/* GRAY50 */.mu, global_styles/* GRAY70 */.Q2, function(param) {
    var _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled;
    return disabled && (0,styled_components_browser_esm/* css */.iv)(BasicInput_templateObject(), global_styles/* GRAYBG */.lm, global_styles/* GRAY80 */.OD);
});

// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(9097);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./components/Global/BasicLNB.tsx

function BasicLNB_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          display: ",
        ";\n          position: absolute;\n          width: fit-content;\n          white-space: nowrap;\n          top: calc(100% + 6px);\n          left: 50%;\n          transform: translate3d(-50%, 0, 0);\n          padding: 16px;\n          background: rgba(0, 0, 0, 0.75);\n          box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n          border-radius: 16px;\n          justify-content: center;\n          align-items: center;\n        "
    ]);
    BasicLNB_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BasicLNB_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          transition: max-height 0.3s;\n          max-height: ",
        ";\n          opacity: ",
        ";\n          padding-left: 32px;\n          position: relative;\n          z-index: 9999;\n\n          .item-anchor {\n            justify-content: flex-start;\n            font-family: 'Noto Sans KR', sans-serif;\n            opacity: ",
        ";\n            font-size: 2.8rem;\n            line-height: 175%;\n            letter-spacing: -0.01rem;\n            height: 36px;\n\n            .btn-text2 {\n              @media screen and (max-width: 1239px) and (min-width: 905px) {\n                font-size: 22px;\n              }\n              @media screen and (max-width: 904px) and (min-width: 600px) {\n                font-size: 18px;\n              }\n              @media screen and (max-width: 599px) {\n                font-size: 17px;\n              }\n            }\n          }\n        "
    ]);
    BasicLNB_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BasicLNB_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  transition: 0.3s padding cubic-bezier(0.1, 0.57, 0.1, 1);\n  min-width: 144px;\n\n  .item-anchor {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: ",
        ";\n    opacity: ",
        ";\n    height: ",
        ";\n    transform: ",
        ";\n    transition: 0.3s all cubic-bezier(0.1, 0.57, 0.1, 1);\n  }\n  .item-anchor:hover,\n  .item-anchor.selected {\n    color: ",
        ";\n  }\n  ",
        ";\n"
    ]);
    BasicLNB_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var BasicLNB = function(param) {
    var items = param.items, isMobileSize = param.isMobileSize, isOpen = param.isOpen, locale = param.locale;
    var asPath = useRouter().asPath;
    return /*#__PURE__*/ _jsx(BasicLNBContainer, {
        isMobileSize: isMobileSize,
        isOpen: isOpen,
        children: items.map(function(item) {
            return /*#__PURE__*/ _jsx(Link, {
                href: item.link,
                locale: locale,
                scroll: true,
                children: /*#__PURE__*/ _jsx("a", {
                    tabIndex: isOpen ? 0 : -1,
                    className: asPath.toLowerCase().includes(item.label.split(" : ")[0].toLowerCase()) ? "item-anchor selected" : "item-anchor",
                    children: /*#__PURE__*/ _jsx(ButtonText2, {
                        className: "btn-text2",
                        children: item.label
                    })
                })
            }, item.label);
        })
    });
};
var BasicLNBContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BasicLNB__BasicLNBContainer",
    componentId: "sc-8384e149-0"
})(BasicLNB_templateObject2(), global_styles/* GRAY70 */.Q2, function(param) {
    var isMobileSize = param.isMobileSize, isOpen = param.isOpen;
    return isOpen && isMobileSize || !isMobileSize ? 1 : 0;
}, function(param) {
    var isMobileSize = param.isMobileSize, isOpen = param.isOpen;
    return isOpen && isMobileSize || !isMobileSize ? "36px" : 0;
}, function(param) {
    var isMobileSize = param.isMobileSize, isOpen = param.isOpen;
    return isOpen && isMobileSize || !isMobileSize ? "scaleY(1)" : "scaleY(0)";
}, global_styles/* GRAYBG */.lm, function(param) {
    var isMobileSize = param.isMobileSize, isOpen = param.isOpen;
    return !isMobileSize ? (0,styled_components_browser_esm/* css */.iv)(BasicLNB_templateObject(), isOpen ? "unset" : "none") : (0,styled_components_browser_esm/* css */.iv)(BasicLNB_templateObject1(), isOpen ? "188px" : "0", isOpen ? 1 : 0, isOpen ? 1 : 0);
});

// EXTERNAL MODULE: ../../packages/global-styles/MainButton.tsx
var global_styles_MainButton = __webpack_require__(8920);
;// CONCATENATED MODULE: ./components/Global/BasicPopup.tsx

function BasicPopup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  background: #ffffff;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 16px;\n  .header {\n    width: 100%;\n    height: 48px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    color: ",
        ";\n  }\n  .close-btn {\n    position: absolute;\n    right: 15px;\n  }\n  .basic-popup-body {\n    color: ",
        ";\n    padding: 16px 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n  }\n"
    ]);
    BasicPopup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var BasicPopup = function(param) {
    var width = param.width, headerText = param.headerText, bodyComponent = param.bodyComponent, bodyText = param.bodyText, buttonText = param.buttonText, buttonFn = param.buttonFn, closeBtnFn = param.closeBtnFn;
    var locale = useRouter().locale;
    return /*#__PURE__*/ _jsxs(BasicPopupContainer, {
        width: width,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "header",
                children: [
                    /*#__PURE__*/ _jsx(BodyTextLStrong, {
                        children: headerText
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        className: "close-btn",
                        onClick: closeBtnFn,
                        children: /*#__PURE__*/ _jsx(CloseIcon, {
                            color: GRAY50
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "body",
                children: bodyComponent ? /*#__PURE__*/ _jsx(_Fragment, {
                    children: bodyComponent
                }) : /*#__PURE__*/ _jsxs("div", {
                    className: "basic-popup-body",
                    children: [
                        /*#__PURE__*/ _jsx(BodyTextL, {
                            children: bodyText || ""
                        }),
                        /*#__PURE__*/ _jsx(MainButton, {
                            buttonType: "default",
                            text: buttonText || locale === "en" ? "OK" : "확인",
                            onClick: function() {
                                if (buttonFn) buttonFn();
                            },
                            injectInlineStyles: {
                                width: "156px",
                                height: "48px",
                                marginTop: "16px"
                            }
                        })
                    ]
                })
            })
        ]
    });
};
var BasicPopupContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BasicPopup__BasicPopupContainer",
    componentId: "sc-87b78408-0"
})(BasicPopup_templateObject(), function(param) {
    var width = param.width;
    return width || "328px";
}, global_styles.BB, global_styles/* GRAY30 */.zm);

;// CONCATENATED MODULE: ./components/Global/BypassBlock.tsx




var BypassBlock = function(param) {
    var contentSectionId = param.contentSectionId;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: "bypass-blocks-wrapper",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "bypass-block",
                    href: "#contact-popup-btn",
                    children: locale === "en" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextS */.Ei, {
                        children: "Go to Contact"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextS */.Ei, {
                        children: "문의로 바로가기"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "bypass-block",
                    href: "".concat(contentSectionId),
                    children: locale === "en" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextS */.Ei, {
                        children: "Go to Main Contents"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextS */.Ei, {
                        children: "본문으로 바로가기"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Global/ContactButton.tsx

function ContactButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 60px;\n  height: 60px;\n  background: #ffffff;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 30px;\n  color: ",
        ";\n  font-size: 16px;\n  font-weight: 500;\n  font-family: 'Noto Sans KR', sans-serif;\n  white-space: nowrap;\n  transition: all 0.3s;\n\n  .hover-text {\n    display: none;\n  }\n\n  @media (hover: hover) {\n    &:hover {\n      width: fit-content;\n      padding: 0px 32px;\n      svg {\n        margin-left: 9px;\n      }\n      .hover-text {\n        display: unset;\n      }\n    }\n  }\n\n  @media screen and (max-width: 904px) and (min-width: 600px) {\n    width: 45px;\n    height: 45px;\n  }\n  @media screen and (max-width: 599px) {\n    width: 45px;\n    height: 45px;\n  }\n"
    ]);
    ContactButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ContactButton = function(param) {
    var onClick = param.onClick;
    var locale = (0,router.useRouter)().locale;
    var text = locale === "en" ? "Contact" : "문의 연락";
    var ariaLabel = locale === "en" ? "Move to contact us page" : "문의하기 페이지로 이동";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactButtonContainer, {
        onClick: onClick,
        id: "contact-popup-btn",
        "aria-haspopup": true,
        "aria-label": ariaLabel,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "hover-text",
                children: text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ContactBtnIcon */.iJ, {})
        ]
    });
};
var ContactButtonContainer = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "ContactButton__ContactButtonContainer",
    componentId: "sc-a58a2fbe-0"
})(ContactButton_templateObject(), global_styles.BB);

;// CONCATENATED MODULE: ./components/Global/Dropdown.tsx


function Dropdown_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  .select {\n    height: 36px;\n    background: transparent;\n    padding: 8px 16px;\n    border: ",
        ";\n    border-radius: 9999px;\n    display: flex;\n    align-items: center;\n    svg {\n      margin-left: 0.8rem;\n    }\n  }\n"
    ]);
    Dropdown_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Dropdown_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 45px;\n  color: ",
        ";\n"
    ]);
    Dropdown_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Dropdown_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    Dropdown_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Dropdown_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: calc(100% + 6px);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 0px;\n  width: 100px;\n  animation: ",
        " 0.1s ease-in-out;\n  background: #ffffff;\n  box-shadow: 0px 4px 8px 2px rgba(0, 0, 0, 0.12);\n  li {\n    width: 100%;\n    height: 36px;\n    button {\n      background: transparent;\n      width: 100%;\n      height: 100%;\n    }\n  }\n  .selected {\n    color: ",
        " !important;\n    border-bottom: 1px solid ",
        ";\n  }\n  @media screen and (max-width: 904px) {\n    width: 100px;\n  }\n"
    ]);
    Dropdown_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








var Dropdown = function(param) {
    var isOpen = param.isOpen, isScrolled = param.isScrolled, handleToggleMenu = param.handleToggleMenu;
    var modalRef = (0,react.useRef)();
    var ref = (0,src_sliced_to_array/* default */.Z)(useCloseModalClickOutside_useCloseModalClickOutside(modalRef), 2), isDropdownOpen = ref[0], setIsDropdownOpen = ref[1];
    var ref1 = (0,router.useRouter)(), locale = ref1.locale, push = ref1.push, pathname = ref1.pathname, replace = ref1.replace, asPath = ref1.asPath;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropDownContainer, {
        isScrolled: isScrolled,
        isOpen: isOpen,
        ref: modalRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "select",
                "aria-label": isOpen ? "close the language change pop up" : "open the language change pop up",
                "aria-expanded": isOpen,
                "aria-controls": "language-select-modal",
                onClick: function() {
                    setIsDropdownOpen(function(isDropdownOpen) {
                        return !isDropdownOpen;
                    });
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageBtnText, {
                        isScrolled: isScrolled,
                        isOpen: isOpen,
                        children: locale === "en" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "ENG"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "한국어"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DownArrowIcon */.G6, {
                        color: isOpen ? "#fff" : isScrolled ? global_styles.BB : "#fff",
                        size: "16"
                    })
                ]
            }),
            isDropdownOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownModal, {
                id: "language-select-modal",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            "aria-label": "choose English as display language.",
                            onClick: function() {
                                replace(pathname, asPath, {
                                    locale: "en",
                                    scroll: false
                                });
                                setIsDropdownOpen(false);
                                if (isOpen) handleToggleMenu();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionBtnText, {
                                className: locale === "en" ? "selected" : "",
                                children: "ENG"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            "aria-label": "choose Korean as display language.",
                            onClick: function() {
                                push(pathname, asPath, {
                                    locale: "ko",
                                    scroll: false
                                });
                                setIsDropdownOpen(false);
                                if (isOpen) handleToggleMenu();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionBtnText, {
                                className: locale === "ko" ? "selected" : "",
                                children: "한국어"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var DropDownContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Dropdown__DropDownContainer",
    componentId: "sc-cb05134c-0"
})(Dropdown_templateObject(), function(param) {
    var isScrolled = param.isScrolled;
    return isScrolled ? "1px solid ".concat(global_styles/* GRAY80 */.OD) : "1px solid #fff";
});
var LanguageBtnText = (0,styled_components_browser_esm/* default */.ZP)(global_styles/* ButtonText2 */.zg).withConfig({
    displayName: "Dropdown__LanguageBtnText",
    componentId: "sc-cb05134c-1"
})(Dropdown_templateObject1(), function(param) {
    var isScrolled = param.isScrolled;
    return isScrolled ? "#888" : "#fff";
});
var OptionBtnText = (0,styled_components_browser_esm/* default */.ZP)(global_styles/* ButtonText2 */.zg).withConfig({
    displayName: "Dropdown__OptionBtnText",
    componentId: "sc-cb05134c-2"
})(Dropdown_templateObject2(), global_styles/* GRAY70 */.Q2);
var DropdownModal = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "Dropdown__DropdownModal",
    componentId: "sc-cb05134c-3"
})(Dropdown_templateObject3(), openAnim, global_styles.BB, global_styles.BB);

// EXTERNAL MODULE: ./components/Global/ProductButton.tsx
var ProductButton = __webpack_require__(9220);
;// CONCATENATED MODULE: ./components/Global/ScrollButton.tsx

function ScrollButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        transform: rotate(180deg);\n      "
    ]);
    ScrollButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ScrollButton_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 60px;\n  height: 60px;\n  margin-bottom: 16px;\n  background: ",
        ";\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  transition: 0.3s all;\n  &:hover {\n    background: ",
        ";\n  }\n\n  @media screen and (max-width: 904px) and (min-width: 600px) {\n    width: 45px;\n    height: 45px;\n  }\n  @media screen and (max-width: 599px) {\n    width: 45px;\n    height: 45px;\n  }\n\n  svg {\n    transition: 0.2s all ease-in-out;\n    ",
        ";\n  }\n"
    ]);
    ScrollButton_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var ScrollButton = function(param) {
    var isOpenContact = param.isOpenContact, isScrolled = param.isScrolled, onClick = param.onClick;
    var locale = (0,router.useRouter)().locale;
    var ariaLabels = locale === "en" ? [
        "scroll to the top",
        "scroll to bottom by window height"
    ] : [
        "최상단으로 스크롤 올리기",
        "인터넷 창 높이만큼 스크롤 내리기"
    ];
    if (isOpenContact) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollButtonContainer, {
        "aria-label": isScrolled ? ariaLabels[0] : ariaLabels[1],
        className: "scroll-btn",
        isScrolled: isScrolled,
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ScrollBtnIcon */.lq, {})
    });
};
var ScrollButtonContainer = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "ScrollButton__ScrollButtonContainer",
    componentId: "sc-33ec4da6-0"
})(ScrollButton_templateObject1(), global_styles.BB, global_styles.BB, function(param) {
    var isScrolled = param.isScrolled;
    return !isScrolled && (0,styled_components_browser_esm/* css */.iv)(ScrollButton_templateObject());
});

;// CONCATENATED MODULE: ./public/asset/02-section1/content1/ai-model/ai-model@2x.png
/* harmony default export */ var ai_model_2x = ({"src":"/_next/static/media/ai-model@2x.24215fd4.png","height":448,"width":448,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAADFBMVEUAN3QAM3AAMnEAM3CAPPBNAAAABHRSTlMBEyAx0RU4TgAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAACtJREFUeJxFy8ENADAMwkDb2X/nKn20vE4g4KWpBGeROKUCljstb3H1r3AACVkANZMUEL8AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/asset/02-section1/content1/acceleration/acceleration@2x.png
/* harmony default export */ var acceleration_2x = ({"src":"/_next/static/media/acceleration@2x.f8e91bb3.png","height":448,"width":448,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAMFBMVEVMaXEAFl33+fsILWoLPHhffaQUPHgAGl3y9vj5/Pzh8PCnu9Czw9Xa4+xri69NcJytV+U9AAAAEHRSTlMASYkzInQTac5hEY/NHMCeRxlKYwAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAC1JREFUeJxjYEAAFkZWJjCDmZ2PAyLExsjPwQtmMLMycYGleCBqWBi5OZH0AgAWCQCjnyTQPgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/asset/02-section1/content1/codec/codec@2x.png
/* harmony default export */ var codec_2x = ({"src":"/_next/static/media/codec@2x.5bb89d95.png","height":448,"width":448,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAElBMVEUANoEAN3QANHAANHIANnMAM3IxL5fZAAAABnRSTlMCC2YnRijkZy9IAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAJUlEQVR4nGXGsQ0AMAzDMKmp/3+5gKcA5UT4WeCUeEs8tTNJMj4KRABtCZeFdQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/asset/02-section1/content1/silicon-IP/silicon-IP@2x.png
/* harmony default export */ var silicon_IP_2x = ({"src":"/_next/static/media/silicon-IP@2x.55f02ea5.png","height":448,"width":448,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJFBMVEVMaXEHOnECNXAAKmoPQXgANm0DL2wENnJujK8sV4oaSX9UeJ+GvEMgAAAADHRSTlMAHSMJMRVRlYOgzKneXsvhAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAM0lEQVR4nE2KNxIAMRCDJDY4/f+/N+fKNBQgPZiryHmGpaDXHinh6saItF3J34C4e5WkDxPHAJT9WePNAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./locale/ko.ts
var ko = __webpack_require__(4804);
// EXTERNAL MODULE: ./locale/en.ts
var en = __webpack_require__(4614);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(6577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/Common/CommonWrappers.tsx
var CommonWrappers = __webpack_require__(5564);
;// CONCATENATED MODULE: ./components/Global/TechBox.tsx

function TechBox_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    opacity: 0;\n  } 100% {\n    opacity: 1;\n  }\n"
    ]);
    TechBox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TechBox_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 14px;\n  margin-top: 8px;\n  line-height: 24px;\n"
    ]);
    TechBox_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TechBox_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  line-height: 24px;\n"
    ]);
    TechBox_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TechBox_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  scroll-snap-align: center;\n  @media screen and (max-width: 904px) {\n    &:first-child {\n      margin-left: 50vw;\n    }\n    &:last-child {\n      margin-right: 50vw;\n      margin-right: 100px;\n      position: relative;\n    }\n  }\n  @media screen and (max-width: 1348px) {\n    &:last-child::after {\n      content: '';\n      display: block;\n      height: 1px;\n      width: 50vw;\n      right: -150%;\n      position: absolute;\n    }\n  }\n  cursor: pointer;\n  flex-shrink: 0;\n  flex-direction: column;\n  width: 300px;\n  height: 384px;\n  border-radius: 8px;\n  background: #fff;\n  transition: all 0.9s cubic-bezier(0.1, 0.57, 0.1, 1);\n  margin-top: 16px;\n  position: relative;\n  @media screen and (min-width: 1920px) {\n    width: 288px;\n  }\n  .top-color {\n    height: 8px;\n    display: block;\n    background: #2564ce;\n    border-radius: 8px 8px 0 0;\n  }\n  .front {\n    display: block;\n    transition: 0.3s all;\n  }\n  .rear {\n    transition: 0.3s all;\n    display: none;\n  }\n  .tech-title {\n    font-family: 'Kanit', sans-serif;\n    font-size: 30px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    line-height: 39px;\n    text-align: center;\n    color: ",
        ";\n    height: 80px;\n  }\n  .content-wrapper {\n    padding: 32px 16px;\n  }\n  .front .tech-title {\n    margin-top: 32px;\n  }\n  .rear .tech-title {\n    height: 60px;\n    margin-bottom: 8px;\n  }\n  .more-btn-wrapper {\n    width: 100%;\n    height: fit-content;\n    bottom: 32px;\n    left: 0;\n    position: absolute;\n    display: flex;\n    justify-content: center;\n  }\n\n  &:hover > .content-wrapper,\n  &:focus-visible > .content-wrapper {\n    animation: ",
        " 1.2s cubic-bezier(0.1, 0.57, 0.1, 1);\n  }\n  &:hover,\n  &:focus-visible {\n    filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.1));\n    transform: translate3d(0, -16px, 0);\n    .front {\n      display: none;\n    }\n    .rear {\n      display: block;\n    }\n  }\n"
    ]);
    TechBox_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}












var techInfoList = [
    {
        techTitle: "AI model",
        imgSrc: ai_model_2x.src
    },
    {
        techTitle: "Video & Image Codec",
        imgSrc: codec_2x.src
    },
    {
        techTitle: "Acceleration",
        imgSrc: acceleration_2x.src
    },
    {
        techTitle: "Semiconductor Design",
        imgSrc: silicon_IP_2x.src
    }, 
];
var TechBox = function(param) {
    var idx = param.idx;
    var locale = (0,router.useRouter)().locale;
    var t = locale === "en" ? en/* default */.Z : ko/* default */.Z;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TechBoxContainer, {
        id: idx === 0 ? "main-content1" : undefined,
        tabIndex: 0,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "top-color"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "content-wrapper front",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            position: "relative",
                            width: "100%",
                            height: "200px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonWrappers/* ImgBackgroundWrapper */.Yo, {
                            isNormalUse: true,
                            style: {
                                width: "200px",
                                height: "200px",
                                left: "50%",
                                transform: "translate3d(-50%,0,0)"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: techInfoList[idx].imgSrc,
                                alt: t.coreTech[idx].description,
                                layout: "fill",
                                objectFit: "cover",
                                quality: 51
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tech-title",
                        children: techInfoList[idx].techTitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "content-wrapper rear",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tech-title",
                        children: techInfoList[idx].techTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionBodyTxt, {
                        children: t.coreTech[idx].description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HightlightBodyTxt, {
                        children: t.coreTech[idx].highlight
                    })
                ]
            })
        ]
    });
};
var opacityKeyframes = (0,styled_components_browser_esm/* keyframes */.F4)(TechBox_templateObject());
var DescriptionBodyTxt = (0,styled_components_browser_esm/* default */.ZP)(global_styles/* BodyTextS */.Ei).withConfig({
    displayName: "TechBox__DescriptionBodyTxt",
    componentId: "sc-64fdae2a-0"
})(TechBox_templateObject1(), global_styles/* GRAY50 */.mu);
var HightlightBodyTxt = (0,styled_components_browser_esm/* default */.ZP)(global_styles/* BodyTextS */.Ei).withConfig({
    displayName: "TechBox__HightlightBodyTxt",
    componentId: "sc-64fdae2a-1"
})(TechBox_templateObject2(), global_styles.BB);
var TechBoxContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TechBox__TechBoxContainer",
    componentId: "sc-64fdae2a-2"
})(TechBox_templateObject3(), global_styles/* BBDARK */.wz, opacityKeyframes);

;// CONCATENATED MODULE: ./components/Global/index.ts













/***/ }),

/***/ 2486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OP": function() { return /* binding */ SecondTitleBanner; },
/* harmony export */   "Xn": function() { return /* binding */ txtAnimation; },
/* harmony export */   "Y6": function() { return /* binding */ FirstTitleBanner; },
/* harmony export */   "fz": function() { return /* binding */ SecondDescBanner; },
/* harmony export */   "k5": function() { return /* binding */ FirstDescBanner; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5505);
/* harmony import */ var _locale_en__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4614);
/* harmony import */ var _locale_ko__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4804);
/* harmony import */ var global_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9059);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% {\n    opacity: 0;\n    transform: translate3d(0,100%,0);\n    } 100% {\n    opacity: 1;\n    transform: translate3d(0,0,0);\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #fff;\n  overflow-y: hidden;\n  span {\n    display: block;\n    animation: ",
        " 1.5s 0.3s cubic-bezier(0.4, 0, 0.2, 1) backwards;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  position: relative;\n  .pc {\n    display: block;\n  }\n  .mobile {\n    display: none;\n  }\n  @media screen and (max-width: 599px) {\n    .pc {\n      display: none;\n    }\n    .mobile {\n      display: block;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  margin-top: 32px;\n  overflow-y: hidden;\n  position: relative;\n\n  span {\n    display: block;\n    animation: ",
        " 1.5s 1.3s cubic-bezier(0.4, 0, 0.2, 1) backwards;\n  }\n  @media screen and (max-width: 904px) {\n    margin-top: 16px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #fff;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






var FirstTitleBanner = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FirstTitleBannerContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MobileSize, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PCSize, {})
        ]
    });
};
var MobileSize = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FirstH1, {
                className: "banner-title mobile",
                tabIndex: -1,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    children: "Enhance and Optimize"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FirstH1, {
                className: "banner-title mobile",
                tabIndex: -1,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    children: "Videos that fit into"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FirstH1, {
                className: "banner-title mobile",
                tabIndex: -1,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    children: "your use case and gratify"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FirstH1, {
                className: "banner-title mobile",
                tabIndex: -1,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    children: "Viewer's Needs"
                })
            })
        ]
    });
};
var PCSize = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FirstH1, {
                className: "banner-title pc",
                tabIndex: -1,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    children: "Enhance and Optimize"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FirstH1, {
                className: "banner-title pc",
                tabIndex: -1,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    children: "Videos that fit into your use case"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FirstH1, {
                className: "banner-title pc",
                tabIndex: -1,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    children: "and gratify Viewer's Needs"
                })
            })
        ]
    });
};
var FirstDescBanner = function() {
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    var t = locale === "en" ? _locale_en__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z : _locale_ko__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(DescBannerContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DescSubtitleL, {
                tabIndex: -1,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    children: t.banner[0].first
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DescSubtitleL, {
                tabIndex: -1,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    children: t.banner[0].second
                })
            })
        ]
    });
};
var SecondTitleBanner = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FirstTitleBannerContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FirstH1, {
                tabIndex: -1,
                children: "A provider of"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FirstH1, {
                tabIndex: -1,
                children: "AI-based video processing"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FirstH1, {
                tabIndex: -1,
                children: "and encoding solutions"
            })
        ]
    });
};
var SecondDescBanner = function() {
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    var t = locale === "en" ? _locale_en__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z : _locale_ko__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(DescBannerContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DescSubtitleL, {
                tabIndex: -1,
                children: t.banner[1].first
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DescSubtitleL, {
                tabIndex: -1,
                children: t.banner[1].second
            })
        ]
    });
};
var txtAnimation = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .keyframes */ .F4)(_templateObject());
var FirstH1 = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(global_styles__WEBPACK_IMPORTED_MODULE_5__.H1).withConfig({
    displayName: "BannerItems__FirstH1",
    componentId: "sc-aa82aac2-0"
})(_templateObject1(), txtAnimation);
var FirstTitleBannerContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "BannerItems__FirstTitleBannerContainer",
    componentId: "sc-aa82aac2-1"
})(_templateObject2());
var DescBannerContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "BannerItems__DescBannerContainer",
    componentId: "sc-aa82aac2-2"
})(_templateObject3(), txtAnimation);
var DescSubtitleL = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(global_styles__WEBPACK_IMPORTED_MODULE_5__/* .SubtitleL */ .ar).withConfig({
    displayName: "BannerItems__DescSubtitleL",
    componentId: "sc-aa82aac2-3"
})(_templateObject4());


/***/ }),

/***/ 8040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K2": function() { return /* binding */ ProductTemplate; },
/* harmony export */   "Mj": function() { return /* binding */ opacityAppear; },
/* harmony export */   "rT": function() { return /* binding */ translateAppear; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6383);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var global_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9059);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(299);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5505);
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6627);
/* harmony import */ var _BannerItems__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2486);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% {\n    opacity: 0;\n  } 100% {\n    opacity: 1;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% {\n    transform: translate3d(0,300%,0);\n  } 100% {\n    transform: translate3d(0,0,0);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            animation: ",
        " 1s 0.2s cubic-bezier(0.4, 0, 0.2, 1)\n              forwards;\n          "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            animation: ",
        " 0.9s ease forwards;\n          "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            animation: ",
        " 1.2s 0.3s cubic-bezier(0.4, 0, 0.2, 1)\n              forwards;\n          "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          animation: ",
        " 0.9s 1s cubic-bezier(0.4, 0, 0.2, 1)\n            forwards;\n        "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          animation: ",
        " 0.9s 1.5s cubic-bezier(0.4, 0, 0.2, 1)\n            backwards;\n        "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          animation: ",
        " 0.9s 1.5s cubic-bezier(0.4, 0, 0.2, 1)\n            backwards;\n        "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  display: flex;\n  flex-direction: ",
        ";\n  & + & {\n    padding-top: 146px;\n  }\n\n  .left-container {\n    width: 50%;\n    .product-img-wrapper {\n      width: 100%;\n      position: relative !important;\n      .product-img {\n        object-fit: contain;\n        position: relative !important;\n        width: 100% !important;\n        height: unset !important;\n        vertical-align: top;\n        opacity: 0;\n        transition: all 0.4s cubic-bezier(0.1, 0.57, 0.1, 1);\n        ",
        ";\n      }\n    }\n    .product-img-wrapper > span {\n      position: unset !important;\n    }\n    @media screen and (min-width: 1240px) {\n      padding: ",
        ";\n      .product-img {\n        max-width: 544px;\n        max-height: 544px;\n      }\n    }\n    @media screen and (max-width: 1239px) and (min-width: 905px) {\n      padding: ",
        ";\n      .product-img {\n        max-width: 468px;\n        max-height: 468px;\n      }\n    }\n  }\n  .right-container {\n    width: 50%;\n\n    .label-text {\n      padding: 16px 0;\n      color: ",
        ";\n      overflow-y: hidden;\n      span {\n        display: block;\n        transform: translate3d(0, 300%, 0);\n        ",
        ";\n      }\n    }\n    .heading-three {\n      color: ",
        ";\n      margin-bottom: 32px;\n      overflow-y: hidden;\n      span {\n        display: block;\n        transform: translate3d(0, 300%, 0);\n        ",
        ";\n      }\n      @media screen and (max-width: 1239px) {\n        margin-bottom: 16px;\n      }\n      @media screen and (max-width: 904px) {\n        margin-bottom: 8px;\n      }\n    }\n    .body-text-m {\n      color: ",
        ";\n      overflow-y: hidden;\n      opacity: 0;\n      ",
        ";\n    }\n    .product-feature-list {\n      margin: 16px 0 56px 16px;\n      color: ",
        ";\n      list-style: disc;\n      ",
        ";\n    }\n    .buttons-wrapper {\n      display: flex;\n      width: 328px;\n      justify-content: space-between;\n      ",
        ";\n      & > button {\n        width: 156px !important;\n      }\n    }\n\n    @media screen and (max-width: 904px) {\n      margin-top: 16px;\n      .label-text {\n        padding: 16px 0 8px;\n      }\n    }\n  }\n\n  @media screen and (max-width: 1240px) {\n    .right-container {\n      .product-feature-list {\n        margin: 16px 0 32px 16px;\n      }\n    }\n  }\n  @media screen and (max-width: 904px) {\n    flex-direction: column;\n    justify-content: flex-start;\n    .left-container {\n      padding: 0;\n    }\n    .left-container,\n    .right-container {\n      width: 100%;\n      height: 100%;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}








var ProductTemplate = function(param) {
    var imgPath = param.imgPath, productName = param.productName, productPhrase = param.productPhrase, productDescription = param.productDescription, productFeatureList = param.productFeatureList, buttons = param.buttons, reverseLayout = param.reverseLayout, className = param.className;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_8__/* .useInView */ .YD)({
        threshold: 0.2,
        triggerOnce: true
    }), 2), targetRef = ref[0], isVisible = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ProductTemplateContainer, {
        reverseLayout: reverseLayout,
        isVisible: isVisible,
        ref: targetRef,
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "left-container",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "product-img-wrapper",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                        src: imgPath,
                        alt: productName,
                        className: "product-img",
                        layout: "fill",
                        quality: 70,
                        sizes: "(min-width: 905px) 50vw, 95vw"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "right-container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_2__/* .LabelText */ .NV, {
                        className: "label-text",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            children: productName
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_2__.H3, {
                        className: "heading-three",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            children: productPhrase
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_2__/* .BodyTextM */ .OV, {
                        className: "body-text-m",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            children: productDescription
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
                        className: "product-feature-list",
                        children: productFeatureList.map(function(productFeature) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_2__/* .BodyTextMStrong */ .X9, {
                                as: "li",
                                className: "product-feature",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                    children: productFeature
                                })
                            }, productFeature);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "buttons-wrapper",
                        children: buttons
                    })
                ]
            })
        ]
    });
};
var opacityAppear = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .keyframes */ .F4)(_templateObject());
var translateAppear = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .keyframes */ .F4)(_templateObject1());
var ProductTemplateContainer = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].article.withConfig */ .ZP.article.withConfig({
    displayName: "ProductTemplate__ProductTemplateContainer",
    componentId: "sc-50039a7d-0"
})(_templateObject8(), _Layout__WEBPACK_IMPORTED_MODULE_5__/* .gridSystemMargin */ .nR, function(param) {
    var reverseLayout = param.reverseLayout;
    return reverseLayout ? "row" : "row-reverse";
}, function(param) {
    var isVisible = param.isVisible;
    return isVisible && (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(_templateObject2(), opacityAppear);
}, function(param) {
    var reverseLayout = param.reverseLayout;
    return reverseLayout ? "0 54px 0 0" : "0 0 0 54px";
}, function(param) {
    var reverseLayout = param.reverseLayout;
    return reverseLayout ? "0 32px 0 0" : "0 0 0 32px";
}, global_styles__WEBPACK_IMPORTED_MODULE_2__.BB, function(param) {
    var isVisible = param.isVisible;
    return isVisible && (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(_templateObject3(), translateAppear);
}, global_styles__WEBPACK_IMPORTED_MODULE_2__/* .GRAY10 */ .Ir, function(param) {
    var isVisible = param.isVisible;
    return isVisible && (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(_templateObject4(), translateAppear);
}, global_styles__WEBPACK_IMPORTED_MODULE_2__/* .GRAY50 */ .mu, function(param) {
    var isVisible = param.isVisible;
    return isVisible && (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(_templateObject5(), opacityAppear);
}, global_styles__WEBPACK_IMPORTED_MODULE_2__/* .GRAY30 */ .zm, function(param) {
    var isVisible = param.isVisible;
    return isVisible && (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(_templateObject6(), _BannerItems__WEBPACK_IMPORTED_MODULE_6__/* .txtAnimation */ .Xn);
}, function(param) {
    var isVisible = param.isVisible;
    return isVisible && (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(_templateObject7(), _BannerItems__WEBPACK_IMPORTED_MODULE_6__/* .txtAnimation */ .Xn);
});


/***/ }),

/***/ 4561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "IM": function() { return /* reexport */ BannerSlideTemplate; },
  "cl": function() { return /* reexport */ CareerBanner; },
  "K0": function() { return /* reexport */ CoreTech; },
  "$2": function() { return /* reexport */ MainBanner; },
  "K2": function() { return /* reexport */ ProductTemplate/* ProductTemplate */.K2; },
  "Mj": function() { return /* reexport */ ProductTemplate/* opacityAppear */.Mj; }
});

// UNUSED EXPORTS: FirstDescBanner, FirstTitleBanner, SecondDescBanner, SecondTitleBanner, translateAppear, txtAnimation

// EXTERNAL MODULE: ./components/Home/BannerItems.tsx
var BannerItems = __webpack_require__(2486);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(2228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(6577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ./public/asset/01-main-banner/contents1/mainbanner-cover.jpg
/* harmony default export */ var mainbanner_cover = ({"src":"/_next/static/media/mainbanner-cover.30b3f2bd.jpg","height":2258,"width":4014,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAcEAACAgIDAAAAAAAAAAAAAAABAwACBFEFERP/xAAVAQEBAAAAAAAAAAAAAAAAAAABA//EABYRAQEBAAAAAAAAAAAAAAAAAAABEf/aAAwDAQACEQMRAD8Aicc/JQp/pkXeWVFbFh7IA1qIiXg1/9k=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./components/Home/BannerSlideTemplate.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  height: calc(var(--vh, 1vh) * 100);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: #000;\n\n  @media screen and (min-width: 1440px) {\n    width: 100%;\n    padding: 0 96px;\n  }\n  @media screen and (min-width: 1240px) and (max-width: 1439px) {\n    width: 100%;\n    padding: 0 96px;\n  }\n  @media screen and (min-width: 905px) and (max-width: 1239px) {\n    width: 100%;\n    padding: 0 56px;\n  }\n  @media screen and (min-width: 600px) and (max-width: 904px) {\n    width: 100%;\n    padding: 0 32px;\n  }\n  @media screen and (max-width: 599px) {\n    width: 100%;\n    padding: 0 16px;\n  }\n\n  .banner-img-wrapper {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    /* z-index: -1; */\n  }\n\n  .banner-vid {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    position: absolute;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var BannerSlideTemplate = function(param) {
    var useVideo = param.useVideo, MainComponent = param.MainComponent, DescComponent = param.DescComponent, backgroundImagePath = param.backgroundImagePath;
    var wrapperRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerSlideTemplateContainer, {
        ref: wrapperRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "banner-img-wrapper",
                children: useVideo ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: mainbanner_cover,
                            layout: "fill",
                            alt: "bluedot",
                            className: "banner-img",
                            quality: 30,
                            priority: true,
                            sizes: "(min-width: 906px) 90vw, (min-width: 600px) 85vw, (max-width: 599px) 75vw",
                            loading: "eager"
                        }),
                        backgroundImagePath && backgroundImagePath.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                            src: backgroundImagePath,
                            autoPlay: true,
                            playsInline: true,
                            poster: backgroundImagePath,
                            muted: true,
                            loop: true,
                            className: "banner-vid"
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: backgroundImagePath,
                    layout: "fill",
                    alt: "bluedot",
                    className: "banner-img",
                    quality: 85,
                    priority: true,
                    sizes: "(min-width: 906px) 90vw, (min-width: 600px) 85vw, (max-width: 599px) 75vw",
                    loading: "eager"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainComponent, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DescComponent, {})
        ]
    });
};
var BannerSlideTemplateContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "BannerSlideTemplate__BannerSlideTemplateContainer",
    componentId: "sc-ea6b8922-0"
})(_templateObject());

// EXTERNAL MODULE: ../../packages/global-styles/MainButton.tsx
var MainButton = __webpack_require__(8920);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../packages/assets/icons.tsx
var icons = __webpack_require__(1089);
// EXTERNAL MODULE: ./styles/breakPoints.ts
var breakPoints = __webpack_require__(3081);
// EXTERNAL MODULE: ../../packages/global-styles/index.ts
var global_styles = __webpack_require__(9059);
;// CONCATENATED MODULE: ./components/Home/CareerBanner.tsx

function CareerBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "margin-top:56px; height: 56px;"
    ]);
    CareerBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  .inner-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    color: #fff;\n    padding: 93.5px 0;\n    text-align: center;\n    @media screen and (min-width: 1440px) {\n      width: 100%;\n      max-width: 1200px;\n      margin: 0 auto;\n      padding: 93.5px 0;\n    }\n    @media screen and (min-width: 1240px) and (max-width: 1439px) {\n      width: calc(100% - 192px);\n      margin: 0 96px;\n      padding: 93.5px 0;\n    }\n    @media screen and (min-width: 905px) and (max-width: 1239px) {\n      width: calc(100% - 112px);\n      margin: 0 56px;\n      padding: 56px 0;\n    }\n    @media screen and (min-width: 600px) and (max-width: 904px) {\n      width: calc(100% - 64px);\n      margin: 0 32px;\n      padding: 56px 0;\n    }\n    @media screen and (max-width: 599px) {\n      width: calc(100% - 32px);\n      margin: 0 16px;\n      padding: 56px 0;\n    }\n    .career-txt {\n      color: #fff;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var CareerBanner = function() {
    var locale = (0,router.useRouter)().locale;
    if (locale === "en") return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CareerBannerContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "inner-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* H2KR */.Zj, {
                    children: "블루닷과 함께 성장해 나갈"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* H2KR */.Zj, {
                    children: "열정 가득한 인재를 찾고 있습니다."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MainButton/* MainButton */.c, {
                    injectInlineStyles: {
                        width: "328px"
                    },
                    injectCssStyles: [
                        (0,breakPoints/* generateCssStyle */.m)({
                            "margin-top": "32px",
                            height: "48px"
                        }),
                        breakPoints/* mediaQueryStyle.M */.Pm.M(CareerBanner_templateObject()), 
                    ],
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* GoToIcon */.A5, {}),
                    tag: "a",
                    href: "https://blue-dot.career.greetinghr.com/",
                    buttonType: "default-w",
                    changeIconColor: true,
                    target: "_blank",
                    iconPosition: "right",
                    text: "채용페이지 바로가기"
                })
            ]
        })
    });
};
var CareerBannerContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "CareerBanner__CareerBannerContainer",
    componentId: "sc-15a8f5c4-0"
})(_templateObject1(), global_styles/* BBINDIGO */._4);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(6383);
// EXTERNAL MODULE: ./components/Global/index.ts + 16 modules
var Global = __webpack_require__(6402);
;// CONCATENATED MODULE: ./public/asset/02-section1/icon/main-section1-icon@2x.png
/* harmony default export */ var main_section1_icon_2x = ({"src":"/_next/static/media/main-section1-icon@2x.7cab17d2.png","height":161,"width":161,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAKlBMVEVMaXEtas9He9Qtas8sac9Bf9s4cdEzbs9ejNhNf9Q8ddMpZ85KfNRKfdRgyP0GAAAADnRSTlMAhRcrlAmWWGaBQqGsdc731A8AAAAJcEhZcwAAFiUAABYlAUlSJPAAAAA4SURBVHicFctJEgAxCMNAGTBkmf+/dyon9UVgOxNgpNJT3lt94JSqFRCq7m8B0uy9DDkZ8S7slx8gRQDa15ONUgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./components/Home/ProductTemplate.tsx
var ProductTemplate = __webpack_require__(8040);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(299);
;// CONCATENATED MODULE: ./components/Home/CoreTech.tsx


function CoreTech_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        animation: ",
        " 1s 0.7s ease-out forwards;\n      "
    ]);
    CoreTech_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CoreTech_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100vw;\n  width: 100%;\n  height: 100vh;\n  height: calc(var(--vh, 1vh) * 100);\n  min-height: 640px;\n  text-align: center;\n  overflow-y: hidden;\n\n  .tech-icon-wrapper {\n    position: relative;\n    width: 80px;\n    height: 80px;\n    margin: 16px auto;\n  }\n  @media screen and (min-width: 1440px) {\n    padding: 0 96px;\n  }\n  @media screen and (max-width: 1439px) {\n    padding: 0 96px;\n  }\n  @media screen and (max-width: 1239px) {\n    padding: 0 56px;\n  }\n  @media screen and (max-width: 904px) {\n    padding: 0 32px;\n    .tech-icon-wrapper {\n      width: 60px;\n      height: 60px;\n      margin: 8px auto;\n    }\n  }\n  @media screen and (max-width: 599px) {\n    padding: 0 16px;\n\n    .tech-icon-wrapper {\n      width: 48px;\n      height: 48px;\n    }\n  }\n  .tech-wrapper {\n    transform: translate3d(0, -50%, 0);\n    top: 50%;\n    left: 0;\n    right: 0;\n    position: absolute;\n    /* device높이 700px 이하부터는 top(마진역할)이 68px로 최소값 설정되어 헤더가 가리지 않도록 한다. */\n    @media screen and (max-height: 700px) {\n      top: 68px;\n      transform: none;\n    }\n  }\n\n  .tech-box-wrapper::-webkit-scrollbar {\n    display: none; /* Chrome, Safari, Opera*/\n  }\n  .tech-box-wrapper {\n    overflow-x: scroll;\n    overflow-y: hidden;\n    padding-left: 60px;\n    padding-right: 60px;\n    padding-top: 56px;\n    scroll-snap-type: x mandatory;\n    opacity: 0;\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n    display: flex;\n    gap: 16px;\n    width: 100%;\n    ",
        ";\n\n    @media screen and (min-width: 1440px) {\n      padding: 56px auto 0;\n    }\n    @media screen and (min-width: 1240px) and (max-width: 1439px) {\n      padding: 56px 96px 0;\n    }\n    @media screen and (min-width: 905px) and (max-width: 1239px) {\n      padding: 56px 56px 0;\n    }\n    @media screen and (min-width: 600px) and (max-width: 904px) {\n      padding: 32px 32px 0;\n    }\n    @media screen and (max-width: 599px) {\n      padding: 16px 16px 0;\n    }\n\n    @media screen and (min-width: 1439px) {\n      justify-content: center;\n    }\n  }\n  .upper,\n  .bottom {\n    position: absolute;\n    left: 0;\n    right: 0;\n  }\n  .upper {\n    top: 0;\n    bottom: 33.33%;\n    background: radial-gradient(\n      125.21% 125.21% at 50% -2.92%,\n      #33466c 0%,\n      #202140 42.97%,\n      #0b183a 99.99%,\n      #152346 100%\n    );\n  }\n  .bottom {\n    top: 66.67%;\n    bottom: 0;\n    background: radial-gradient(\n      100% 100% at 50% 0%,\n      #f5f5f5 0%,\n      #e7e6e6 0.01%,\n      #f5f5f5 100%\n    );\n    @media screen and (max-width: 599px) {\n      background: linear-gradient(\n        180deg,\n        #e7e6e6 0.16%,\n        #f5f5f5 0.17%,\n        #e8e8e8 100%\n      );\n    }\n  }\n"
    ]);
    CoreTech_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  overflow-y: hidden;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        animation: ",
        " 0.7s cubic-bezier(0.4, 0, 0.2, 1) forwards;\n      "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n  overflow-y: hidden;\n  .translate-wrapper {\n    display: block;\n    transform: translate3d(0, 300%, 0);\n    margin: 0 auto;\n    ",
        ";\n    .lb {\n      @media screen and (max-width: 600px) {\n        display: block;\n      }\n    }\n  }\n  .ai-based {\n    margin-left: 0.5ch;\n    color: #2564ce;\n  }\n  .ai-based-mo {\n    display: none;\n  }\n  @media screen and (max-width: 600px) {\n    flex-direction: column;\n    .ai-based-pc {\n      display: none;\n    }\n    .ai-based-mo {\n      display: unset;\n      margin-left: 0;\n      margin-right: 0.5ch;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}








var CoreTech = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,react_intersection_observer_modern/* useInView */.YD)({
        threshold: 0.3,
        fallbackInView: true,
        triggerOnce: true
    }), 2), targetRef = ref[0], isVisible = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CoreTechContainer, {
        ref: targetRef,
        isVisible: isVisible,
        className: "core-tech-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "upper"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bottom"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tech-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreTechLabelText, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "translate-wrapper",
                            children: "Core Technologies"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tech-icon-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: main_section1_icon_2x.src,
                            alt: "",
                            layout: "fill",
                            objectFit: "contain",
                            quality: 70
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreTechH2, {
                        className: "vas",
                        isVisible: isVisible,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "translate-wrapper",
                            children: [
                                "Video Application Specific",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "ai-based-pc ai-based",
                                    children: "AI-based"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreTechH2, {
                        isVisible: isVisible,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "translate-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "ai-based-mo ai-based",
                                    children: "AI-based"
                                }),
                                "Processing and",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "lb",
                                    children: " Compression Technologies"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tech-box-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Global/* TechBox */.Tt, {
                                idx: 0
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Global/* TechBox */.Tt, {
                                idx: 1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Global/* TechBox */.Tt, {
                                idx: 2
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Global/* TechBox */.Tt, {
                                idx: 3
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var CoreTechContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "CoreTech__CoreTechContainer",
    componentId: "sc-4496ce0-0"
})(CoreTech_templateObject1(), function(param) {
    var isVisible = param.isVisible;
    return isVisible && (0,styled_components_browser_esm/* css */.iv)(CoreTech_templateObject(), ProductTemplate/* opacityAppear */.Mj);
});
var CoreTechLabelText = (0,styled_components_browser_esm/* default */.ZP)(global_styles/* LabelText */.NV).withConfig({
    displayName: "CoreTech__CoreTechLabelText",
    componentId: "sc-4496ce0-1"
})(_templateObject2(), global_styles/* BBPALE */.po);
var CoreTechH2 = (0,styled_components_browser_esm/* default */.ZP)(global_styles.H2).withConfig({
    displayName: "CoreTech__CoreTechH2",
    componentId: "sc-4496ce0-2"
})(_templateObject4(), function(param) {
    var isVisible = param.isVisible;
    return isVisible && (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), ProductTemplate/* translateAppear */.rT);
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(6670);
// EXTERNAL MODULE: ../../node_modules/react-slick/lib/index.js
var lib = __webpack_require__(3467);
;// CONCATENATED MODULE: ./public/asset/01-main-banner/contents2/mainvisual-img2.png
/* harmony default export */ var mainvisual_img2 = ({"src":"/_next/static/media/mainvisual-img2.f112906b.png","height":1081,"width":1920,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAADFBMVEUFDCQDCRcIDjIMFkAPQvVAAAAABHRSTlP8+/z8yrBDMgAAAAlwSFlzAAALEwAACxMBAJqcGAAAACFJREFUeJwtxrENAAAIw7A0/f9nBMKTwS5AW8lNkivZ/AYFawAvydM0tgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./public/asset/01-main-banner/contents1/mainvisual-video-L.mp4
var mainvisual_video_L = __webpack_require__(9039);
var mainvisual_video_L_default = /*#__PURE__*/__webpack_require__.n(mainvisual_video_L);
// EXTERNAL MODULE: ./public/asset/01-main-banner/contents1/mainvisual-video-M.mp4
var mainvisual_video_M = __webpack_require__(1464);
var mainvisual_video_M_default = /*#__PURE__*/__webpack_require__.n(mainvisual_video_M);
// EXTERNAL MODULE: ./public/asset/01-main-banner/contents1/mainvisual-video-S.mp4
var mainvisual_video_S = __webpack_require__(6976);
var mainvisual_video_S_default = /*#__PURE__*/__webpack_require__.n(mainvisual_video_S);
// EXTERNAL MODULE: ../../node_modules/react-device-detect/dist/lib.js
var dist_lib = __webpack_require__(6582);
// EXTERNAL MODULE: ../../node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(1192);
// EXTERNAL MODULE: ../../node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(3201);
;// CONCATENATED MODULE: ./components/Home/MainBanner.tsx



function MainBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-x: hidden;\n  width: 100vw;\n  width: 100%;\n  height: calc(var(--vh, 1vh) * 100);\n  .slick-initialized {\n    overflow: hidden;\n  }\n"
    ]);
    MainBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MainBanner_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: calc(var(--vh, 1vh) * 100);\n  width: 100vw;\n  width: 100%;\n  min-height: 640px;\n  position: relative;\n  z-index: 99;\n  overscroll-behavior-y: none;\n  .buttons-wrapper {\n    position: absolute;\n    left: 32px;\n    bottom: 32px;\n    display: flex;\n    align-items: center;\n    .cus-slick-button {\n      width: 48px;\n      height: 48px;\n      justify-content: center;\n      background: transparent;\n      display: flex;\n      align-items: center;\n      color: #fff;\n    }\n    .cus-slick-next {\n      transform: rotate(180deg);\n    }\n  }\n  .banner-img {\n    object-fit: cover;\n    width: 100vw;\n    height: 100vh;\n    height: calc(var(--vh, 1vh) * 100);\n  }\n  @media screen and (max-width: 599px) {\n    .buttons-wrapper {\n      left: 16px;\n      bottom: 16px;\n    }\n  }\n"
    ]);
    MainBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MainBanner_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #fff;\n  font-size: 15px;\n  width: 76px;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  .slash {\n    transform: rotate(35deg);\n    display: inline-block;\n    width: 1px;\n    height: 16px;\n    background: #fff;\n  }\n"
    ]);
    MainBanner_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}















var MainBanner = function(param) {
    var $mainBannerRef = param.$mainBannerRef;
    var ref = (0,react.useState)(""), videoUrl = ref[0], setVideoUrl = ref[1];
    var ref1 = (0,react.useState)({
        oldSlide: 0,
        activeSlide: 0,
        activeSlide2: 0
    }), slideIdx = ref1[0], setSlideIdx = ref1[1];
    var slickRef = (0,react.useRef)(null);
    var settings = (0,react.useMemo)(function() {
        return {
            infinite: true,
            speed: 700,
            useTransform: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            Infinity: true,
            arrows: false,
            pauseOnHover: false,
            easing: "ease-in-out",
            autoplay: false,
            autoplaySpeed: 7000,
            beforeChange: function(current, next) {
                return setSlideIdx((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, slideIdx), {
                    oldSlide: current,
                    activeSlide: next
                }));
            },
            afterChange: function(current) {
                return setSlideIdx((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, slideIdx), {
                    activeSlide2: current
                }));
            }
        };
    }, [
        slideIdx
    ]);
    var handleClickNext = function() {
        if (slickRef.current) slickRef.current.slickNext();
    };
    var handleClickPrev = function() {
        if (slickRef.current) slickRef.current.slickPrev();
    };
    (0,react.useEffect)(function() {
        setVideoUrl(dist_lib/* isDesktop */.nI ? (mainvisual_video_L_default()) : dist_lib/* isMobileOnly */.UA ? (mainvisual_video_S_default()) : (mainvisual_video_M_default()));
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainBannerContainer, {
        className: "main-section-container",
        ref: $mainBannerRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSlider, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
                ref: slickRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerSlideTemplate, {
                            useVideo: true,
                            MainComponent: BannerItems/* FirstTitleBanner */.Y6,
                            DescComponent: BannerItems/* FirstDescBanner */.k5,
                            backgroundImagePath: videoUrl,
                            blurImgPath: "",
                            movePath: "/"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerSlideTemplate, {
                            useVideo: false,
                            MainComponent: BannerItems/* SecondTitleBanner */.OP,
                            DescComponent: BannerItems/* SecondDescBanner */.fz,
                            backgroundImagePath: mainvisual_img2.src,
                            movePath: "/"
                        })
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "buttons-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: handleClickPrev,
                        className: "cus-slick-prev cus-slick-button",
                        "aria-label": "previous",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* MainBannerArrowIcon */.Pu, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SlickIndicatorBtnText, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: slideIdx.activeSlide2 + 1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "slash"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        "aria-label": "next",
                        onClick: handleClickNext,
                        className: "cus-slick-next cus-slick-button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* MainBannerArrowIcon */.Pu, {})
                    })
                ]
            })
        ]
    });
};
var StyledSlider = (0,styled_components_browser_esm/* default */.ZP)(lib/* default */.Z).withConfig({
    displayName: "MainBanner__StyledSlider",
    componentId: "sc-5f4e825c-0"
})(MainBanner_templateObject());
var MainBannerContainer = styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
    displayName: "MainBanner__MainBannerContainer",
    componentId: "sc-5f4e825c-1"
})(MainBanner_templateObject1());
var SlickIndicatorBtnText = (0,styled_components_browser_esm/* default */.ZP)(global_styles/* ButtonText1 */.Ls).withConfig({
    displayName: "MainBanner__SlickIndicatorBtnText",
    componentId: "sc-5f4e825c-2"
})(MainBanner_templateObject2());

;// CONCATENATED MODULE: ./components/Home/index.ts








/***/ }),

/***/ 6627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DA": function() { return /* binding */ gridSystemPadding; },
/* harmony export */   "nR": function() { return /* binding */ gridSystemMargin; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5505);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media screen and (min-width: 1440px) {\n    width: 100%;\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n  @media screen and (min-width: 1240px) and (max-width: 1439px) {\n    width: calc(100% - 192px);\n    margin: 0 96px;\n  }\n  @media screen and (min-width: 905px) and (max-width: 1239px) {\n    width: calc(100% - 112px);\n    margin: 0 56px;\n  }\n  @media screen and (min-width: 600px) and (max-width: 904px) {\n    width: calc(100% - 64px);\n    margin: 0 32px;\n  }\n  @media screen and (max-width: 599px) {\n    width: calc(100% - 32px);\n    margin: 0 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media screen and (min-width: 1440px) {\n    width: 100%;\n    max-width: 1200px;\n    padding: 0 96px;\n  }\n  @media screen and (min-width: 1240px) and (max-width: 1439px) {\n    width: 100%;\n    padding: 0 96px;\n  }\n  @media screen and (min-width: 905px) and (max-width: 1239px) {\n    width: 100%;\n    padding: 0 56px;\n  }\n  @media screen and (min-width: 600px) and (max-width: 904px) {\n    width: 100%;\n    padding: 0 32px;\n  }\n  @media screen and (max-width: 599px) {\n    width: 100%;\n    padding: 0 16px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var gridSystemMargin = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
var gridSystemPadding = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1());
var Layout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx(LayoutContainer, {
        children: children
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Layout)));
var LayoutContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "Layout__LayoutContainer",
    componentId: "sc-ded66cc9-0"
})(_templateObject2(), gridSystemMargin);


/***/ }),

/***/ 1849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ NewHeader; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(2228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(9097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
// EXTERNAL MODULE: ./public/asset/bluedot-logo-c.svg
var bluedot_logo_c = __webpack_require__(7302);
;// CONCATENATED MODULE: ./public/asset/bluedot-logo-w.svg
/* harmony default export */ var bluedot_logo_w = ({"src":"/_next/static/media/bluedot-logo-w.14d257e1.svg","height":36,"width":229});
;// CONCATENATED MODULE: ./components/Header/LogoArea.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  transition: all 0.3s cubic-bezier(0.1, 0.57, 0.1, 1);\n  width: 153px;\n  height: 24px;\n  a {\n    display: inline-block;\n    width: 100%;\n    img {\n      width: 100%;\n    }\n  }\n\n  @media screen and (max-width: 1439px) {\n    width: 128px;\n    height: 20px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var LogoArea = function(param) {
    var isScrolled = param.isScrolled, isOpen = param.isOpen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoAreaContainer, {
        isScrolled: isScrolled,
        as: "h1",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/",
            scroll: true,
            children: isScrolled || isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: bluedot_logo_c/* default.src */.Z.src,
                    alt: "bluedot inc."
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: bluedot_logo_w.src,
                    alt: "bluedot inc."
                })
            })
        })
    });
};
var LogoAreaContainer = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    displayName: "LogoArea__LogoAreaContainer",
    componentId: "sc-2d1faa00-0"
})(_templateObject());

// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(5237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(6383);
// EXTERNAL MODULE: ../avif-comparison/src/components/AppModal.tsx
var AppModal = __webpack_require__(4572);
// EXTERNAL MODULE: ./components/Home/index.ts + 7 modules
var Home = __webpack_require__(4561);
;// CONCATENATED MODULE: ./components/NewHeader/HeaderNavIcons.tsx


/* Company svg */ var AboutIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        style: {
            width: "100%",
            height: "100%"
        },
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "48",
                height: "48",
                rx: "7.5",
                fill: "#0080CC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.5776 11.4746H32.4233C32.7507 11.4747 33.0145 11.5833 33.2299 11.7988C33.4456 12.0143 33.5541 12.2789 33.5541 12.6064V35.3936C33.5541 35.6802 33.4713 35.9188 33.3061 36.1182L33.2299 36.2012C33.0145 36.4167 32.7507 36.5253 32.4233 36.5254H26.2153V30.583H21.7846V36.5254H15.5776C15.2907 36.5254 15.0524 36.4418 14.853 36.2764L14.77 36.2012L14.6948 36.1182C14.5293 35.9188 14.4457 35.6804 14.4457 35.3936V12.6064C14.4457 12.2789 14.5543 12.0143 14.77 11.7988C14.9854 11.5832 15.25 11.4746 15.5776 11.4746ZM16.2465 34.7246H19.9848V28.7832H28.0151V34.7246H31.7543V13.2754H16.2465V34.7246ZM28.0151 22.8984V25.0439H25.8696V22.8984H28.0151ZM22.1303 22.8984V25.0439H19.9848V22.8984H22.1303ZM28.0151 17.0137V19.1592H25.8696V17.0137H28.0151ZM22.1303 17.0137V19.1592H19.9848V17.0137H22.1303Z",
                fill: "#FAFBFD",
                stroke: "#0080CC",
                strokeWidth: "0.45"
            })
        ]
    });
};
var BlogIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        style: {
            width: "100%",
            height: "100%"
        },
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "48",
                height: "48",
                rx: "7.5",
                fill: "#0080CC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.7694 33.9922C14.194 33.9922 13.7135 33.7995 13.3281 33.4141C12.9427 33.0287 12.75 32.5482 12.75 31.9728V16.0116C12.75 15.4361 12.9427 14.9557 13.3281 14.5703C13.7135 14.1849 14.194 13.9922 14.7694 13.9922H33.2306C33.806 13.9922 34.2865 14.1849 34.6719 14.5703C35.0573 14.9557 35.25 15.4361 35.25 16.0116V31.9728C35.25 32.5482 35.0573 33.0287 34.6719 33.4141C34.2865 33.7995 33.806 33.9922 33.2306 33.9922H14.7694ZM14.7694 32.7422H33.2306C33.4231 32.7422 33.5995 32.6621 33.7597 32.5019C33.9199 32.3417 34 32.1653 34 31.9728V16.0116C34 15.8191 33.9199 15.6427 33.7597 15.4825C33.5995 15.3223 33.4231 15.2422 33.2306 15.2422H14.7694C14.5769 15.2422 14.4005 15.3223 14.2403 15.4825C14.0801 15.6427 14 15.8191 14 16.0116V31.9728C14 32.1653 14.0801 32.3417 14.2403 32.5019C14.4005 32.6621 14.5769 32.7422 14.7694 32.7422ZM18.0866 29.2806H29.9134C30.0914 29.2806 30.24 29.2209 30.3594 29.1016C30.4788 28.9822 30.5384 28.8335 30.5384 28.6556C30.5384 28.4777 30.4788 28.3291 30.3594 28.2097C30.24 28.0903 30.0914 28.0306 29.9134 28.0306H18.0866C17.9086 28.0306 17.76 28.0903 17.6406 28.2097C17.5213 28.3291 17.4616 28.4777 17.4616 28.6556C17.4616 28.8335 17.5213 28.9822 17.6406 29.1016C17.76 29.2209 17.9086 29.2806 18.0866 29.2806ZM18.0866 24.6172H21.0672C21.2451 24.6172 21.3938 24.5575 21.5131 24.4381C21.6325 24.3188 21.6922 24.1701 21.6922 23.9922V19.3288C21.6922 19.1508 21.6325 19.0022 21.5131 18.8828C21.3938 18.7634 21.2451 18.7038 21.0672 18.7038H18.0866C17.9086 18.7038 17.76 18.7634 17.6406 18.8828C17.5213 19.0022 17.4616 19.1508 17.4616 19.3288V23.9922C17.4616 24.1701 17.5213 24.3188 17.6406 24.4381C17.76 24.5575 17.9086 24.6172 18.0866 24.6172ZM25.2981 24.6172H29.9134C30.0914 24.6172 30.24 24.5575 30.3594 24.4381C30.4788 24.3188 30.5384 24.1701 30.5384 23.9922C30.5384 23.8143 30.4788 23.6656 30.3594 23.5463C30.24 23.4269 30.0914 23.3672 29.9134 23.3672H25.2981C25.1202 23.3672 24.9716 23.4269 24.8522 23.5463C24.7328 23.6656 24.6731 23.8143 24.6731 23.9922C24.6731 24.1701 24.7328 24.3188 24.8522 24.4381C24.9716 24.5575 25.1202 24.6172 25.2981 24.6172ZM25.2981 19.9538H29.9134C30.0914 19.9538 30.24 19.8941 30.3594 19.7747C30.4788 19.6553 30.5384 19.5067 30.5384 19.3288C30.5384 19.1508 30.4788 19.0022 30.3594 18.8828C30.24 18.7634 30.0914 18.7038 29.9134 18.7038H25.2981C25.1202 18.7038 24.9716 18.7634 24.8522 18.8828C24.7328 19.0022 24.6731 19.1508 24.6731 19.3288C24.6731 19.5067 24.7328 19.6553 24.8522 19.7747C24.9716 19.8941 25.1202 19.9538 25.2981 19.9538Z",
                fill: "#FAFBFD"
            })
        ]
    });
};
var EventIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        style: {
            width: "100%",
            height: "100%"
        },
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "48",
                height: "48",
                rx: "7.5",
                fill: "#0080CC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.0116 35.2728C15.4361 35.2728 14.9557 35.0801 14.5703 34.6947C14.1849 34.3093 13.9922 33.8289 13.9922 33.2534V17.2922C13.9922 16.7168 14.1849 16.2364 14.5703 15.8509C14.9557 15.4655 15.4361 15.2728 16.0116 15.2728H18.2228V13.1575C18.2228 12.9635 18.2866 12.8028 18.4141 12.6753C18.5416 12.548 18.7022 12.4844 18.8959 12.4844C19.0899 12.4844 19.2506 12.548 19.3781 12.6753C19.5054 12.8028 19.5691 12.9635 19.5691 13.1575V15.2728H28.5116V13.1094C28.5116 12.9315 28.5712 12.7828 28.6906 12.6634C28.81 12.5441 28.9586 12.4844 29.1366 12.4844C29.3143 12.4844 29.4628 12.5441 29.5822 12.6634C29.7018 12.7828 29.7616 12.9315 29.7616 13.1094V15.2728H31.9728C32.5482 15.2728 33.0286 15.4655 33.4141 15.8509C33.7995 16.2364 33.9922 16.7168 33.9922 17.2922V33.2534C33.9922 33.8289 33.7995 34.3093 33.4141 34.6947C33.0286 35.0801 32.5482 35.2728 31.9728 35.2728H16.0116ZM16.0116 34.0228H31.9728C32.1653 34.0228 32.3417 33.9427 32.5019 33.7825C32.6621 33.6223 32.7422 33.4459 32.7422 33.2534V22.2922H15.2422V33.2534C15.2422 33.4459 15.3223 33.6223 15.4825 33.7825C15.6427 33.9427 15.8191 34.0228 16.0116 34.0228ZM15.2422 21.0419H32.7422V17.2922C32.7422 17.0997 32.6621 16.9233 32.5019 16.7631C32.3417 16.6029 32.1653 16.5228 31.9728 16.5228H16.0116C15.8191 16.5228 15.6427 16.6029 15.4825 16.7631C15.3223 16.9233 15.2422 17.0997 15.2422 17.2922V21.0419ZM23.9922 26.715C23.7343 26.715 23.5095 26.6193 23.3178 26.4278C23.1264 26.2364 23.0306 26.0116 23.0306 25.7534C23.0306 25.4955 23.1264 25.2708 23.3178 25.0794C23.5095 24.8879 23.7343 24.7922 23.9922 24.7922C24.2501 24.7922 24.4749 24.8879 24.6666 25.0794C24.858 25.2708 24.9537 25.4955 24.9537 25.7534C24.9537 26.0116 24.858 26.2364 24.6666 26.4278C24.4749 26.6193 24.2501 26.715 23.9922 26.715ZM18.9922 26.715C18.7343 26.715 18.5095 26.6193 18.3178 26.4278C18.1264 26.2364 18.0306 26.0116 18.0306 25.7534C18.0306 25.4955 18.1264 25.2708 18.3178 25.0794C18.5095 24.8879 18.7343 24.7922 18.9922 24.7922C19.2501 24.7922 19.4749 24.8879 19.6666 25.0794C19.858 25.2708 19.9537 25.4955 19.9537 25.7534C19.9537 26.0116 19.858 26.2364 19.6666 26.4278C19.4749 26.6193 19.2501 26.715 18.9922 26.715ZM28.9922 26.715C28.7343 26.715 28.5095 26.6193 28.3178 26.4278C28.1263 26.2364 28.0306 26.0116 28.0306 25.7534C28.0306 25.4955 28.1263 25.2708 28.3178 25.0794C28.5095 24.8879 28.7343 24.7922 28.9922 24.7922C29.2501 24.7922 29.4749 24.8879 29.6666 25.0794C29.858 25.2708 29.9537 25.4955 29.9537 25.7534C29.9537 26.0116 29.858 26.2364 29.6666 26.4278C29.4749 26.6193 29.2501 26.715 28.9922 26.715ZM23.9922 31.5228C23.7343 31.5228 23.5095 31.4271 23.3178 31.2356C23.1264 31.0442 23.0306 30.8194 23.0306 30.5613C23.0306 30.3033 23.1264 30.0785 23.3178 29.8869C23.5095 29.6954 23.7343 29.5997 23.9922 29.5997C24.2501 29.5997 24.4749 29.6954 24.6666 29.8869C24.858 30.0785 24.9537 30.3033 24.9537 30.5613C24.9537 30.8194 24.858 31.0442 24.6666 31.2356C24.4749 31.4271 24.2501 31.5228 23.9922 31.5228ZM18.9922 31.5228C18.7343 31.5228 18.5095 31.4271 18.3178 31.2356C18.1264 31.0442 18.0306 30.8194 18.0306 30.5613C18.0306 30.3033 18.1264 30.0785 18.3178 29.8869C18.5095 29.6954 18.7343 29.5997 18.9922 29.5997C19.2501 29.5997 19.4749 29.6954 19.6666 29.8869C19.858 30.0785 19.9537 30.3033 19.9537 30.5613C19.9537 30.8194 19.858 31.0442 19.6666 31.2356C19.4749 31.4271 19.2501 31.5228 18.9922 31.5228ZM28.9922 31.5228C28.7343 31.5228 28.5095 31.4271 28.3178 31.2356C28.1263 31.0442 28.0306 30.8194 28.0306 30.5613C28.0306 30.3033 28.1263 30.0785 28.3178 29.8869C28.5095 29.6954 28.7343 29.5997 28.9922 29.5997C29.2501 29.5997 29.4749 29.6954 29.6666 29.8869C29.858 30.0785 29.9537 30.3033 29.9537 30.5613C29.9537 30.8194 29.858 31.0442 29.6666 31.2356C29.4749 31.4271 29.2501 31.5228 28.9922 31.5228Z",
                fill: "#FAFBFD"
            })
        ]
    });
};
/* Product svg */ var DeepFieldSRIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        style: {
            width: "100%",
            height: "100%"
        },
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "48",
                height: "48",
                rx: "7.5",
                fill: "#0080CC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                xlinkHref: "#arrow-grow-icon"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.752 29.1875V32.5625C22.752 35.375 21.627 36.5 18.8145 36.5H15.4395C12.627 36.5 11.502 35.375 11.502 32.5625V29.1875C11.502 26.375 12.627 25.25 15.4395 25.25H18.8145C21.627 25.25 22.752 26.375 22.752 29.1875Z",
                stroke: "#FAFBFD",
                strokeWidth: "1.0575",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.3389 30.0908C19.9899 30.4667 19.9898 31.4064 19.3389 31.7822L16.6523 33.333C16.0013 33.7089 15.1875 33.239 15.1875 32.4873V29.3857C15.1875 28.634 16.0013 28.1642 16.6523 28.54L19.3389 30.0908Z",
                stroke: "#ffffff",
                strokeWidth: "1.0575",
                style: {
                    transformOrigin: "center",
                    transformBox: "fill-box"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("animateTransform", {
                    attributeName: "transform",
                    fill: "freeze",
                    attributeType: "XML",
                    type: "scale",
                    values: "0.95 1;1.2 1;0.95 1",
                    keyTimes: "0;0.5;1",
                    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1",
                    calcMode: "spline",
                    dur: "2s",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                xlinkHref: "#most-outline-path"
            })
        ]
    });
};
var DeepFieldPQOIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        style: {
            width: "100%",
            height: "100%"
        },
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "48",
                height: "48",
                rx: "7.5",
                fill: "#0080CC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.2505 11.5C14.0005 11.5 11.5005 14 11.5005 20.25",
                stroke: "#FAFBFD",
                strokeWidth: "1.0575",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27.6191 11.5C33.8691 11.5 36.3691 14 36.3691 20.25",
                stroke: "#FAFBFD",
                strokeWidth: "1.0575",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27.6191 36.3672C33.8691 36.3672 36.3691 33.8672 36.3691 27.6172",
                stroke: "#FAFBFD",
                strokeWidth: "1.0575",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.2505 36.3672C14.0005 36.3672 11.5005 33.8672 11.5005 27.6172",
                stroke: "#FAFBFD",
                strokeWidth: "1.0575",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.0518 11.0156V18.5156L26.565 16.0156 M24.0513 18.5156L21.5381 16.0156",
                stroke: "#FAFBFD",
                strokeWidth: "1.0575",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                style: {
                    transformOrigin: "top"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("animateTransform", {
                    attributeName: "transform",
                    fill: "freeze",
                    type: "translate",
                    attributeType: "XML",
                    values: "0 -2;0 1;0 -2",
                    begin: "0s",
                    dur: "2s",
                    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1",
                    calcMode: "spline",
                    repeatCount: "indefinite"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.0518 36.875V29.375L26.565 31.875 M24.0513 29.375L21.5381 31.875",
                stroke: "#FAFBFD",
                strokeWidth: "1.0575",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                style: {
                    transformOrigin: "bottom"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("animateTransform", {
                    attributeName: "transform",
                    fill: "freeze",
                    type: "translate",
                    attributeType: "XML",
                    values: "0 2;0 -1;0 2",
                    begin: "0s",
                    dur: "2s",
                    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1",
                    calcMode: "spline",
                    repeatCount: "indefinite"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.89551 24.0547H17.3955L14.8955 26.5679 M17.3965 24.0523L14.8965 21.5391",
                stroke: "#FAFBFD",
                strokeWidth: "1.0575",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                style: {
                    transformOrigin: "bottom"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("animateTransform", {
                    attributeName: "transform",
                    fill: "freeze",
                    type: "translate",
                    attributeType: "XML",
                    values: "2 0;-1 0;2 0",
                    begin: "0s",
                    dur: "2s",
                    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1",
                    calcMode: "spline",
                    repeatCount: "indefinite"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.2158 24.0547H30.7158L33.2158 26.5679 M30.7163 24.0523L33.2163 21.5391",
                stroke: "#FAFBFD",
                strokeWidth: "1.0575",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                style: {
                    transformOrigin: "right"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("animateTransform", {
                    attributeName: "transform",
                    fill: "freeze",
                    type: "translate",
                    attributeType: "XML",
                    values: "-2 0;1 0;-2 0",
                    begin: "0s",
                    dur: "2s",
                    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1",
                    calcMode: "spline",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
var CommonDEFS = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        id: "common-defs",
        style: {
            position: "absolute"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    opacity: "0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "opacity",
                        id: "reset-anim",
                        values: "0;1",
                        begin: "outline-path-anim.end+0s",
                        dur: "2s"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "arrow-grow-icon",
                    d: "M25.248 22.7516L31.5105 16.4766H26.498 M31.5117 16.4766V21.4891",
                    stroke: "#FAFBFD",
                    strokeWidth: "1.0575",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    style: {
                        transformOrigin: "bottom left",
                        transformBox: "fill-box"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("animateTransform", {
                        id: "arrow-path-anim",
                        attributeName: "transform",
                        type: "scale",
                        begin: "0;reset-anim.end+0s",
                        values: "0;0.99;1",
                        keyTimes: "0;0.8;1",
                        keySplines: "0.2 0 0.2 1; 0 0 0.58 1",
                        calcMode: "spline",
                        dur: "0.9s",
                        fill: "freeze"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("path", {
                    id: "most-outline-path",
                    d: "M27.7129 36.4609C33.9629 36.4609 36.4629 33.961 36.4629 27.711V20.211C36.4629 13.961 33.9629 11.461 27.7129 11.461H20.2129C13.9629 11.461 11.4629 13.961 11.4629 20.211L11.4629 21.3118",
                    stroke: "#FAFBFD",
                    strokeWidth: "1.0575",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    opacity: "0",
                    pathLength: "1",
                    strokeDasharray: "1",
                    strokeDashoffset: "1",
                    style: {
                        transformOrigin: "bottom left",
                        transformBox: "fill-box"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                            id: "outline-path-anim",
                            attributeName: "stroke-dashoffset",
                            from: "1",
                            to: "0",
                            dur: "0.7s",
                            begin: "arrow-path-anim.end + 0.12s",
                            calcMode: "spline",
                            keySplines: "0.22 0 0.2 1",
                            fill: "freeze"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                            attributeName: "opacity",
                            from: "0",
                            to: "1",
                            dur: "0.3s",
                            begin: "arrow-path-anim.end + 0.12s",
                            calcMode: "spline",
                            keySplines: "0 0 0.58 1",
                            fill: "freeze"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                            id: "remove-path-anim",
                            attributeName: "opacity",
                            from: "1",
                            to: "0",
                            dur: "0.3s",
                            begin: "outline-path-anim.end+1.8s",
                            calcMode: "spline",
                            keySplines: "0.22 0 0.2 1",
                            fill: "freeze"
                        })
                    ]
                })
            ]
        })
    });
};
var PulsarAV1Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        style: {
            width: "100%",
            height: "100%"
        },
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "48",
                height: "48",
                rx: "7.5",
                fill: "#0080CC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37.2171 37.6484L30.9421 31.3859V36.3984 M30.9421 31.3906H35.9546",
                stroke: "#FAFBFD",
                strokeWidth: "1.0575",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                style: {
                    transformOrigin: "bottom right",
                    transformBox: "fill-box"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "translate",
                    values: "0 0;-3 -3; -0.5 -0.5; 0 0",
                    keyTimes: "0; 0.15; 0.95; 1",
                    calcMode: "spline",
                    keySplines: "0.2 0 0.2 1; 0.2 0 0.2 1; 0.2 0 0.2 1",
                    dur: "2.5s",
                    repeatCount: "indefinite"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.7924 10.3438L17.0674 16.6063V11.5938 M17.0674 16.6094H12.0549",
                stroke: "#FAFBFD",
                strokeWidth: "1.0575",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                style: {
                    transformOrigin: "top left",
                    transformBox: "fill-box"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "translate",
                    values: "0 0;3 3; 0.5 0.5; 0 0",
                    keyTimes: "0; 0.15; 0.95; 1",
                    calcMode: "spline",
                    keySplines: "0.2 0 0.2 1; 0.2 0 0.2 1; 0.2 0 0.2 1",
                    dur: "2.5s",
                    repeatCount: "indefinite"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.9653 10.4297H28.4653C34.7153 10.4297 37.2153 12.9297 37.2153 19.1797V26.6797",
                stroke: "#FAFBFD",
                strokeWidth: "1.0575",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27.1421 37.6484H19.6421C13.3921 37.6484 10.8921 35.1484 10.8921 28.8984V21.3984",
                stroke: "#FAFBFD",
                strokeWidth: "1.0575",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.4102 23.1172C28.9089 23.5038 28.9087 24.2685 28.4102 24.6553L28.2959 24.7324L22.7549 27.9316C22.104 28.3073 21.2903 27.8374 21.29 27.0859V20.6875C21.29 19.9358 22.1039 19.4659 22.7549 19.8418L28.2959 23.041L28.4102 23.1172Z",
                stroke: "#FAFBFD",
                strokeWidth: "1.0575",
                style: {
                    transformOrigin: "top left",
                    transformBox: "fill-box"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "scale",
                    values: "1 1; 0.75 0.75; 1.02 1.02; 1 1",
                    keyTimes: "0; 0.15; 0.95; 1",
                    calcMode: "spline",
                    keySplines: "0.2 0 0.2 1; 0.2 0 0.2 1; 0.2 0 0.2 1",
                    dur: "2.5s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
var PulsarAVIFIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        style: {
            width: "100%",
            height: "100%"
        },
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "48",
                height: "48",
                rx: "7.5",
                fill: "#0080CC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37.2164 37.6484L30.9414 31.3859V36.3984 M30.9414 31.3906H35.9539",
                stroke: "#FAFBFD",
                strokeWidth: "1.0575",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                style: {
                    transformOrigin: "bottom right",
                    transformBox: "fill-box"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "translate",
                    values: "0 0;-3 -3; -0.5 -0.5; 0 0",
                    keyTimes: "0; 0.15; 0.95; 1",
                    calcMode: "spline",
                    keySplines: "0.2 0 0.2 1; 0.2 0 0.2 1; 0.2 0 0.2 1",
                    dur: "2.5s",
                    repeatCount: "indefinite"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "mount-sun",
                style: {
                    transformOrigin: "center",
                    transformBox: "fill-box"
                },
                vectorEffect: "non-scaling-stroke",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23.145 23.3438C24.5257 23.3438 25.645 22.2245 25.645 20.8438C25.645 19.463 24.5257 18.3438 23.145 18.3438C21.7643 18.3438 20.645 19.463 20.645 20.8438C20.645 22.2245 21.7643 23.3438 23.145 23.3438Z",
                        stroke: "#FAFBFD",
                        strokeWidth: "1.0575",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.2026 32.5065L17.7691 27.1772C18.8213 26.3239 20.3397 26.4205 21.2854 27.4026L21.7249 27.8695C22.7638 28.9483 24.4421 28.9483 25.481 27.8695L31.0218 22.1216C32.0607 21.0428 33.7389 21.0428 34.7779 22.1216L36.9489 24.3757",
                        stroke: "#FAFBFD",
                        strokeWidth: "1.0575",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "scale",
                        values: "1 1; 0.55 0.65; 1.02 1.01; 1 1",
                        keyTimes: "0; 0.15; 0.95; 1",
                        calcMode: "spline",
                        keySplines: "0.2 0 0.2 1; 0.2 0 0.2 1; 0.2 0 0.2 1",
                        dur: "2.5s",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.7924 10.3438L17.0674 16.6063V11.5938 M17.0674 16.6016H12.0549",
                stroke: "#FAFBFD",
                strokeWidth: "1.0575",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                style: {
                    transformOrigin: "top left",
                    transformBox: "fill-box"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "translate",
                    values: "0 0;3 3; 0.5 0.5; 0 0",
                    keyTimes: "0; 0.15; 0.95; 1",
                    calcMode: "spline",
                    keySplines: "0.2 0 0.2 1; 0.2 0 0.2 1; 0.2 0 0.2 1",
                    dur: "2.5s",
                    repeatCount: "indefinite"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27.0425 37.5625H19.5425C13.2925 37.5625 10.7925 35.0625 10.7925 28.8125V21.3125",
                stroke: "#FAFBFD",
                strokeWidth: "1.0575",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.8657 10.3438H28.3657C34.6157 10.3438 37.1157 12.8438 37.1157 19.0938V26.5938",
                stroke: "#FAFBFD",
                strokeWidth: "1.0575",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var PulsarVQMIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        style: {
            width: "100%",
            height: "100%"
        },
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "48",
                height: "48",
                rx: "7.5",
                fill: "#0080CC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                    attributeName: "opacity",
                    id: "vqm-reset-anim",
                    values: "0;0",
                    dur: "2s",
                    begin: "arrow-head-anim.end+0"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.3068 36.9352H28.017C34.4422 36.9352 37.0123 34.3651 37.0123 27.9399V20.2297C37.0123 13.8045 34.4422 11.2344 28.017 11.2344H20.3068C13.8816 11.2344 11.3115 13.8045 11.3115 20.2297V27.9399C11.3115 34.3651 13.8816 36.9352 20.3068 36.9352Z",
                stroke: "#FAFBFD",
                strokeWidth: "1.0575",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30.0585 17.7689C28.6751 16.3563 27.1829 15.6666 25.3728 15.3547M17.4878 17.8095C15.6775 19.5825 14.7688 21.9287 14.7674 24.277M17.4878 17.8095L20.1788 20.5571M17.4878 17.8095C19.6497 15.6921 22.6023 14.8772 25.3728 15.3547M19.2055 28.4141L17.6519 30.2661C17.4926 30.456 17.2035 30.4676 17.0392 30.282C15.5219 28.5686 14.7662 26.4219 14.7674 24.277M14.7674 24.277L18.1992 24.3127M25.3728 15.3547L25.123 19.1925",
                stroke: "#FAFBFD",
                strokeWidth: "1.0575",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23.4124 24.0061C23.9032 23.8304 24.1587 23.29 23.9829 22.7992C23.8072 22.3083 23.2668 22.0529 22.776 22.2287C22.2851 22.4044 22.0297 22.9448 22.2054 23.4356C22.3812 23.9265 22.9216 24.1819 23.4124 24.0061Z",
                        stroke: "#FAFBFD",
                        strokeWidth: "1.0575",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20.9775 24.4609L22.1848 23.625",
                        stroke: "#FAFBFD",
                        strokeWidth: "1.0575",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23.8267 22.4609L27.1035 20.1919",
                        stroke: "#FAFBFD",
                        strokeWidth: "1.0575",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        values: "-30 23.35 23.95; 40 23.35 23.95; -30 23.35 23.95",
                        keyTimes: "0;0.5;1",
                        calcMode: "spline",
                        keySplines: "0.2 0 0.2 1; 0.2 0 0.2 1",
                        dur: "2.4s",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.6932 33.5318L24.4602 27.4958L30.6472 28.3977L33.7676 23.5669",
                stroke: "#FAFBFD",
                strokeWidth: "1.0575",
                strokeLinecap: "round",
                strokeDasharray: "1",
                strokeDashoffset: "1",
                pathLength: "1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                    id: "arrow-tail-anim",
                    attributeName: "stroke-dashoffset",
                    dur: "1s",
                    values: "1;0",
                    keyTimes: "0;1",
                    calcMode: "spline",
                    keySplines: "0.22 0 0.2 1",
                    fill: "freeze",
                    begin: "0;vqm-reset-anim.end+0"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("path", {
                d: "M31.4468 23.8984L33.8634 23.4596L34.3008 25.868",
                stroke: "#FAFBFD",
                strokeWidth: "1.0575",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeDasharray: "1",
                strokeDashoffset: "1",
                pathLength: "1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        id: "arrow-head-anim",
                        attributeName: "stroke-dashoffset",
                        values: "1;0",
                        keyTimes: "0;1",
                        dur: "0.3s",
                        begin: "arrow-tail-anim.end+0",
                        calcMode: "spline",
                        keySplines: "0.22 0 0.2 1",
                        fill: "freeze"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        id: "arrow-head-remove-anim",
                        attributeName: "opacity",
                        values: "1;0",
                        keyTimes: "0;1",
                        dur: "0.3s",
                        begin: "arrow-tail-anim.end+2.2s",
                        calcMode: "spline",
                        keySplines: "0.22 0 0.2 1",
                        fill: "freeze"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1",
                        keyTimes: "0;1",
                        dur: "0.3s",
                        begin: "arrow-head-remove-anim.end+1s",
                        calcMode: "spline",
                        keySplines: "0.22 0 0.2 1",
                        fill: "freeze"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../packages/global-styles/index.ts
var global_styles = __webpack_require__(9059);
;// CONCATENATED MODULE: ./components/NewHeader/CompanyNavList.tsx

function CompanyNavList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 16px;\n  animation: ",
        " 0.15s ease-in;\n\n  & a {\n    display: block;\n    padding: 16px;\n    color: ",
        ";\n  }\n  & > ul {\n    display: flex;\n  }\n  & a:hover {\n    transition: background 0.3s;\n    border-radius: 16px;\n    background: ",
        ";\n  }\n  & .nav-item {\n    width: 100%;\n  }\n  & .nav-item svg {\n    margin-bottom: 8px;\n  }\n  .icon-wrapper {\n    width: 48px;\n    height: 48px;\n    display: inline-block;\n  }\n"
    ]);
    CompanyNavList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var CompanyNavList = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyNavListContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "nav-item",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/about",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "icon-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutIcon, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextMStrong */.X9, {
                                    children: "About"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "nav-item",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/blog",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "icon-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogIcon, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextMStrong */.X9, {
                                    children: "Blog"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "nav-item",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/event",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "icon-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventIcon, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextMStrong */.X9, {
                                    children: "Event"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var NewHeader_CompanyNavList = (CompanyNavList);
var CompanyNavListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CompanyNavList__CompanyNavListContainer",
    componentId: "sc-b44823d7-0"
})(CompanyNavList_templateObject(), Home/* opacityAppear */.Mj, global_styles/* GRAY30 */.zm, global_styles/* BBPALE */.po);

// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./components/NewHeader/ProductNavList.tsx

function ProductNavList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: ",
        " 0.15s ease-in;\n\n  & a {\n    display: flex;\n    align-items: center;\n    color: ",
        ";\n    gap: 16px;\n  }\n  & > ul {\n    display: flex;\n  }\n  & .nav-item {\n    padding: 16px;\n    padding-bottom: 0;\n  }\n  & .nav-item:hover {\n    transition: background 0.3s;\n    border-radius: 16px;\n    background: ",
        ";\n  }\n  & .nav-item {\n    width: 280px;\n  }\n  .p-category {\n    color: ",
        ";\n    display: block;\n    margin-bottom: 16px;\n  }\n  .pp {\n    margin-top: 16px;\n  }\n  .feat-ul {\n    display: flex;\n    gap: 8px;\n    padding-block: 16px;\n    white-space: nowrap;\n  }\n  .feat-li {\n    padding: 4px 12px;\n    color: ",
        ";\n    border: 1px solid ",
        ";\n    border-radius: 18px;\n  }\n  .icon-wrapper {\n    width: 48px;\n    height: 48px;\n    display: inline-block;\n  }\n"
    ]);
    ProductNavList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var ProductNavList = function() {
    var locale = (0,next_router.useRouter)().locale;
    var deepFieldItems = [
        {
            label: "DeepField-SR",
            Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeepFieldSRIcon, {}),
            href: "/product/sr",
            features: {
                ko: [
                    "AI",
                    "업스케일링",
                    "4K"
                ],
                en: [
                    "AI",
                    "Upscale",
                    "4K"
                ]
            }
        },
        {
            label: "DeepField-PQO",
            Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeepFieldPQOIcon, {}),
            href: "/product/pqo",
            features: {
                ko: [
                    "AI",
                    "압축 코덱",
                    "화질개선"
                ],
                en: [
                    "AI",
                    "Codec",
                    "Imporved"
                ]
            }
        }, 
    ];
    var pulsarItems = [
        {
            label: "Pulsar-AV1",
            Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PulsarAV1Icon, {}),
            href: "/product/av1",
            features: {
                ko: [
                    "반도체",
                    "영상 압축",
                    "인코더"
                ],
                en: [
                    "Hardware",
                    "Video",
                    "Encoder"
                ]
            }
        },
        {
            label: "Pulsar-AVIF",
            Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PulsarAVIFIcon, {}),
            href: "/product/avif",
            features: {
                ko: [
                    "반도체",
                    "이미지 압축",
                    "인코더"
                ],
                en: [
                    "Hardware",
                    "Image",
                    "Encoder"
                ]
            }
        },
        {
            label: "Pulsar-VQM",
            Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PulsarVQMIcon, {}),
            href: "/product/vmaf",
            features: {
                ko: [
                    "VMAF",
                    "품질측정",
                    "비용절감"
                ],
                en: [
                    "VMAF",
                    "Measure",
                    "Costsave"
                ]
            }
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductNavListContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextSStrong */.dH, {
                className: "p-category",
                children: "DeepField"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: deepFieldItems.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: "nav-item",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: item.href,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "icon-wrapper",
                                            children: item.Icon
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextMStrong */.X9, {
                                            children: item.label
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "feat-ul",
                                children: item.features[locale].map(function(feature) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_styles/* BodyTextS */.Ei, {
                                        as: "li",
                                        className: "feat-li",
                                        children: [
                                            "#",
                                            feature
                                        ]
                                    }, item.label + feature);
                                })
                            })
                        ]
                    }, item.label);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextSStrong */.dH, {
                className: "p-category pp",
                children: "Pulsar"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: pulsarItems.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: "nav-item",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: item.href,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "icon-wrapper",
                                            children: item.Icon
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextMStrong */.X9, {
                                            children: item.label
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "feat-ul",
                                children: item.features[locale].map(function(feature) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_styles/* BodyTextS */.Ei, {
                                        as: "li",
                                        className: "feat-li",
                                        children: [
                                            "#",
                                            feature
                                        ]
                                    }, item.label + feature);
                                })
                            })
                        ]
                    }, item.label);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonDEFS, {})
        ]
    });
};
/* harmony default export */ var NewHeader_ProductNavList = (ProductNavList);
var ProductNavListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ProductNavList__ProductNavListContainer",
    componentId: "sc-d3dc0e71-0"
})(ProductNavList_templateObject(), Home/* opacityAppear */.Mj, global_styles/* GRAY30 */.zm, global_styles/* BBPALE */.po, global_styles/* GRAY60 */.Ts, global_styles/* GRAY60 */.Ts, global_styles/* GRAY90 */.cW);

// EXTERNAL MODULE: ../../packages/shared-utils/index.ts + 2 modules
var shared_utils = __webpack_require__(1748);
;// CONCATENATED MODULE: ./components/NewHeader/SubMenus.tsx


function _SubMenus_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      animation: ",
        " 0.15s ease-in;\n    "
    ]);
    _SubMenus_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  z-index: 999;\n  top: 100%;\n  left: 0;\n  right: 0;\n  animation: ",
        " 0.15s ease-in;\n\n  ",
        "\n\n  .inner-wrapper {\n    width: 968px;\n    margin: 0 auto;\n    border-radius: 16px;\n    background: #fff;\n    box-shadow: 0 4px 8px 2px rgba(0, 0, 0, 0.12);\n\n    position: relative;\n    transition: min-height 200ms ease;\n  }\n  .panel {\n    padding: 24px 48px;\n    position: absolute;\n    inset: 0;\n    opacity: 0;\n    transform: translateY(8px);\n    transition: opacity 150ms ease, transform 150ms ease, visibility 150ms;\n    visibility: hidden;\n    pointer-events: none;\n    will-change: opacity, transform;\n  }\n  .panel[data-open='true'] {\n    opacity: 1;\n    transform: translateY(0);\n    visibility: visible;\n    pointer-events: auto;\n  }\n  @media screen and (max-width: 1048px) {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var SubMenus = function(param) {
    var submenuType = param.submenuType, setSubmenuType = param.setSubmenuType;
    var ref = (0,_sliced_to_array/* default */.Z)((0,shared_utils/* useAnimation */._7)(submenuType !== null, 150), 2), isVisible = ref[0], showAnimation = ref[1];
    if (!isVisible && !showAnimation) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubMenusContainer, {
        showAnimation: showAnimation,
        onMouseOver: function() {
            setSubmenuType(submenuType);
        },
        onMouseLeave: function() {
            return setSubmenuType(null);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "inner-wrapper",
            style: {
                minHeight: submenuType === "company" ? "164px" : "396px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "panel",
                    "data-open": submenuType === "company",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewHeader_CompanyNavList, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "panel",
                    "data-open": submenuType === "product",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewHeader_ProductNavList, {})
                })
            ]
        })
    });
};
/* harmony default export */ var _SubMenus = (SubMenus);
var SubMenusContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "\bSubMenus__SubMenusContainer",
    componentId: "sc-643a83f5-0"
})(_templateObject1(), Home/* opacityAppear */.Mj, function(param) {
    var showAnimation = param.showAnimation;
    return showAnimation && (0,styled_components_browser_esm/* css */.iv)(_SubMenus_templateObject(), AppModal/* opacityDisappear */.c);
});

// EXTERNAL MODULE: ../../packages/assets/icons.tsx
var icons = __webpack_require__(1089);
// EXTERNAL MODULE: ./components/Global/index.ts + 16 modules
var Global = __webpack_require__(6402);
;// CONCATENATED MODULE: ./components/NewHeader/DesktopNavList.tsx

function DesktopNavList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      .nav-item:hover {\n        color: ",
        ";\n\n        svg {\n          path {\n            fill: ",
        ";\n          }\n        }\n      }\n\n      svg {\n        path {\n          fill: ",
        ";\n        }\n      }\n    "
    ]);
    DesktopNavList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DesktopNavList_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  z-index: 9999;\n  .nav-items {\n    position: absolute;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    text-transform: uppercase;\n    color: ",
        ";\n  }\n  .nav-item {\n    transition: 0.2s all;\n    white-space: nowrap;\n    cursor: pointer;\n    padding: 0 16px;\n    display: flex;\n    align-items: center;\n    height: 100%;\n    color: ",
        ";\n  }\n  .nav-item[data-is-selected='true'] {\n    color: ",
        ";\n  }\n  .nav-item + .nav-item {\n    padding-left: 32px;\n  }\n  .nav-item svg {\n    margin-left: 6px;\n  }\n  .nav-item svg path {\n    transition: 0.2s all;\n  }\n  .nav-item:hover {\n    color: #fff;\n    svg {\n      path {\n        fill: #fff;\n      }\n    }\n  }\n\n  a,\n  a:visited {\n    color: inherit;\n  }\n\n  ",
        ";\n\n  @media screen and (max-width: 1048px) {\n    display: none;\n  }\n"
    ]);
    DesktopNavList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var DesktopNavList = function(param) {
    var isScrolled = param.isScrolled, setSubmenuType = param.setSubmenuType;
    var asPath = (0,next_router.useRouter)().asPath;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DesktopNavListContainer, {
        isScrolled: isScrolled,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: "nav-items desk",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "nav-item",
                        onMouseOver: function() {
                            return setSubmenuType("company");
                        },
                        onMouseLeave: function() {
                            return setSubmenuType(null);
                        },
                        "data-is-selected": asPath.toLowerCase().includes("about") || asPath.toLowerCase().includes("blog") || asPath.toLowerCase().includes("event"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* ProductHeaderText */.q4, {
                            children: "COMPANY"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "nav-item",
                        onMouseOver: function() {
                            return setSubmenuType("product");
                        },
                        onMouseLeave: function() {
                            return setSubmenuType(null);
                        },
                        "data-is-selected": asPath.toLowerCase().includes("product"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* ProductHeaderText */.q4, {
                            children: "PRODUCT"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "nav-item",
                        onMouseOver: function() {
                            return setSubmenuType(null);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: "https://blue-dot.career.greetinghr.com/",
                            target: "_blank",
                            rel: "noreferrer",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* ProductHeaderText */.q4, {
                                    children: "CAREER"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* GoToIcon */.A5, {
                                    color: global_styles/* GRAY80 */.OD
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "nav-item",
                        onMouseOver: function() {
                            return setSubmenuType(null);
                        },
                        "data-is-selected": false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/product/avif/#product-section",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* ProductHeaderText */.q4, {
                                    children: "Image Optimization"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "nav-item",
                        onMouseOver: function() {
                            return setSubmenuType(null);
                        },
                        "data-is-selected": asPath.toLowerCase().includes("cloud"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "https://www.kokoon.cloud",
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                target: "_blank",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* ProductHeaderText */.q4, {
                                        children: "Cloud"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* GoToIcon */.A5, {
                                        color: "#fff"
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Global/* Dropdown */.Lt, {
                isScrolled: isScrolled,
                isOpen: true,
                handleToggleMenu: function() {}
            })
        ]
    });
};
/* harmony default export */ var NewHeader_DesktopNavList = (DesktopNavList);
var DesktopNavListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DesktopNavList__DesktopNavListContainer",
    componentId: "sc-5845e27b-0"
})(DesktopNavList_templateObject1(), global_styles/* PRODUCTSUB */.zJ, global_styles/* GRAY80 */.OD, function(param) {
    var isScrolled = param.isScrolled;
    return isScrolled ? "".concat(global_styles.BB) : "#fff";
}, function(param) {
    var isScrolled = param.isScrolled;
    return isScrolled && (0,styled_components_browser_esm/* css */.iv)(DesktopNavList_templateObject(), global_styles.BB, global_styles.BB, global_styles/* PRODUCTSUB */.zJ);
});

;// CONCATENATED MODULE: ./hooks/useAnimation.ts

var useAnimation = function(initialState, duration) {
    var ref = (0,react.useState)(initialState), isVisible = ref[0], setIsVisible = ref[1];
    var ref1 = (0,react.useState)(false), showAnimation = ref1[0], setShowAnimation = ref1[1];
    (0,react.useEffect)(function() {
        if (isVisible && !initialState) {
            setShowAnimation(true);
            setTimeout(function() {
                setShowAnimation(false);
            }, duration || 300);
        }
        setIsVisible(initialState);
    }, [
        isVisible,
        initialState,
        duration
    ]);
    return [
        isVisible,
        showAnimation
    ];
};

// EXTERNAL MODULE: ./hooks/useContactModal.ts
var useContactModal = __webpack_require__(2921);
;// CONCATENATED MODULE: ./components/NewHeader/NavList.tsx

function NavList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .link-item-list {\n  }\n  .link-item {\n    display: flex;\n    align-items: center;\n    color: ",
        ";\n    gap: 16px;\n    padding-left: 32px;\n  }\n  .link-item:first-of-type {\n    margin-top: 24px;\n  }\n  .l-link-item {\n    color: ",
        ";\n    align-items: center;\n    display: flex;\n    gap: 8px;\n  }\n  .l-link-item > svg {\n    margin-left: 8px;\n  }\n  .link-item + .link-item {\n    margin-top: 8px;\n  }\n  .link-list-wrapper {\n    padding-block: 16px;\n    display: block;\n  }\n  .icon-wrapper {\n    width: 32px;\n    height: 32px;\n  }\n"
    ]);
    NavList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var companyItems = [
    {
        label: "About",
        href: "/about",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutIcon, {})
    },
    {
        label: "Blog",
        href: "/blog",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogIcon, {})
    },
    {
        label: "Event",
        href: "/event",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventIcon, {})
    }, 
];
var productItems = [
    {
        label: "DeepField-SR",
        href: "/product/sr/#product-section",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeepFieldSRIcon, {})
    },
    {
        label: "DeepField-PQO",
        href: "/product/pqo/#product-section",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeepFieldPQOIcon, {})
    },
    {
        label: "Pulsar-AV1",
        href: "/product/av1/#product-section",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PulsarAV1Icon, {})
    },
    {
        label: "Pulsar-AVIF",
        href: "/product/avif/#product-section",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PulsarAVIFIcon, {})
    },
    {
        label: "Pulsar-VQM",
        href: "/product/vmaf/#product-section",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PulsarVQMIcon, {})
    }, 
];
var NavList = function(param) {
    var setIsOpen = param.setIsOpen;
    var router = (0,next_router.useRouter)();
    var handleMoveToContactUsPage = (0,useContactModal/* useContactModal */.s)().handleMoveToContactUsPage;
    (0,react.useEffect)(function() {
        var handleCloseIsOpenMobileNavMenu = function() {
            setIsOpen(false);
        };
        router.events.on("routeChangeComplete", handleCloseIsOpenMobileNavMenu);
        return function() {
            return router.events.off("routeChangeComplete", handleCloseIsOpenMobileNavMenu);
        };
    }, [
        router,
        setIsOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileNavAccordionContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "link-list-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* H4KR */.bJ, {
                        children: "COMPANY"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "link-item-list",
                        children: companyItems.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "link-item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "icon-wrapper",
                                        children: item.icon
                                    }),
                                    item.label === "Contact" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                                        as: "a",
                                        onClick: handleMoveToContactUsPage,
                                        style: {
                                            color: "#ccc",
                                            padding: "0"
                                        },
                                        children: item.label
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: item.href,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                                            as: "a",
                                            children: item.label
                                        })
                                    })
                                ]
                            }, item.href);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "link-list-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* H4KR */.bJ, {
                        children: "PRODUCT"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "link-item-list",
                        children: productItems.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "link-item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "icon-wrapper",
                                        children: item.icon
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: item.href,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                                            as: "a",
                                            children: item.label
                                        })
                                    })
                                ]
                            }, item.href);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_styles/* H4KR */.bJ, {
                as: "a",
                href: "https://blue-dot.career.greetinghr.com/",
                target: "_blank",
                rel: "noreferrer",
                className: "l-link-item link-list-wrapper",
                children: [
                    "CAREER",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* GoToIcon */.A5, {
                        color: global_styles/* GRAY60 */.Ts,
                        className: "goto-icon"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/product/avif#product-section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* H4KR */.bJ, {
                    as: "a",
                    className: "l-link-item link-list-wrapper",
                    children: "Image Optimization"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "https://www.kokoon.cloud",
                target: "_blank",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_styles/* H4KR */.bJ, {
                    as: "a",
                    target: "_blank",
                    className: "l-link-item link-list-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Cloud"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* GoToIcon */.A5, {
                            color: global_styles/* GRAY60 */.Ts,
                            className: "goto-icon"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonDEFS, {})
        ]
    });
};
var MobileNavAccordionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NavList__MobileNavAccordionContainer",
    componentId: "sc-aa330c16-0"
})(NavList_templateObject(), global_styles/* GRAY50 */.mu, global_styles/* GRAY30 */.zm);

;// CONCATENATED MODULE: ./components/NewHeader/MobileNavItems.tsx


function MobileNavItems_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      animation: ",
        " 0.2s;\n    "
    ]);
    MobileNavItems_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MobileNavItems_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-y: auto;\n  position: fixed;\n  z-index: 999;\n  top: 72px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  color: ",
        ";\n  background: #fff;\n  padding: 32px;\n  animation: ",
        " 0.2s;\n\n  ",
        ";\n\n  @media screen and (max-width: 1439px) {\n    top: 64px;\n  }\n  @media screen and (max-width: 1239px) {\n    top: 60px;\n  }\n  @media screen and (max-width: 600px) {\n    top: 56px;\n  }\n"
    ]);
    MobileNavItems_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var MobileNavItems = function(param) {
    var isOpen = param.isOpen, setIsOpen = param.setIsOpen;
    var ref = (0,_sliced_to_array/* default */.Z)(useAnimation(isOpen, 200), 2), isVisible = ref[0], showAnimation = ref[1];
    if (!isVisible && !showAnimation) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNavItemsContainer, {
        isVisible: isVisible,
        showAnimation: showAnimation,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "list-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavList, {
                setIsOpen: setIsOpen
            })
        })
    });
};
/* harmony default export */ var NewHeader_MobileNavItems = (MobileNavItems);
var MobileNavItemsContainer = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "MobileNavItems__MobileNavItemsContainer",
    componentId: "sc-5d78069-0"
})(MobileNavItems_templateObject1(), global_styles/* GRAY30 */.zm, Home/* opacityAppear */.Mj, function(param) {
    var showAnimation = param.showAnimation;
    return showAnimation && (0,styled_components_browser_esm/* css */.iv)(MobileNavItems_templateObject(), AppModal/* opacityDisappear */.c);
});

;// CONCATENATED MODULE: ./components/NewHeader/MobileNavList.tsx

function MobileNavList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  @media screen and (max-width: 1048px) {\n    display: block;\n  }\n"
    ]);
    MobileNavList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MobileNavList_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      .bar-top {\n        top: 50%;\n        transform: rotate(45deg) translate3d(0, -50%, 0);\n      }\n      .bar-bottom {\n        top: 50%;\n        left: 10%;\n        transform: rotate(-45deg) translate3d(0, -50%, 0);\n      }\n      .bar {\n        background: ",
        ";\n      }\n    "
    ]);
    MobileNavList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 48px;\n  height: 48px;\n  position: relative;\n  background: transparent;\n  display: block;\n  .bar-top {\n    top: 34.04%;\n    bottom: 59.57%;\n    left: 6.25%;\n  }\n  .bar-bottom {\n    left: 6.25%;\n    bottom: 36.17%;\n  }\n\n  .bar {\n    transition: all 0.2s;\n    position: absolute;\n    width: 42px;\n    height: 3px;\n    background: ",
        ";\n    transform-origin: center;\n  }\n  ",
        ";\n  @media screen and (min-width: 1049px) {\n    display: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var MobileNavList = function(param) {
    var isScrolled = param.isScrolled, setIsOpen = param.setIsOpen, isOpen = param.isOpen;
    var handleToggleIsOpen = function() {
        return setIsOpen(function(io) {
            return !io;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileNavListContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HamBurgerBtn, {
                onClick: handleToggleIsOpen,
                isOpen: isOpen,
                isScrolled: isScrolled,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "bar-top bar"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "bar-bottom bar"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewHeader_MobileNavItems, {
                isScrolled: isScrolled,
                isOpen: isOpen,
                setIsOpen: setIsOpen
            })
        ]
    });
};
/* harmony default export */ var NewHeader_MobileNavList = (MobileNavList);
var MobileNavListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MobileNavList__MobileNavListContainer",
    componentId: "sc-9bfc7faa-0"
})(MobileNavList_templateObject());
var HamBurgerBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "MobileNavList__HamBurgerBtn",
    componentId: "sc-9bfc7faa-1"
})(_templateObject2(), function(param) {
    var isScrolled = param.isScrolled;
    return isScrolled ? global_styles/* GRAY10 */.Ir : "#fff";
}, function(param) {
    var isOpen = param.isOpen;
    return isOpen && (0,styled_components_browser_esm/* css */.iv)(MobileNavList_templateObject1(), global_styles/* GRAY10 */.Ir);
});

;// CONCATENATED MODULE: ./components/NewHeader/index.tsx

function NewHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background: #fff;\n      box-shadow: 5px 1px 10px 1px rgba(95, 95, 95, 0.25);\n    "
    ]);
    NewHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NewHeader_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background: #fff;\n    "
    ]);
    NewHeader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NewHeader_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  z-index: 9999;\n  width: 100%;\n  height: 72px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 32px;\n  transition: 0.2s all;\n\n  ",
        ";\n\n  ",
        ";\n\n  @media screen and (max-width: 1439px) {\n    height: 64px;\n  }\n  @media screen and (max-width: 1239px) {\n    height: 60px;\n  }\n  @media screen and (max-width: 599px) {\n    height: 56px;\n    padding: 0 16px;\n  }\n"
    ]);
    NewHeader_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var HeaderPopupArea = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 878).then(__webpack_require__.bind(__webpack_require__, 4878));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4878)
            ];
        }
    },
    ssr: false
});
var useMediaQuery = function(query, onChange) {
    var mqlRef = (0,react.useRef)();
    (0,react.useEffect)(function() {
        if (false) {}
        var mql = window.matchMedia(query);
        mqlRef.current = mql;
        var handler = function(e) {
            return onChange === null || onChange === void 0 ? void 0 : onChange(e.matches);
        };
        if ("addEventListner" in mql) {
            mql.addEventListener("change", handler);
        } else {
            // polyfill for safari old version
            mql.addListener(handler);
        }
        return function() {
            if ("removeEventListner" in mql) {
                mql.removeEventListener("change", handler);
            } else {
                mql.addListener(handler);
            }
        };
    }, [
        query,
        onChange
    ]);
};
var useBodyScrollLock = function(isOpen) {
    (0,react.useEffect)(function() {
        if ( false || typeof document === "undefined") return;
        if (isOpen) document.body.style.overflowY = "hidden";
        else document.body.style.overflowY = "unset";
    }, [
        isOpen
    ]);
    (0,react.useEffect)(function() {
        if (false) {}
        // 지원하지 않는 브라우저 대비 try-catch
        try {
            window.history.scrollRestoration = "manual";
            window.scrollTo({
                top: 0
            });
        } catch (error) {
        // no-op
        }
    }, []);
};
var Index = function(param) {
    var isScrolled = param.isScrolled;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react.useState)(null), submenuType = ref1[0], setSubmenuType = ref1[1];
    var layoutRef = (0,react.useRef)();
    var handleMatchMedia = (0,react.useCallback)(function(matches) {
        if (matches) setIsOpen(false);
    }, []);
    // 전체 화면 크기 1048 이하일 경우 상태제어 hooks
    useMediaQuery("(max-width: 1048px)", handleMatchMedia);
    useBodyScrollLock(isOpen);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewHeaderContainer, {
        isScrolled: isScrolled,
        isOpen: isOpen,
        ref: layoutRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoArea, {
                isScrolled: isScrolled,
                isOpen: isOpen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewHeader_DesktopNavList, {
                isScrolled: isScrolled,
                setIsOpen: setIsOpen,
                setSubmenuType: setSubmenuType
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewHeader_MobileNavList, {
                isScrolled: isScrolled,
                setIsOpen: setIsOpen,
                isOpen: isOpen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(_SubMenus, {
                submenuType: submenuType,
                setSubmenuType: setSubmenuType
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderPopupArea, {})
        ]
    });
};
/* harmony default export */ var NewHeader = (Index);
var NewHeaderContainer = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    displayName: "NewHeader__NewHeaderContainer",
    componentId: "sc-e578d3ff-0"
})(NewHeader_templateObject2(), function(param) {
    var isScrolled = param.isScrolled;
    return isScrolled && (0,styled_components_browser_esm/* css */.iv)(NewHeader_templateObject());
}, function(param) {
    var isOpen = param.isOpen;
    return isOpen && (0,styled_components_browser_esm/* css */.iv)(NewHeader_templateObject1());
});


/***/ }),

/***/ 763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r8": function() { return /* reexport */ Contact; },
  "VR": function() { return /* reexport */ PrivatePolicyPopup; }
});

// UNUSED EXPORTS: ContactContainer, ContactPopup, ContactPopupContainer, PopupBackground, contactPopupOption, option

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var src_sliced_to_array = __webpack_require__(6383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(2228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
// EXTERNAL MODULE: ./locale/en.ts
var locale_en = __webpack_require__(4614);
// EXTERNAL MODULE: ./locale/ko.ts
var locale_ko = __webpack_require__(4804);
// EXTERNAL MODULE: ../../packages/assets/icons.tsx
var icons = __webpack_require__(1089);
// EXTERNAL MODULE: ../../packages/global-styles/index.ts
var global_styles = __webpack_require__(9059);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(6577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../packages/global-styles/MainButton.tsx
var global_styles_MainButton = __webpack_require__(8920);
// EXTERNAL MODULE: ./styles/breakPoints.ts
var breakPoints = __webpack_require__(3081);
// EXTERNAL MODULE: ./hooks/useContactModal.ts
var useContactModal = __webpack_require__(2921);
// EXTERNAL MODULE: ./components/Home/ProductTemplate.tsx
var ProductTemplate = __webpack_require__(8040);
;// CONCATENATED MODULE: ./public/asset/04-contact/main-contact-img@2x.png
/* harmony default export */ var main_contact_img_2x = ({"src":"/_next/static/media/main-contact-img@2x.4c877382.png","height":1601,"width":3840,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAJ1BMVEXJ1PDS2/W6w9uTlKSBfIO7yeTEzuqqr8nAyeNcYnaXnLF+h57e5P19iV2FAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAI0lEQVR4nGNgY2DkYWRi52JgZWBgYmVm5mZgZWBkYmZh4QQABTMAYb+nWFcAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(299);
;// CONCATENATED MODULE: ./components/Popup/Contact.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            margin-top: 56px;\n            height: 56px;\n          "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        animation: ",
        " 0.8s ease-in-out forwards;\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 640px;\n  position: relative;\n  @media screen and (min-width: 905px) {\n    height: 800px;\n  }\n  .inner-container {\n    opacity: 0;\n    ",
        ";\n    .contact-h2-kr {\n      color: ",
        ";\n      font-weight: 700;\n      margin-bottom: 32px;\n    }\n    .contact-subtitle-m {\n      color: ",
        ";\n    }\n    @media screen and (min-width: 1440px) {\n      width: 100%;\n      max-width: 1200px;\n      margin: 0 auto 286px;\n      padding-top: 146px;\n    }\n    @media screen and (min-width: 1240px) and (max-width: 1439px) {\n      width: calc(100% - 192px);\n      margin: 0 96px 296px;\n      padding-top: 146px;\n    }\n    @media screen and (min-width: 905px) and (max-width: 1239px) {\n      width: calc(100% - 112px);\n      margin: 0 56px 223px;\n      padding-top: 96px;\n    }\n    @media screen and (min-width: 600px) and (max-width: 904px) {\n      width: calc(100% - 64px);\n      margin: 0 32px 364px;\n      padding-top: 56px;\n    }\n    @media screen and (max-width: 599px) {\n      width: calc(100% - 32px);\n      margin: 0 16px 336px;\n      padding-top: 56px;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}














var Contact_option = {
    rootMargin: "0px",
    threshold: 0.4
};
var Contact = function() {
    var handleMoveToContactUsPage = (0,useContactModal/* useContactModal */.s)().handleMoveToContactUsPage;
    var ref = (0,src_sliced_to_array/* default */.Z)((0,react_intersection_observer_modern/* useInView */.YD)({
        threshold: 0.4,
        fallbackInView: true
    }), 2), targetRef = ref[0], isVisible = ref[1];
    var locale = (0,router.useRouter)().locale;
    var t = locale === "en" ? locale_en/* default */.Z : locale_ko/* default */.Z;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactContainer, {
        isVisible: isVisible,
        ref: targetRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: main_contact_img_2x.src,
                layout: "fill",
                alt: "",
                objectFit: "cover"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "inner-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* H2KR */.Zj, {
                        className: "contact-h2-kr",
                        children: t.contact.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                        className: "contact-subtitle-m",
                        children: t.contact.texts[0]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                        className: "contact-subtitle-m",
                        children: t.contact.texts[1]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                        className: "contact-subtitle-m",
                        children: t.contact.texts[2]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles_MainButton/* MainButton */.c, {
                        text: t.contact.buttonText,
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* NormalArrowIcon */.LS, {
                            color: global_styles.BB
                        }),
                        buttonType: "default",
                        onClick: handleMoveToContactUsPage,
                        injectInlineStyles: {
                            width: "328px"
                        },
                        injectCssStyles: [
                            (0,breakPoints/* generateCssStyle */.m)({
                                height: "48px",
                                "margin-top": "32px"
                            }),
                            breakPoints/* mediaQueryStyle.L */.Pm.L(_templateObject()), 
                        ]
                    })
                ]
            })
        ]
    });
};
var ContactContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "Contact__ContactContainer",
    componentId: "sc-25dc5d54-0"
})(_templateObject2(), function(param) {
    var isVisible = param.isVisible;
    return isVisible && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), ProductTemplate/* opacityAppear */.Mj);
}, global_styles.BB, global_styles.BB);

// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(8316);
// EXTERNAL MODULE: ./components/Global/index.ts + 16 modules
var Global = __webpack_require__(6402);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/Common/CommonWrappers.tsx
var CommonWrappers = __webpack_require__(5564);
// EXTERNAL MODULE: ./react-query/zendeskApi.ts
var zendeskApi = __webpack_require__(9222);
;// CONCATENATED MODULE: ./components/Popup/ContactPopup.tsx


function ContactPopup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 40%;\n  @media screen and (max-width: 599px) {\n    width: 100%;\n  }\n"
    ]);
    ContactPopup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ContactPopup_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 60%;\n  margin-left: 8px;\n  @media screen and (max-width: 599px) {\n    width: 100%;\n    margin-left: 0;\n    margin-top: 8px;\n  }\n"
    ]);
    ContactPopup_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ContactPopup_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 50%;\n  @media screen and (max-width: 599px) {\n    width: 100%;\n    margin-top: 8px;\n  }\n"
    ]);
    ContactPopup_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 50%;\n  margin-left: 8px;\n  @media screen and (max-width: 599px) {\n    width: 100%;\n    margin-left: 0;\n    margin-top: 8px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n  max-height: 1155px;\n  min-height: 576px;\n  height: 100%;\n  width: 750px;\n  line-height: 24px;\n  position: relative;\n  z-index: 1;\n\n  @media screen and (max-width: 904px) and (min-width: 600px) {\n    width: 600px;\n  }\n  @media screen and (max-width: 599px) {\n    width: 360px;\n  }\n\n  header {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 56px;\n    color: ",
        ";\n  }\n  .scrollable {\n    height: calc(100% - 56px - 160px);\n    padding: 32px;\n    overflow-y: auto;\n    @media screen and (max-width: 599px) {\n      padding: 16px;\n    }\n  }\n  .query-kind {\n    margin-bottom: 32px;\n  }\n  .query-kind-title {\n    margin-bottom: 8px;\n  }\n  .first-row,\n  .second-row,\n  .last-row {\n    display: flex;\n    @media screen and (max-width: 599px) {\n      flex-wrap: wrap;\n    }\n  }\n  .first-row {\n    margin-top: 8px;\n  }\n  .second-row {\n    margin-top: 8px;\n    @media screen and (max-width: 599px) {\n      margin-top: 0;\n    }\n  }\n  .last-row {\n    margin-top: 8px;\n    flex-direction: column;\n    text-align: right;\n    color: ",
        ";\n    textarea {\n      width: 100%;\n      height: 160px;\n      resize: none;\n    }\n  }\n\n  .policy {\n    margin-top: 32px;\n  }\n  .policy-area {\n    margin-top: 8px;\n    border: 1px solid ",
        ";\n    padding: 16px;\n    border-radius: 4px;\n    color: ",
        ";\n  }\n  .guide-title {\n    text-align: center;\n  }\n  .guide-area {\n    color: ",
        ";\n    margin-top: 8px;\n    margin-bottom: 16px;\n    text-align: center;\n  }\n  .guide-text-area {\n    width: 100%;\n    line-height: 24px;\n    display: flex;\n    justify-content: center;\n  }\n  .guide-text-area > * {\n    width: calc(100% - 100px);\n  }\n  .contact-info {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 16px;\n    padding: 16px 32px;\n    background: ",
        ";\n    border-radius: 12px;\n    @media screen and (max-width: 599px) {\n      width: 100%;\n      margin-top: 16px;\n      flex-direction: column;\n    }\n  }\n  .contact-info-l,\n  .contact-info-r {\n    padding-left: 16px;\n    width: 100%;\n    color: ",
        ";\n    @media screen and (max-width: 599px) {\n      padding-left: 0;\n      display: flex;\n      align-items: center;\n      flex-direction: column;\n    }\n  }\n\n  .contact-info-l {\n    @media screen and (max-width: 599px) {\n      padding-bottom: 8px;\n    }\n  }\n  .contact-info-r {\n    position: relative;\n    @media screen and (max-width: 599px) {\n      padding-top: 8px;\n    }\n  }\n  .contact-info-r::after {\n    content: '';\n    position: absolute;\n    display: inline-block;\n    width: 1px;\n    height: 50px;\n    left: 0;\n    top: 0;\n    background: ",
        ";\n    @media screen and (max-width: 599px) {\n      width: 40px;\n      height: 1px;\n      left: 50%;\n      top: 0;\n      transform: translateX(-50%);\n    }\n  }\n  .contact-info-l .contact-info-item {\n    width: 170px;\n  }\n  .s-title {\n    margin-right: 8px;\n  }\n  .s-title.ir {\n    padding-left: 25px;\n    @media screen and (max-width: 600px) {\n      padding-left: 5px;\n    }\n  }\n  .contact-info-item {\n    display: flex;\n    align-items: center;\n    svg {\n      margin-right: 8px;\n    }\n  }\n  & .l-b {\n    width: 100%;\n    height: 1px;\n    background: ",
        ";\n    margin-bottom: 32px;\n  }\n\n  .close-contact-btn {\n    width: 48px;\n    height: 48px;\n    position: absolute;\n    right: 0;\n    background: transparent;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .modal-bottom-area {\n    height: 160px;\n    width: 100%;\n    padding: 16px 0 32px;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    position: relative;\n    .gradation {\n      top: -32px;\n      width: 100%;\n      height: 32px;\n      position: absolute;\n      object-fit: cover;\n    }\n  }\n  .checkbox-wrapper {\n    display: flex;\n    align-items: center;\n    height: 48px;\n    margin-bottom: 4px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  min-height: 640px;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n  height: 100vh;\n  height: calc(var(--vh, 1vh) * 100);\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 56px 0;\n  @media screen and (max-width: 1239px) and (min-width: 600px) {\n    padding: 32px 0;\n  }\n  @media screen and (max-width: 1239px) {\n    padding: 32px 0;\n  }\n  .close-floating-button {\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    background: ",
        ";\n    position: fixed;\n    bottom: 56px;\n    right: 32px;\n    @media screen and (max-width: 904px) and (min-width: 600px) {\n      bottom: 32px;\n      right: 32px;\n      width: 45px;\n      height: 45px;\n    }\n    @media screen and (max-width: 599px) {\n      width: 45px;\n      height: 45px;\n      bottom: 32px;\n      right: 16px;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




















var contactPopupOption = {
    rootMargin: "0px",
    threshold: 1
};
var EMAIL_VALIDATE_REGEXP = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}$/g;
var ContactPopup = function(param) {
    var handleCloseContact = param.handleCloseContact;
    var ref, ref1;
    var locale = useRouter().locale;
    var ref2 = useSendZendiskTicketMutation(), mutate = ref2.mutate, isLoading = ref2.isLoading, isSuccess = ref2.isSuccess, error = ref2.error;
    var t = locale === "en" ? en : ko;
    var firstQueryKindState = t.contactPopup.inputGuide.options[0];
    var ref3 = useState(firstQueryKindState), queryKind = ref3[0], setQueryKind = ref3[1];
    var ref4 = useState(""), name = ref4[0], setName = ref4[1];
    var ref5 = useState(""), email = ref5[0], setEmail = ref5[1];
    var ref6 = useState(""), contact = ref6[0], setContact = ref6[1];
    var ref7 = useState(""), company = ref7[0], setCompany = ref7[1];
    var ref8 = useState(""), message = ref8[0], setMessage = ref8[1];
    var ref9 = useState(false), agree = ref9[0], setAgree = ref9[1];
    var isSatisfied = useMemo(function() {
        return queryKind !== "" && name.length !== 0 && EMAIL_VALIDATE_REGEXP.test(email) && message.length >= 5 && agree;
    }, [
        name,
        email,
        message,
        agree,
        queryKind
    ]);
    var ref10 = _sliced_to_array(useInView({
        fallbackInView: true
    }), 2), observerRef = ref10[0], isVisible = ref10[1];
    var formRef = useRef(null);
    var $portal = document.querySelector("#portal");
    var handleOpenPrivatePolicyModal = usePrivatePolicyModal().handleOpenPrivatePolicyModal;
    var handleSubmitZendeskTicket = function() {
        if (!isSatisfied) return;
        mutate({
            name: name,
            email: email.trim() || "",
            contact: contact,
            company: company,
            queryKind: queryKind,
            message: message
        });
    };
    if (!$portal) return null;
    if (error) return /*#__PURE__*/ ReactDOM.createPortal(/*#__PURE__*/ _jsx(PopupBackground, {
        children: /*#__PURE__*/ _jsx(BasicPopup, {
            headerText: "Complete",
            bodyText: isAxiosError(error) ? (error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || "Unknown Error." : "Unknown Error.",
            closeBtnFn: handleCloseContact,
            buttonFn: handleCloseContact
        })
    }), $portal);
    if (isSuccess) return /*#__PURE__*/ ReactDOM.createPortal(/*#__PURE__*/ _jsx(PopupBackground, {
        children: /*#__PURE__*/ _jsx(BasicPopup, {
            headerText: "Complete",
            bodyText: t.contactPopup.privacyPolicy.completeText,
            closeBtnFn: handleCloseContact,
            buttonFn: handleCloseContact
        })
    }), $portal);
    return /*#__PURE__*/ ReactDOM.createPortal(/*#__PURE__*/ _jsxs(PopupBackground, {
        children: [
            /*#__PURE__*/ _jsxs(ContactPopupContainer, {
                children: [
                    /*#__PURE__*/ _jsxs("header", {
                        children: [
                            /*#__PURE__*/ _jsx(BodyTextLStrong, {
                                children: "Contact"
                            }),
                            /*#__PURE__*/ _jsx("button", {
                                className: "close-contact-btn",
                                onClick: handleCloseContact,
                                children: /*#__PURE__*/ _jsx(CloseIcon, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("form", {
                        className: "scrollable",
                        ref: formRef,
                        children: [
                            /*#__PURE__*/ _jsx(SubtitleM, {
                                className: "guide-title",
                                children: t.contactPopup.title
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "guide-area",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "guide-text-area",
                                        children: /*#__PURE__*/ _jsx(BodyTextS, {
                                            children: t.contactPopup.guideTexts[0]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "contact-info",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "contact-info-l",
                                                children: /*#__PURE__*/ _jsxs(BodyTextS, {
                                                    className: "contact-info-item",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(EmailIcon, {
                                                            color: GRAY60
                                                        }),
                                                        " contact@blue-dot.io"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "contact-info-r",
                                                children: [
                                                    /*#__PURE__*/ _jsxs(BodyTextS, {
                                                        className: "contact-info-item",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(CallIcon, {}),
                                                            /*#__PURE__*/ _jsx(BodyTextS, {
                                                                className: "s-title",
                                                                children: "Sales"
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                children: "+82 2 6205 0814"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs(BodyTextS, {
                                                        className: "contact-info-item",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(BodyTextS, {
                                                                className: "s-title ir",
                                                                children: "IR"
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                children: "+82 2 6205 0812"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "l-b"
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "query-kind",
                                children: [
                                    /*#__PURE__*/ _jsx(BodyTextLStrong, {
                                        className: "query-kind-title",
                                        children: t.contactPopup.inputGuide.inputTitle
                                    }),
                                    /*#__PURE__*/ _jsx(BasicDropdown, {
                                        onClickOptions: setQueryKind,
                                        width: "320px",
                                        value: queryKind,
                                        options: t.contactPopup.inputGuide.options
                                    }),
                                    /*#__PURE__*/ _jsx("input", {
                                        value: queryKind,
                                        readOnly: true,
                                        name: "contact_type",
                                        className: "a11y-hidden"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "query-contents",
                                children: [
                                    /*#__PURE__*/ _jsx(BodyTextLStrong, {
                                        className: "query-contents-title",
                                        children: t.contactPopup.inputGuide.enterMessage
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "first-row",
                                        children: [
                                            /*#__PURE__*/ _jsx(NameInput, {
                                                placeholder: t.contactPopup.privacyPolicy.placeholders.name,
                                                disabled: false,
                                                name: "from_name",
                                                value: name,
                                                spellCheck: false,
                                                onChange: function(e) {
                                                    return setName(e.target.value);
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx(EmailInput, {
                                                placeholder: t.contactPopup.privacyPolicy.placeholders.email,
                                                type: "email",
                                                disabled: false,
                                                name: "from_email",
                                                value: email,
                                                spellCheck: false,
                                                onChange: function(e) {
                                                    return setEmail(e.target.value);
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "second-row",
                                        children: [
                                            /*#__PURE__*/ _jsx(ContactInput, {
                                                placeholder: t.contactPopup.privacyPolicy.placeholders.contact,
                                                disabled: false,
                                                name: "from_contact",
                                                value: contact,
                                                spellCheck: false,
                                                onChange: function(e) {
                                                    return setContact(e.target.value);
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx(CompanyInput, {
                                                placeholder: t.contactPopup.privacyPolicy.placeholders.company,
                                                type: "email",
                                                disabled: false,
                                                name: "from_company",
                                                value: company,
                                                spellCheck: false,
                                                onChange: function(e) {
                                                    return setCompany(e.target.value);
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "last-row",
                                        children: [
                                            /*#__PURE__*/ _jsx(BasicInput, {
                                                as: "textarea",
                                                name: "message",
                                                placeholder: t.contactPopup.privacyPolicy.placeholders.message,
                                                disabled: false,
                                                value: message,
                                                maxLength: 500,
                                                spellCheck: false,
                                                onChange: function(e) {
                                                    return setMessage(e.target.value);
                                                }
                                            }),
                                            /*#__PURE__*/ _jsxs(BodyTextM, {
                                                className: "indita",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: (message === null || message === void 0 ? void 0 : message.length) || 0
                                                    }),
                                                    " / 500"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "policy",
                                children: [
                                    /*#__PURE__*/ _jsx(BodyTextLStrong, {
                                        children: t.contactPopup.privacyPolicy.title
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "policy-area",
                                        children: [
                                            /*#__PURE__*/ _jsx(BodyTextM, {
                                                children: t.contactPopup.privacyPolicy.policies[0]
                                            }),
                                            /*#__PURE__*/ _jsx(BodyTextM, {
                                                children: t.contactPopup.privacyPolicy.policies[1]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "ot",
                                        ref: observerRef
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "modal-bottom-area",
                        children: [
                            !isVisible && /*#__PURE__*/ _jsx("div", {
                                className: "gradation",
                                children: /*#__PURE__*/ _jsx(ImgBackgroundWrapper, {
                                    isNormalUse: true,
                                    children: /*#__PURE__*/ _jsx(Image, {
                                        src: "/asset/04-contact/g-bottom.png",
                                        layout: "fill",
                                        alt: "bluedot",
                                        className: "banner-img",
                                        quality: 70,
                                        sizes: "(min-width: 906px) 90vw, (min-width: 600px) 85vw, (max-width: 599px) 75vw"
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "checkbox-wrapper",
                                children: /*#__PURE__*/ _jsx(CustomizedCheckbox, {
                                    labelComponent: locale === "en" ? /*#__PURE__*/ _jsxs(ButtonText1, {
                                        children: [
                                            "I Agree with the",
                                            /*#__PURE__*/ _jsx(ButtonText1, {
                                                as: "button",
                                                onClick: function(e) {
                                                    e.stopPropagation();
                                                    handleOpenPrivatePolicyModal();
                                                },
                                                style: {
                                                    color: BB,
                                                    textDecoration: "underline"
                                                },
                                                children: "Privacy policy."
                                            })
                                        ]
                                    }) : /*#__PURE__*/ _jsxs(ButtonText1, {
                                        children: [
                                            /*#__PURE__*/ _jsx(ButtonText1, {
                                                as: "button",
                                                onClick: function(e) {
                                                    e.stopPropagation();
                                                    handleOpenPrivatePolicyModal();
                                                },
                                                style: {
                                                    color: BB,
                                                    textDecoration: "underline",
                                                    padding: 0
                                                },
                                                children: "개인정보처리방침"
                                            }),
                                            "에 동의합니다."
                                        ]
                                    }),
                                    isChecked: agree,
                                    onClick: function() {
                                        setAgree(function(agree) {
                                            return !agree;
                                        });
                                    },
                                    onKeyDown: function() {
                                        setAgree(function(agree) {
                                            return !agree;
                                        });
                                    },
                                    htmlId: "agree",
                                    disabled: false
                                })
                            }),
                            /*#__PURE__*/ _jsx(MainButton, {
                                buttonType: isLoading || !isSatisfied ? "disabled" : "default",
                                text: isLoading ? t.contactPopup.privacyPolicy.buttonText[0] : t.contactPopup.privacyPolicy.buttonText[1],
                                icon: isLoading ? undefined : /*#__PURE__*/ _jsx(EmailIcon, {}),
                                onClick: handleSubmitZendeskTicket,
                                injectInlineStyles: {
                                    width: "328px",
                                    height: "56px"
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("button", {
                className: "close-floating-button",
                onClick: handleCloseContact,
                children: /*#__PURE__*/ _jsx(CloseIcon, {
                    color: "#fff"
                })
            })
        ]
    }), $portal);
};
var NameInput = (0,styled_components_browser_esm/* default */.ZP)(Global/* BasicInput */.Fk).withConfig({
    displayName: "ContactPopup__NameInput",
    componentId: "sc-a95b575a-0"
})(ContactPopup_templateObject());
var EmailInput = (0,styled_components_browser_esm/* default */.ZP)(Global/* BasicInput */.Fk).withConfig({
    displayName: "ContactPopup__EmailInput",
    componentId: "sc-a95b575a-1"
})(ContactPopup_templateObject1());
var ContactInput = (0,styled_components_browser_esm/* default */.ZP)(Global/* BasicInput */.Fk).withConfig({
    displayName: "ContactPopup__ContactInput",
    componentId: "sc-a95b575a-2"
})(ContactPopup_templateObject2());
var CompanyInput = (0,styled_components_browser_esm/* default */.ZP)(Global/* BasicInput */.Fk).withConfig({
    displayName: "ContactPopup__CompanyInput",
    componentId: "sc-a95b575a-3"
})(_templateObject3());
var ContactPopupContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "ContactPopup__ContactPopupContainer",
    componentId: "sc-a95b575a-4"
})(_templateObject4(), global_styles.BB, global_styles/* GRAY70 */.Q2, global_styles/* GRAY80 */.OD, global_styles/* GRAY70 */.Q2, global_styles/* GRAY60 */.Ts, global_styles/* GRAYBG */.lm, global_styles/* GRAY60 */.Ts, global_styles/* GRAY90 */.cW, global_styles/* GRAY90 */.cW);
var PopupBackground = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ContactPopup__PopupBackground",
    componentId: "sc-a95b575a-5"
})(_templateObject5(), global_styles/* GRAY10 */.Ir);

// EXTERNAL MODULE: ./locale/privacyPolicy.ts
var privacyPolicy = __webpack_require__(9014);
;// CONCATENATED MODULE: ./components/Popup/PrivatePolicyPopup.tsx


function PrivatePolicyPopup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  .ot {\n    display: block;\n    width: 100%;\n  }\n  .mid {\n    position: relative;\n    text-align: center;\n    padding: 32px 32px 0 32px;\n  }\n  .pri-gradation.top {\n    transform: rotate(180deg);\n    top: 100px;\n    left: 0;\n  }\n  .mid-last-up {\n    margin-bottom: 16px;\n    color: ",
        ";\n  }\n  .mid-desc {\n    margin-bottom: 32px;\n    text-align: left;\n    color: ",
        ";\n  }\n  .scrollable {\n    padding: 0 32px 32px;\n    height: calc(100% - 186px - 88px);\n    overflow-y: auto;\n  }\n  .policy {\n    margin-top: 0px;\n  }\n  .modal-bottom-area {\n    height: 104px;\n    padding: 16px 0 32px;\n  }\n  .pol-box {\n    color: ",
        ";\n  }\n  .pol-box + .pol-box {\n    margin-top: 32px;\n  }\n  .pol-desc {\n    color: ",
        ";\n    white-space: pre-line;\n  }\n  .pri-gradation {\n    top: -32px;\n    width: 100%;\n    height: 32px;\n    position: absolute;\n    object-fit: cover;\n  }\n  @media screen and (max-width: 599px) {\n    .scrollable {\n      padding: 0 16px 16px;\n    }\n    .policy {\n      padding: 0;\n    }\n  }\n"
    ]);
    PrivatePolicyPopup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var PrivatePolicyPopup = function(param) {
    var handleClosePrivatePolicy = param.handleClosePrivatePolicy;
    var locale = (0,router.useRouter)().locale;
    var ref = (0,src_sliced_to_array/* default */.Z)((0,react_intersection_observer_modern/* useInView */.YD)({
        threshold: 1,
        fallbackInView: true
    }), 2), observerRef = ref[0], isVisible = ref[1];
    var $portal = document.querySelector("#portal");
    var articleArray = locale === "en" ? privacyPolicy.en.articles : privacyPolicy.ko.articles;
    if (!$portal) return null;
    return /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ (0,jsx_runtime.jsx)(PopupBackground, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PrivatePopupContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextLStrong */.zY, {
                            children: "Privacy Policy"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "close-contact-btn",
                            onClick: handleClosePrivatePolicy,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIcon */.Tw, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mid",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                            className: "mid-title",
                            children: locale === "en" ? "BLUEDOT Privacy policy" : "블루닷 개인정보처리방침"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextMStrong */.X9, {
                            className: "mid-last-up",
                            children: locale === "en" ? "2022.09.07 last updated" : "2022.09.07 마지막으로 업데이트 됨"
                        }),
                        !isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pri-gradation top",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonWrappers/* ImgBackgroundWrapper */.Yo, {
                                isNormalUse: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/asset/04-contact/g-bottom.png",
                                    layout: "fill",
                                    alt: "bluedot",
                                    className: "banner-img",
                                    quality: 70,
                                    sizes: "(min-width: 906px) 90vw, (min-width: 600px) 85vw, (max-width: 599px) 75vw"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "scrollable",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "policy",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "ot",
                                ref: observerRef
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextS */.Ei, {
                                className: "mid-desc",
                                children: locale === "en" ? privacyPolicy.en.midDesc : privacyPolicy.ko.midDesc
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "policy-area",
                                children: articleArray.map(function(art) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "pol-box",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextMStrong */.X9, {
                                                children: art.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextS */.Ei, {
                                                as: "pre",
                                                className: "pol-desc",
                                                children: art.desc
                                            })
                                        ]
                                    }, art.title);
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "modal-bottom-area",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pri-gradation",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonWrappers/* ImgBackgroundWrapper */.Yo, {
                                isNormalUse: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/asset/04-contact/g-bottom.png",
                                    layout: "fill",
                                    alt: "bluedot",
                                    className: "banner-img",
                                    quality: 70,
                                    sizes: "(min-width: 906px) 90vw, (min-width: 600px) 85vw, (max-width: 599px) 75vw"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles_MainButton/* MainButton */.c, {
                            onClick: handleClosePrivatePolicy,
                            buttonType: "default",
                            text: "확인",
                            injectInlineStyles: {
                                width: "328px",
                                height: "56px"
                            }
                        })
                    ]
                })
            ]
        })
    }), $portal);
};
var PrivatePopupContainer = (0,styled_components_browser_esm/* default */.ZP)(ContactPopupContainer).withConfig({
    displayName: "PrivatePolicyPopup__PrivatePopupContainer",
    componentId: "sc-efc4a7a1-0"
})(PrivatePolicyPopup_templateObject(), global_styles/* GRAY70 */.Q2, global_styles/* GRAY50 */.mu, global_styles/* GRAY50 */.mu, global_styles/* GRAY70 */.Q2);

;// CONCATENATED MODULE: ./components/Popup/index.ts





/***/ }),

/***/ 2921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ usePrivatePolicyModal; },
/* harmony export */   "s": function() { return /* binding */ useContactModal; }
/* harmony export */ });
/* harmony import */ var context_AppContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9941);
/* harmony import */ var context_PrivatePolicyContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5909);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);




var useContactModal = function() {
    var push = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().push;
    var ref = (0,context_AppContext__WEBPACK_IMPORTED_MODULE_0__/* .useAppContext */ .b)(), isContactModalOpen = ref.state.isContactModalOpen, dispatch = ref.dispatch;
    var handleMoveToContactUsPage = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        push("/contact");
    }, [
        push
    ]);
    var handleOpenContactModal = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        return dispatch({
            type: "open"
        });
    }, [
        dispatch
    ]);
    var handleCloseContactModal = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        return dispatch({
            type: "close"
        });
    }, [
        dispatch
    ]);
    return {
        isContactModalOpen: isContactModalOpen,
        handleMoveToContactUsPage: handleMoveToContactUsPage,
        handleOpenContactModal: handleOpenContactModal,
        handleCloseContactModal: handleCloseContactModal
    };
};
var usePrivatePolicyModal = function() {
    var ref = (0,context_PrivatePolicyContext__WEBPACK_IMPORTED_MODULE_1__/* .usePrivatePolicyContext */ .a)(), isPrivatePolicyModalOpen = ref.state.isPrivatePolicyModalOpen, dispatch = ref.dispatch;
    var handleOpenPrivatePolicyModal = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        return dispatch({
            type: "open"
        });
    }, [
        dispatch
    ]);
    var handleClosePrivatePolicyModal = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        return dispatch({
            type: "close"
        });
    }, [
        dispatch
    ]);
    return {
        isPrivatePolicyModalOpen: isPrivatePolicyModalOpen,
        handleOpenPrivatePolicyModal: handleOpenPrivatePolicyModal,
        handleClosePrivatePolicyModal: handleClosePrivatePolicyModal
    };
};


/***/ }),

/***/ 4614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var public_asset_03_section2_content1_content1_2x_png__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9540);
/* harmony import */ var public_asset_03_section2_content2_content2_2x_png__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7388);
/* harmony import */ var public_asset_03_section2_content3_content3_2x_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5744);
/* harmony import */ var public_asset_03_section2_content4_content4_2x_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7027);
/* harmony import */ var public_asset_03_section2_content5_content5_2x_png__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4656);





var en = {
    metaTag: {
        title: "BLUEDOT | Video AI & Codec technology IP provider",
        description: "BLUEDOT develops Semiconductor IP on FPGA in data center to accelerate Video Processing and Video Encoding, delivering functions as a service.",
        keywords: "BLUEDOT, FPGA, Semiconductor IP, AV1, Xilinx, Cloud Computing, Super Resolution, AI Video Upscaling",
        og_type: "website",
        og_title: "BLUEDOT",
        og_description: "BLUEDOT develops Semiconductor IP on FPGA in data center to accelerate Video Processing and Video Encoding, delivering functions as a service.",
        og_url: "https://blue-dot.io",
        twitter_card: "summary_large_image",
        twitter_domain: "blue-dot.io",
        twitter_title: "BLUEDOT",
        twitter_description: "BLUEDOT develops Semiconductor IP on FPGA in data center to accelerate Video Processing and Video Encoding, delivering functions as a service."
    },
    banner: [
        {
            first: "Using Deep Learning technology, you can increase the resolution and",
            second: "improve the quality of the video in ways that were never possible before."
        },
        {
            first: "Develop next-generation video/image codecs such as AV1/AVIF which have higher",
            second: "compression efficiency and low-cost encoding performance."
        }, 
    ],
    productTemplateList: [
        {
            imgPath: public_asset_03_section2_content1_content1_2x_png__WEBPACK_IMPORTED_MODULE_0__/* ["default"].src */ .Z.src,
            productName: "Video Super Resolution",
            productPhrase: "Same video, another resolution, deliver better viewing experience",
            productDescription: "Many people are communicating online through videos in forms of advertising, content, and information retrieval. High quality videos can capture the minds of the viewers in the flood of video contents. BLUEDOT wants to help you produce high quality video contents for your business customers by utilizing our own Artificial Intelligence technology.",
            productFeatureList: [
                "Removes noise and creates clarity and texture details",
                "Increases color and convert resolution fitting the latest display size", 
            ],
            reverseLayout: true
        },
        {
            imgPath: public_asset_03_section2_content2_content2_2x_png__WEBPACK_IMPORTED_MODULE_1__/* ["default"].src */ .Z.src,
            productName: "Video Quality Measurement (VMAF)",
            productPhrase: "Human Perception based Video Quality Measuring",
            productDescription: "The increased UHD content services improved the visual experience of viewers. Quality measurements for serviced videos have become very important, and evaluation methods (VMAF) based on the quality perceived by viewers are widely used. BLUEDOT provides an easy-to-use VMAF measurement solution.",
            productFeatureList: [
                "Due to its fast speed, it can also be used to measure the quality of real-time ultra-high resolution video services",
                "Low compute infrastructure consumption makes it ideal for services at an affordable cost", 
            ],
            reverseLayout: false
        },
        {
            imgPath: public_asset_03_section2_content3_content3_2x_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src,
            productName: "Perceptual Quality Optimizer",
            productPhrase: "Saving Bitrate while Sustaining Video Quality",
            productDescription: "The biggest concern for service providers is the network traffic because related directly to the cost of the service with the explosive growth of videos. Effective management considering the quality of the video is also crucial since it affects the experience of the viewer. BLUEDOT provides technology to increase compression efficiency while maintaining the perceptual quality of video.",
            productFeatureList: [
                "Enhances encoding efficiency by pre-processing input video with AI technology",
                "It can be applied to real-time streaming service and used with any codec", 
            ],
            reverseLayout: true
        },
        {
            imgPath: public_asset_03_section2_content4_content4_2x_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src,
            productName: "AVIF Image Encoder",
            productPhrase: "Most Efficient and Advanced Image Codec ",
            productDescription: "We use a lot of images on web pages for the efficient delivery of information. Service providers are burdened with the cost of network traffic as much as the amount of images has increased, and consumers are dissatisfied with the slow page loading time. BLUEDOT provides a very fast AVIF image encoder.",
            productFeatureList: [
                "It can be applied to real-time services due to its quick encoding",
                "Low use of computing resources reduce cost burden", 
            ],
            reverseLayout: false
        },
        {
            imgPath: public_asset_03_section2_content5_content5_2x_png__WEBPACK_IMPORTED_MODULE_4__/* ["default"].src */ .Z.src,
            productName: "AV1 Video Encoder",
            productPhrase: "Very High Performance AV1 Encoder",
            productDescription: "The user demand for high game resolution and frame rate is increasing. Nevertheless, cloud gaming and e-sports streaming platform operators are experiencing great difficulties in implementing services due to the increase in network bandwidth usage and the difficulty of low-latency encoding. BLUEDOT offers AV1 encoder solution through the cloud, developed by semiconductor design technology.",
            productFeatureList: [
                "Due to its fast performance, it fits low-latency encoding without compromising video quality",
                "The most cost-effective AV1 encoder solution", 
            ],
            reverseLayout: true
        }, 
    ],
    contact: {
        title: "Contact us",
        texts: [
            "Video upscaling cloud API usage, image quality testing, etc",
            "Please contact us if you have any inquiries about the product or technology.",
            "We will respond you as soon as possible", 
        ],
        buttonText: "Contact us now"
    },
    footer: {
        companyName: "BLUEDOT INC.",
        address: "4th floor of Gangnam Telepia Building, 527 Eonju-ro, Gangnam-gu, Seoul"
    },
    buttonText: {
        tryDemo: "Try Demo",
        learnMore: "Learn more",
        contactUs: "Contact us"
    },
    coreTech: [
        {
            description: "Develop technology where AI models trained for video processing algorithms such as noise removal, deblur, sharpen, upscale, and image quality improvement.",
            highlight: "Optimization of inference model for hardware where AI is utilized."
        },
        {
            description: "Develop next-generation video/image codecs such as AV1/AVIF to support better compression efficiency and low-latency encoding system.",
            highlight: "16+ years of codec development and business experience."
        },
        {
            description: "The developed solution is delivered in software SDK and hardware IP for a flexible and fast acceleration.",
            highlight: "Easy integration into FFmpeg media framework."
        },
        {
            description: "Accelerate solutions faster by implementing semiconductor design technology.",
            highlight: "Leverage new High-Level Synthesis design methodology to give faster deployment and flexible updates of solutions."
        }, 
    ],
    contactPopup: {
        title: "Contact to Sales",
        guideTexts: [
            "Please contact us if you have any inquiries about the product or technology such as video upscaling cloud API usage and image quality testing, etc. We will respond you as soon as possible.", 
        ],
        inputGuide: {
            inputTitle: "Select Theme",
            enterMessage: "Enter Inquiries",
            options: [
                "Purchase",
                "Technical Inquiry",
                "Product Inquiry",
                "Request AVIF Demo",
                "Others", 
            ]
        },
        privacyPolicy: {
            title: "Notice",
            policies: [
                "1. BLUEDOT uses the data to provide an answer for your inquiry.",
                "2. If you agree with this Privacy Policy, your data will be stored for 3 year and after the expiration, it will be deleted immediately. Please check the Privacy Policy.", 
            ],
            buttonText: [
                "Sending...",
                "Send Email"
            ],
            placeholders: {
                name: "Full Name",
                email: "Work Email",
                contact: "Phone Number",
                company: "Company",
                message: "Message"
            },
            completeText: "Email has sent successfully."
        }
    },
    lnb: {
        deepfield: "/product/sr/",
        pulsar: "/product/av1/",
        srLink: "/product/sr/#product-section",
        pqoLink: "/product/pqo/#product-section",
        vmafLink: "/product/vmaf/#product-section",
        avifLink: "/product/avif/#product-section",
        av1Link: "/product/av1/#product-section",
        about: "/about",
        blog: "/blog",
        event: "/event"
    },
    lnbLabel: {
        deepfield: "DeepField : Video Processing",
        pulsar: "Pulsar : Video Encoding"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (en);


/***/ }),

/***/ 4804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var public_asset_03_section2_content1_content1_2x_png__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9540);
/* harmony import */ var public_asset_03_section2_content2_content2_2x_png__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7388);
/* harmony import */ var public_asset_03_section2_content3_content3_2x_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5744);
/* harmony import */ var public_asset_03_section2_content4_content4_2x_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7027);
/* harmony import */ var public_asset_03_section2_content5_content5_2x_png__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4656);





var ko = {
    metaTag: {
        title: "블루닷 | 동영상 인공지능 및 코덱 기술 반도체 IP",
        description: "블루닷은 클라우드 기반의 시스템 반도체 IP를 서비스하기 위해 설립된 기술벤처회사입니다.",
        keywords: "블루닷, 시스템 반도체, Xilinx, 자일링스, FPGA, AI 업스케일링, 슈퍼레졸루션, 초해상화, 클라우드, 온프레미스, 데이터 센터, 스트리밍, AV1, 인코딩, 트랜스코딩",
        og_type: "website",
        og_title: "블루닷 (주)",
        og_description: "블루닷은 클라우드 기반의 시스템 반도체 IP를 서비스하기 위해 설립된 기술벤처회사입니다.",
        og_url: "https://blue-dot.io",
        twitter_card: "summary_large_image",
        twitter_domain: "blue-dot.io",
        twitter_title: "블루닷 (주)",
        twitter_description: "블루닷은 클라우드 기반의 시스템 반도체 IP를 서비스하기 위해 설립된 기술벤처회사입니다."
    },
    banner: [
        {
            first: "딥러닝 기술을 활용하여 기존의 방식으로는",
            second: "불가능했던 품질로 화질을 개선하고 해상도를 높일 수 있습니다."
        },
        {
            first: "비디오에 특화된 인공지능 모델을 개발합니다.",
            second: "반도체 설계 기술을 바탕으로 아주 빠른 비디오 전용 솔루션을 제공합니다."
        }, 
    ],
    productTemplateList: [
        {
            imgPath: public_asset_03_section2_content1_content1_2x_png__WEBPACK_IMPORTED_MODULE_0__/* ["default"].src */ .Z.src,
            productName: "Video Super Resolution",
            productPhrase: "Same video, another resolution, deliver better viewing experience",
            productDescription: "광고, 콘텐츠 그리고 정보 검색까지 많은 사람들이 온라인상에서 동영상으로 소통하고 있습니다. 수 많은 영상 콘텐츠의 홍수속에서 그들의 마음을 사로잡을 수 있는 것은 높은 품질 수준의 영상입니다. 블루닷은 자체 개발한 인공지능 기술을 활용하여 당신의 사업을 위해 고객들에게 서비스할 고품질 영상 콘텐츠를 생산하는데 도움을 주고자합니다. ",
            productFeatureList: [
                "노이즈를 제거하고 선명함과 텍스쳐의 디테일을 생성해 줍니다.",
                "색감을 올리고 해상도를 최신 디스플레이 크기에 맞게 변환해 줍니다.", 
            ],
            reverseLayout: true
        },
        {
            imgPath: public_asset_03_section2_content2_content2_2x_png__WEBPACK_IMPORTED_MODULE_1__/* ["default"].src */ .Z.src,
            productName: "Video Quality Measurement (VMAF)",
            productPhrase: "Human Perception based Video Quality Measuring",
            productDescription: "초고화질 영상의 서비스 증가로 사용자들의 시각적 경험이 향상되었습니다. 서비스 되는 영상에 대한 품질 측정이 매우 중요하게 되었는데 시청자가 인지하는 화질을 기준으로 하는 평가 방법(VMAF)이 널리 사용되어가고 있습니다.  블루닷은 쉽게 사용할 수 있는 VMAF 측정 솔루션을 제공합니다.",
            productFeatureList: [
                "속도가 빨라 실시간 초고해상도 영상 서비스의 품질 측정에도 사용할 수 있습니다.",
                "컴퓨팅 인프라 사용량이 적어 낮은 비용으로 규모의 서비스에 적용하기 적합 합니다.", 
            ],
            reverseLayout: false
        },
        {
            imgPath: public_asset_03_section2_content3_content3_2x_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src,
            productName: "Perceptual Quality Optimizer",
            productPhrase: "Saving Bitrate while Sustaining Video Quality",
            productDescription: "폭발적으로 증가하는 동영상으로 서비스 사업자에게 가장 고민이 되는 부분은 네트워크 트래픽입니다. 서비스 비용과 직결되기 때문인데 소비자의 시청 경험에 영향을 주는 동영상의 화질을 고려하여 효율적인 관리가 매우 중요합니다.  블루닷은 인지화질을 유지 하면서 압축효율을 높이는 기술을 제공합니다.",
            productFeatureList: [
                "인공지능 기술로 입력 동영상을 전처리 하여 인코딩 효율을 높여줍니다.",
                "빠른 가속이 가능하여 실시간 스트리밍 서비스 적용에도 문제 없으며 어떠한 코덱에도 함께 사용할 수 있습니다.", 
            ],
            reverseLayout: true
        },
        {
            imgPath: public_asset_03_section2_content4_content4_2x_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src,
            productName: "AVIF Image Encoder",
            productPhrase: "Most Efficient and Advanced Image Codec ",
            productDescription: "정보의 효율적인 전달을 위해 웹페이지에 많은 이미지를 사용하고 있습니다. 늘어난 이미지의 양 만큼 사업자는 트래픽 비용에 대한 비용 부담이 생기고 느려진 페이지 로딩시간으로 소비자의 불만이 생깁니다. 블루닷은 매우 빠른 AVIF 이미지 인코더를 제공합니다.",
            productFeatureList: [
                "빠르게 인코딩할 수 있어 실시간 서비스에 적용 가능합니다.",
                "낮은 컴퓨팅 리소스 사용으로 비용 부담이 적습니다.", 
            ],
            reverseLayout: false
        },
        {
            imgPath: public_asset_03_section2_content5_content5_2x_png__WEBPACK_IMPORTED_MODULE_4__/* ["default"].src */ .Z.src,
            productName: "AV1 Video Encoder",
            productPhrase: "Very High Performance AV1 Encoder",
            productDescription: "높은 게임 해상도 그리고 프레임 레이트에 대한 사용자 요구가 증가하고 있습니다. 하지만 클라우드 게이밍 그리고 e-스포츠 스트리밍 플랫폼 사업자들은 높은 네트워크 대역폭 사용량의 증가 그리고 저지연 인코딩의 어려움으로 서비스 구현에 큰 어려움을 경험하고 있습니다. 블루닷은 클라우드를 통해 반도체 설계 기술로 개발한 AV1 인코더 솔루션을 제공합니다.",
            productFeatureList: [
                "빠른 성능으로 화질의 손해 없이 저지연 인코딩에 적합합니다.",
                "가장 비용 효과적인 AV1 인코더 솔루션입니다.", 
            ],
            reverseLayout: true
        }, 
    ],
    contact: {
        title: "문의 및 연락",
        texts: [
            "비디오 업스케일링 클라우드 API 사용, 화질테스트 등",
            "제품\xb7기술과 관련된 궁금한 점이 있으시면 문의를 남겨주세요.",
            "최대한 빨리 답변해 드리겠습니다.", 
        ],
        buttonText: "문의하러 가기"
    },
    footer: {
        companyName: "블루닷 (주)",
        address: "서울 강남구 언주로 527 강남텔레피아빌딩 4층"
    },
    buttonText: {
        tryDemo: "체험해보기",
        learnMore: "더 알아보기",
        contactUs: "문의하기"
    },
    coreTech: [
        {
            description: "노이즈 제거, 디블러, 샤프닝, 업스케일링, 화질개선 등과 같은 영상처리 알고리즘을 위해 전용 인공지능 모델을 학습 시키는 개발 기술",
            highlight: "인공지능을 적용할 하드웨어에 맞는 추론 모델의 최적화 기술"
        },
        {
            description: "AV1/AVIF와 같은 차세대 비디오/이미지 코덱을 개발하여 더 나은 압축 효율성과 저지연 인코딩 성능을 지원",
            highlight: "16년 이상의 코덱 개발 및 사업 경험"
        },
        {
            description: "개발된 솔루션은 유연하고 빠른 가속을 위해 소프트웨어 SDK 그리고 하드웨어 IP로 제공",
            highlight: "FFmpeg 미디어 프레임워크에 쉬운 통합"
        },
        {
            description: "반도체 설계 기술로 구현함으로써 솔루션을 더 빠르게 가속",
            highlight: "새로운 설계기법(High-Level Synthesis)의 활용으로 솔루션의 더 빠른 구현과 유연한 업데이트가 가능"
        }, 
    ],
    contactPopup: {
        title: "제품 및 기술 관련 문의",
        guideTexts: [
            // '비디오 업스케일링 클라우드 API 사용, 화질 테스트 등',
            // '제품·기술과 관련된 궁금한 점이 있으시면 문의를 남겨주세요.',
            // '최대한 빨리 답변해 드리겠습니다.',
            "비디오 업스케일링 클라우드 API 사용, 화질 테스트 등 제품\xb7기술과 관련된 궁금한 점이 있으시면 문의를 남겨주세요. 최대한 빨리 답변해 드리겠습니다.", 
        ],
        inputGuide: {
            inputTitle: "문의종류 선택",
            enterMessage: "문의 내용 입력",
            options: [
                "구매",
                "기술 문의",
                "제품 문의",
                "AVIF Demo 요청",
                "기타", 
            ]
        },
        privacyPolicy: {
            title: "확인사항",
            policies: [
                "1. 위에서 입력하는 개인정보 항목들은 고객 문의에 대한 답변제공을 위해 이용됩니다.",
                "2. 수집된 개인정보는 3년간 보유하며 개인정보의 보유 및 이용 기간이 끝난 경우 즉시 파기합니다. 개인정보처리방침 내용 전문을 반드시 확인해주세요.", 
            ],
            buttonText: [
                "전송중...",
                "제출하기"
            ],
            placeholders: {
                name: "이름",
                email: "메일",
                contact: "연락처",
                company: "회사명",
                message: "문의 내용"
            },
            completeText: "보내기가 완료되었습니다."
        }
    },
    lnb: {
        deepfield: "/product/sr/",
        pulsar: "/product/av1/",
        srLink: "/product/sr/#product-section",
        pqoLink: "/product/pqo/#product-section",
        vmafLink: "/product/vmaf/#product-section",
        avifLink: "/product/avif/#product-section",
        av1Link: "/product/av1/#product-section",
        about: "/about",
        blog: "/blog",
        event: "/event"
    },
    lnbLabel: {
        deepfield: "DeepField : 영상처리",
        pulsar: "Pulsar : 영상압축"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (ko);


/***/ }),

/***/ 9014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "en": function() { return /* binding */ en; },
/* harmony export */   "ko": function() { return /* binding */ ko; }
/* harmony export */ });
var en = {
    midDesc: "< BLUEDOT > (\"https://www.blue-dot.io/\"hereinafter referred to as 'BLUEDOT') establishes and\ndiscloses the privacy policy as follows to protect personal information and swiftly and efficiently\nrespond to related concerns pursuant to 「Personal Information Protection Act」 Article 30.",
    articles: [
        {
            title: "Article 1 (Purpose of Processing Personal Information)",
            desc: "The purposes of processing personal information files, < BLUEDOT > registers and discloses\npursuant to the Personal Information Protection Act Article 32, are as follows.\n\n1. Personal Information File Name: BLUEDOT Privacy Policy\nThe Purpose of Processing Personal Information: Collection of basic information for service delivery and response to inquiries and suggestions\nMeans of Collection: homepage\nBasis of Storage: Prevention of duplicate accounts and Act on the Consumer Protection in Electronic Commerce Act\nStorage Period: 3 years\nRelated Laws: Recording of credit information collection/process and usage, etc.: 3 years, Recording of processing consumers' complaints and disputes: 3 years, Recording of payment and provision of commodities, etc.: 5 years, Recording of contract or withdrawal, etc.: 5 years, Recording of display/advertisement: 6 months"
        },
        {
            title: "Article 2 (Categories of Processed Personal Information)",
            desc: "① < BLUEDOT > processes the following personal information categories.\n1. < BLUEDOT Privacy Policy >\nRequired: Email, mobile number, office telephone number, company name, service usage history,\naccess log, cookie, connecting IP information, payment history"
        },
        {
            title: "Article 3 (Process and Method of Destroying Personal Information)",
            desc: "① < BLUEDOT > destroys the personal information without hesitation in case personal information\nbecomes unnecessary due to elapsed storage period, accomplishment of purpose, etc.\n② In case personal information is required to be retained pursuant to other laws despite the elapse of storage period and accomplishment of the purpose of personal information approved by the information controller, the information is moved to a separate database (DB) or stored in a different storage location.\n③ The process of destroying personal information is as follows.\n1. Destruction Process\n< BLUEDOT > selects personal information for which the reason for destruction occurred, and\ndestroys it with the approval of < BLUEDOT >'s privacy protection manager.\n2. Destruction Method\nInformation in form of electronic file format is destroyed by the technical method whose records\ncannot be restored."
        },
        {
            title: "Article 4 (Matters Concerning the Rights and Obligations of Information Controllers and their Legal Representatives and How to Exercise Them)",
            desc: "① Information controllers may exercise their rights to browse, correct, delete, request suspension of the process, etc. to BLUEDOT at any time.\n② The rights in alignment with Clause 1 may be exercised via letter, phone call, email, FAX, etc. and the company shall take measures immediately.\n③ The rights in alignment with Clause 1 may be exercised via an agent such as a legal representative of the information controller or a delegated person. In this case, the power of attorney must be submitted in the format prescribed by “Notification Concerning Method of Processing Personal Information (2020-7)” Annexation 11.\n④ The rights of information controllers to request to browse or suspend personal information may be limited in pursuance of 「Personal Information Protection Act」 Article 35-7 and Article 37-2.\n⑤ Regarding the request to correct or delete personal information, it shall not be eligible for deletion request in case the information is stipulated as the subject of storage in other laws.\n⑥ In case of a request to browse, or request to correct or delete in pursuance of the information controller's rights, BLUEDOT verifies whether the person making the request is the information controller or their authorized representative."
        },
        {
            title: "Article 5 (Matters Concerning Securing Safety of Personal Information)",
            desc: "< BLUEDOT > is taking measures to secure safety of personal information as follow.\n1. Conduction of regular internal audits\nWe conduct internal audits (quarterly) to secure the safety of personal information processing.\n2. Minimizing and training employees dealing with personal information We implement measures to manage personal information by designating employees responsible to deal with personal information and minimizing the number of them.\n3. Establishment and Implementation of the internal management plan We establish and implement an internal management plan to safely process personal information\n4. Technical countermeasures to prepare for hacking, etc.\n<BLUEDOT>('BLUEDOT') installs security programs, regularly renews and inspects them, builds the system in the restricted area from the outside and technically/physically surveils and blocks the threats to prevent leak and damage to personal information by hacking or virus.\n5. Restriction of access to personal information\nWe take necessary measures to restrict access to personal information through authorization, change, and termination of access to personal information database system, and control unauthorized access from the outside by using a firewall system."
        },
        {
            title: "Article 6 (Matters Concerning Installation & Operation of Device to Automatically Collect Personal Information and Rejection)",
            desc: "① BLUEDOT utilizes 'cookie', which stores and from time to time retrieves usage information to provide users with customized services.\n② Cookie is a small portion of information the server (http) used to operate the website sends to the user's computer, and it may be saved on the hard disk of user's PC.\nA. The purpose of cookie: Cookies are used to provide users with optimized information by identifying the services the user visited, the pattern of website visits and usage, secure access, etc.\nB. Install•Operation and Rejection of cookie: You may reject the storage of cookies through Tools at the top of your web browser>Internet Option >the settings in the Privacy menu.\nC. In case you reject cookie storage, difficulties in using customized services may occur."
        },
        {
            title: "Article 7 (Matters Concerning the Privacy Protection Manager)",
            desc: "① BLUEDOT designated the privacy protection manager as follows to take full responsibility for the tasks concerning personal information, deal with complaints of information controller, compensate their damages, etc.\n      ▶ Privacy Protection Manager\nName: Hyeong-Seok Han\nPosition: CMO\nRank: Director\nContact: 02-6205-0812, philip.han@blue-dot.io\n※ The contact is connected to Privacy Protection Division.\n\n▶ Division in Charge of Privacy Protection\nDivision Name: Marketing\nManager: Hyeong-Seok Han\nContact: 02-6205-0812, philip.han@blue-dot.io\n\n② Information controller may consult with the Privacy Protection Manager or Privacy Protection Division over the matters concerning inquiries, complaints, and compensations that occurred during using BLUEDOT's services (or business). BLUEDOT shall respond to and process the information controllers' inquiries promptly."
        },
        {
            title: "Article 8 (Division to Receive and Process Request to Inspect Personal Information)",
            desc: "The information controller may make a request to inspect personal information pursuant to ｢Personal Information Protection Act｣ Article 35 to the following division.\n\n      < BLUEDOT > shall do our best to speedily process the information controller's request to inspect\npersonal information.\n\n▶ Division in Charge of Receiving \xb7 Processing Personal Information Inspection Request\nDivision Name: Marketing\nManager: Ga-Eun Park\nContact: 02-6205-0812, gwen.park@blue-dot.io"
        },
        {
            title: "Article 9 (Remedies for Infringement of Rights and Benefits of Information Controller)",
            desc: "Information controller may apply for dispute mediation, consultation, etc. to Personal Information Dispute Mediation Committee, KISA Personal Information Infringement Report Center, etc. to receive remedies for infringement of their personal information. Please consult with the following institutions over the report and consultation over other personal information infringement.\n      1. Personal Information Dispute Mediation Committee: (without exchange number) 1833-6972 (www.kopico.go.kr)\n      2. Personal Information Infringement Report Center: (without exchange number) 118 (privacy.kisa.or.kr)\n      3. Supreme Prosecutor's Office: (without exchange number) 1301 (www.spo.go.kr)\n      4. National Police Agency: (without exchange number) 182 (ecrm.cyber.go.kr)\n\nThe person whose rights and benefits are infringed due to a disposition or omission of the head of the government office regarding the request under 「Personal Information Protection Act」 Article 35 (Access to Personal Information), Article 36 (Rectification or Erasure of Personal Information), and Article 37 (Suspension of Processing of Personal Information) may file an administrative appeal in pursuance of Administrative Appeals Act.\n\n※ Please refer to the web page of Online Administrative Appeals (www.simpan.go.kr) for further information on administrative appeals."
        },
        {
            title: "Article 10 (Changes to Privacy Policy)",
            desc: "① The privacy policy above is active starting from September 07, 2022."
        }, 
    ]
};
var ko = {
    midDesc: '< BLUEDOT >("https://www.blue-dot.io/"이하 "BLUEDOT")은(는) 「개인정보 보호법」 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립\xb7공개합니다.',
    articles: [
        {
            title: "제1조(개인정보의 처리목적)",
            desc: "< BLUEDOT >(이)가 개인정보 보호법 제32조에 따라 등록․공개하는 개인정보파일의 처리목적은\n다음과 같습니다.\n\n1. 개인정보 파일명 : BLUEDOT 개인정보처리방침\n개인정보의 처리목적 : 서비스 전달, 문의 및 제안사항 회신을 기본 정보 수집\n수집방법 : 홈페이지\n보유근거 : 중복 신청 방지 및 전자상거래 등에서의 소비자보호에 관한 법률\n보유기간 : 3년\n관련법령 : 신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년, 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년, 대금결제 및 재화 등의 공급에 관한 기록 : 5년, 계약 또는 청약철회 등에 관한 기록 : 5년, 표시/광고에 관한 기록 : 6개월"
        },
        {
            title: "제2조(처리하는 개인정보의 항목)",
            desc: "① < BLUEDOT >은(는) 다음의 개인정보 항목을 처리하고 있습니다.\n1. < BLUEDOT 개인정보처리방침 >\n필수항목 : 이메일, 휴대전화번호, 회사전화번호, 회사명, 서비스 이용 기록, 접속 로그, 쿠키, 접속 IP 정보, 결제기록"
        },
        {
            title: "제3조(개인정보의 파기절차 및 파기방법)",
            desc: "① < BLUEDOT > 은(는) 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.\n② 정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.\n③ 개인정보 파기의 절차 및 방법은 다음과 같습니다.\n1. 파기절차\n< BLUEDOT > 은(는) 파기 사유가 발생한 개인정보를 선정하고, < BLUEDOT > 의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.\n2. 파기방법\n전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다"
        },
        {
            title: "제4조(정보주체와 법정대리인의 권리\xb7의무 및 그 행사방법에 관한 사항)",
            desc: "① 정보주체는 BLUEDOT에 대해 언제든지 개인정보 열람\xb7정정\xb7삭제\xb7처리정지 요구 등의 권리를 행사할 수 있습니다.\n\n② 제1항에 따른 권리 행사는 회사에 대해 서면, 전화, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 회사는 이에 대해 지체없이 조치하겠습니다.\n③ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 “개인정보 처리 방법에 관한 고시(제2020-7호)” 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.\n④ 개인정보 열람 및 처리정지 요구는 「개인정보 보호법」 제35조 제4항, 제37조 제2항에 의하여 정보주체의 권리가 제한 될 수 있습니다.\n⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.\n⑥ BLUEDOT은(는) 정보주체 권리에 따른 열람의 요구, 정정\xb7삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다."
        },
        {
            title: "제5조(개인정보의 안전성 확보조치에 관한 사항)",
            desc: "< BLUEDOT >은(는) 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.\n1. 정기적인 자체 감사 실시\n개인정보 취급 관련 안정성 확보를 위해 정기적(분기 1회)으로 자체 감사를 실시하고 있습니다.\n2. 개인정보 취급 직원의 최소화 및 교육\n개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화 하여 개인정보를 관리하는 대책을 시행하고 있습니다.\n3. 내부관리계획의 수립 및 시행\n개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.\n4. 해킹 등에 대비한 기술적 대책\n<BLUEDOT>('BLUEDOT')은 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신\xb7점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.\n5. 개인정보에 대한 접근 제한\n개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여,변경,말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다."
        },
        {
            title: "제6조(개인정보를 자동으로 수집하는 장치의 설치\xb7운영 및 그 거부에 관한 사항)",
            desc: "① BLUEDOT 은(는) 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다.\n② 쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다.\n가. 쿠키의 사용 목적 : 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.\n나. 쿠키의 설치•운영 및 거부 : 웹브라우저 상단의 도구>인터넷 옵션>개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부 할 수 있습니다.\n다. 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다."
        },
        {
            title: "제7조 (개인정보 보호책임자에 관한 사항)",
            desc: "① BLUEDOT 은(는) 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.\n\n      ▶ 개인정보 보호책임자\n성명 :한형석\n직책 :CMO\n직급 :이사\n연락처 :02-6205-0812, philip.han@blue-dot.io\n※ 개인정보 보호 담당부서로 연결됩니다.\n▶ 개인정보 보호 담당부서\n부서명 :마케팅\n담당자 :한형석\n연락처 :02-6205-0812, philip.han@blue-dot.io\n② 정보주체께서는 BLUEDOT 의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. BLUEDOT 은(는) 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다."
        },
        {
            title: "제8조(개인정보의 열람청구를 접수\xb7처리하는 부서)",
            desc: "정보주체는 ｢개인정보 보호법｣ 제35조에 따른 개인정보의 열람 청구를 아래의 부서에 할 수 있습니다.\n< BLUEDOT >은(는) 정보주체의 개인정보 열람청구가 신속하게 처리되도록 노력하겠습니다.\n▶ 개인정보 열람청구 접수\xb7처리 부서\n\n부서명 : 마케팅\n담당자 : 박가은\n연락처 : 02-6205-0812, gwen.park@blue-dot.io"
        },
        {
            title: "제9조(정보주체의 권익침해에 대한 구제방법)",
            desc: "정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보침해의 신고, 상담에 대하여는 아래의 기관에 문의하시기 바랍니다.\n1. 개인정보분쟁조정위원회 : (국번없이) 1833-6972 (www.kopico.go.kr)\n2. 개인정보침해신고센터 : (국번없이) 118 (privacy.kisa.or.kr)\n3. 대검찰청 : (국번없이) 1301 (www.spo.go.kr)\n4. 경찰청 : (국번없이) 182 (ecrm.cyber.go.kr)\n\n「개인정보보호법」제35조(개인정보의 열람), 제36조(개인정보의 정정\xb7삭제), 제37조(개인정보의 처리정지 등)의 규정에 의한 요구에 대 하여 공공기관의 장이 행한 처분 또는 부작위로 인하여 권리 또는 이익의 침해를 받은 자는 행정심판법이 정하는 바에 따라 행정심판을 청구할 수 있습니다.\n※ 행정심판에 대해 자세한 사항은 중앙행정심판위원회(www.simpan.go.kr) 홈페이지를 참고하시기 바랍니다."
        },
        {
            title: "제10조(개인정보 처리방침 변경)",
            desc: "① 이 개인정보처리방침은 2022년 09월 07부터 적용됩니다."
        }, 
    ]
};


/***/ }),

/***/ 9222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useSendZendiskTicketMutation; }
/* harmony export */ });
/* unused harmony export sendZendeskTicket */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5680);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5573);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2066);




// https://bluedot3562.zendesk.com/api/v2/tickets.json
var sendZendeskTicket = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(body) {
        var data, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("/api/send-zd-ticket", body)
                    ];
                case 1:
                    data = _state.sent();
                    console.log(data);
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    console.log(e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function sendZendeskTicket(body) {
        return _ref.apply(this, arguments);
    };
}();
var useSendZendiskTicketMutation = function() {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useMutation)({
        mutationFn: function(param) {
            var name = param.name, email = param.email, contact = param.contact, company = param.company, queryKind = param.queryKind, message = param.message;
            var labels = {
                Purchase: "구매",
                "Technical Inquiry": "기술문의",
                "Product Inquiry": "제품 문의",
                "Request AVIF Demo": "AVIF 데모 요청",
                Other: "기타"
            };
            return sendZendeskTicket({
                ticket: {
                    subject: "[".concat(labels[queryKind] || queryKind, "] | [").concat(company, "] 로 부터 전송된 문의"),
                    comment: {
                        html_body: "<p><strong>Name</strong> : ".concat(name, "</p>\n                        <p><strong>Email</strong> : ").concat(email, "</p>\n                        <p><strong>Contact</strong> : ").concat(contact || "-", "</p>\n                        <p><strong>Company</strong> : ").concat(company, "</p>\n                        <br />\n                        <p><strong>Message</strong> : ").concat(message, "</p>"),
                        public: true
                    },
                    requester: {
                        email: email,
                        name: name
                    },
                    custom_fields: [
                        {
                            id: "12234644768527",
                            value: "homepage"
                        },
                        {
                            id: "12276217298831",
                            value: "email"
                        }
                    ],
                    assignee_email: "sales@blue-dot.io"
                }
            });
        }
    });
};


/***/ }),

/***/ 3081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pm": function() { return /* binding */ mediaQueryStyle; },
/* harmony export */   "m": function() { return /* binding */ generateCssStyle; }
/* harmony export */ });
/* unused harmony export breakpoints */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6383);
/* eslint-disable no-unused-vars */ /**
  * Break points
  * @constant
  * @param {string}({
  * ( XL : width >= 1440px ),
  * ( L : 1440px > width >= 1240px )
  * ( M : 1240px > width >= 905px )
  * ( S : 904px > width >= 600px )
  * ( XS : 600px > width )
 })
 */ 
var breakpoints = {
    XL: "@screen and (min-width: 1440px)",
    L: "@screen and (max-width: 1439px) and (min-width: 1240px)",
    M: "@screen and (max-width: 1239px) and (min-width: 905px)",
    S: "@screen and (max-width: 904px) and (min-width: 600px)",
    XS: "@screen and (max-width: 599px)",
    stL: "@screen and (max-width: 1439px)",
    stM: "@screen and (max-width: 1240px)",
    stS: "@screen and (max-width: 904px)"
};
var size = {
    XL: "1440px",
    L: "1240px",
    M: "905px",
    S: "600px",
    XS: "0px"
};
var mediaQueryStyle = Object.keys(size).reduce(function(acc, key) {
    acc[key] = function(style) {
        var mediaQuery = "@media screen and (min-width: ".concat(size[key], ") { ").concat(style, " }");
        return mediaQuery;
    };
    return acc;
}, {});
var generateCssStyle = function(styleObj) {
    var entries = Object.entries(styleObj);
    var styleString = "";
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_step.value, 2), key = _value[0], value = _value[1];
            styleString += "".concat(key, ": ").concat(value, ";");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return styleString;
};


/***/ }),

/***/ 7622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* reexport */ Dropdown; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(6670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(6297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(8316);
// EXTERNAL MODULE: ../../packages/global-styles/index.ts
var global_styles = __webpack_require__(9059);
;// CONCATENATED MODULE: ../../packages/dropdown/hooks/useSetOptionListRendering.tsx

// 옵션리스트
var useSetOptionListRendering = function(param) {
    var isOpen = param.isOpen, container = param.container, toggleRef = param.toggleRef, optionListRef = param.optionListRef, isPositionFixed = param.isPositionFixed;
    var renderOptionList = function() {
        var toggleElement = toggleRef === null || toggleRef === void 0 ? void 0 : toggleRef.current;
        var optionListElement = optionListRef === null || optionListRef === void 0 ? void 0 : optionListRef.current;
        if (!toggleElement || !optionListElement) return;
        if (isOpen) {
            var scrollY = window.scrollY, scrollX = window.scrollX;
            var toggleBoundingRect = toggleElement.getBoundingClientRect();
            var topCoords = isPositionFixed ? toggleBoundingRect.bottom : toggleBoundingRect.bottom + scrollY;
            var leftCoords = isPositionFixed ? toggleBoundingRect.left : toggleBoundingRect.left + scrollX;
            if (isPositionFixed) optionListElement.style.position = "fixed";
            optionListElement.style.minWidth = "".concat(toggleBoundingRect.width, "px");
            optionListElement.style.left = "".concat(leftCoords, "px");
            optionListElement.style.top = "".concat(topCoords, "px");
            optionListElement.style.marginTop = "8px";
            optionListElement.style.transform = "scale(1)";
            optionListElement.style.opacity = "1";
        }
    };
    (0,react.useEffect)(function() {
        if (container) renderOptionList();
    }, [
        container
    ]);
};

;// CONCATENATED MODULE: ../../packages/dropdown/hooks/useClick.tsx

var useClick = function(param) {
    var toggleRef = param.toggleRef, optionListRef = param.optionListRef, toggle = param.toggle, close = param.close, onChange = param.onChange;
    var handleClick = (0,react.useCallback)(function(e) {
        var ref = [
            toggleRef === null || toggleRef === void 0 ? void 0 : toggleRef.current,
            optionListRef === null || optionListRef === void 0 ? void 0 : optionListRef.current, 
        ], toggleElement = ref[0], optionListElem = ref[1];
        var target = e.target;
        var isTargetToggleElement = target === toggleElement || (toggleElement === null || toggleElement === void 0 ? void 0 : toggleElement.contains(target));
        var isTargetOptionElement = target === optionListElem || (optionListElem === null || optionListElem === void 0 ? void 0 : optionListElem.contains(target));
        if (!isTargetOptionElement && !isTargetToggleElement) {
            close();
        } else if (isTargetToggleElement) {
            toggle();
        } else if (isTargetOptionElement) {
            var clickedOption = Array.from(optionListElem.children)// const clickedOption = ([...optionListElem!.children] as HTMLLIElement[])
            .filter(function(option) {
                return option.ariaDisabled !== "true";
            }).find(function(option) {
                return option.contains(target) || option === target;
            });
            if (clickedOption) {
                var newValue = clickedOption.dataset.value;
                onChange(e, newValue);
                close();
            }
        }
    }, [
        toggleRef,
        optionListRef,
        close,
        toggle
    ]);
    (0,react.useEffect)(function() {
        window.addEventListener("click", handleClick);
        return function() {
            return window.removeEventListener("click", handleClick);
        };
    }, [
        handleClick
    ]);
};

;// CONCATENATED MODULE: ../../packages/dropdown/hooks/useKeydown.tsx

var useKeydown = function(param) {
    var toggleRef = param.toggleRef, optionListRef = param.optionListRef, close = param.close, toggle = param.toggle, onChange = param.onChange;
    var handleKeydown = function(e) {
        if (e.repeat || e.isComposing || e.keyCode === 229) return;
        var ref = [
            toggleRef === null || toggleRef === void 0 ? void 0 : toggleRef.current,
            optionListRef === null || optionListRef === void 0 ? void 0 : optionListRef.current, 
        ], toggleElement = ref[0], optionListElem = ref[1];
        var target = e.target;
        var isTargetToggleElement = target === toggleElement || (toggleElement === null || toggleElement === void 0 ? void 0 : toggleElement.contains(target));
        var isTargetOptionElement = target === optionListElem || (optionListElem === null || optionListElem === void 0 ? void 0 : optionListElem.contains(target));
        if (!isTargetToggleElement && !isTargetOptionElement) return;
        var pressedKey = e.key;
        // esc 누르면 혹은 tab 누르면 close
        if (pressedKey === "Escape" || pressedKey === "Tab") {
            if (optionListElem) {
                e.preventDefault();
                toggleElement === null || toggleElement === void 0 ? void 0 : toggleElement.focus();
                close();
            }
        } else if (e.code === "Space" || pressedKey === "Enter") {
            e.preventDefault();
            if (target.children) {
                var anchorChild = Array.from(target.children).find(// const anchorChild = [...target.children!].find(
                function(item) {
                    return item.tagName === "A";
                });
                if (anchorChild) {
                    anchorChild.click();
                    close();
                    toggleElement === null || toggleElement === void 0 ? void 0 : toggleElement.focus();
                    return;
                }
            }
            if (isTargetToggleElement) toggle();
            else {
                // const optionList = [...optionListElem!.children] as HTMLLIElement[];
                var optionList = Array.from(optionListElem.children);
                var pressedOption = optionList.filter(function(option) {
                    return option.ariaDisabled !== "true";
                }).find(function(option) {
                    return option.contains(target) || option === target;
                });
                if (pressedOption) {
                    var newValue = pressedOption.dataset.value;
                    onChange(e, newValue);
                    close();
                    toggleElement === null || toggleElement === void 0 ? void 0 : toggleElement.focus();
                }
            }
        } else if (pressedKey === "ArrowUp" || pressedKey === "ArrowDown") {
            if (!optionListElem) return;
            e.preventDefault();
            // const optionListElems = [...optionListElem!.children] as HTMLLIElement[];
            var optionListElems = Array.from(optionListElem.children);
            if (isTargetToggleElement) {
                var ref1;
                if (optionListElems[0]) (ref1 = optionListElems[0]) === null || ref1 === void 0 ? void 0 : ref1.focus();
            } else {
                var focusedElement = document.activeElement;
                var currentFocusedOptionIndex = optionListElems.findIndex(function(option) {
                    return option === focusedElement;
                });
                if (currentFocusedOptionIndex !== -1) {
                    var ref2;
                    var direction = pressedKey === "ArrowUp" ? -1 : 1;
                    var newFocusOptionIdx = pressedKey === "ArrowUp" ? Math.min(currentFocusedOptionIndex + direction, 0) : Math.max(currentFocusedOptionIndex + direction, optionListElems.length - 1);
                    (ref2 = optionListElems[newFocusOptionIdx]) === null || ref2 === void 0 ? void 0 : ref2.focus();
                }
            }
        }
    };
    (0,react.useEffect)(function() {
        window.addEventListener("keydown", handleKeydown);
        return function() {
            return window.removeEventListener("keydown", handleKeydown);
        };
    }, [
        toggleRef,
        optionListRef,
        close,
        toggle
    ]);
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(2228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../packages/dropdown/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        ";\n      border: 1px solid #ccc;\n      svg {\n        path {\n          fill: ",
        ";\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 8px 6px;\n      border: 1px solid transparent;\n      color: ",
        ";\n      svg {\n        path {\n          fill: ",
        ";\n        }\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 8px 16px;\n  border: 1px solid #ccc;\n  border-radius: 18px !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: 0.15s all;\n  color: #fff;\n  border: 1px solid #fff;\n  svg {\n    path {\n      fill: #fff;\n    }\n  }\n\n  svg {\n    margin-left: 8px;\n  }\n  ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  padding: 10px;\n  position: absolute;\n  background: #ffffff;\n  box-shadow: 0px 4px 8px 2px rgba(0, 0, 0, 0.12);\n  border-radius: 16px;\n  opacity: 0;\n  transform: scale(0);\n  transform-origin: top center;\n  transition: transform 0.1s ease-in-out, opacity 0.15s ease-in-out;\n  z-index: 9999;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > * {\n    display: inline-block;\n    width: 100%;\n    padding: 8px 0;\n    text-align: center;\n    color: ",
        ";\n    text-transform: uppercase;\n    cursor: pointer;\n  }\n  &[aria-selected='true'] > * {\n    color: ",
        ";\n    text-decoration: underline;\n    text-underline-position: under;\n  }\n  &[aria-disabled='true'] > * {\n    cursor: not-allowed;\n  }\n  &:hover > button {\n    color: ",
        " !important;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var ToggleContainer = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__ToggleContainer",
    componentId: "sc-de2348dd-0"
})(_templateObject2(), function(param) {
    var changeStyle = param.changeStyle;
    return changeStyle && (0,styled_components_browser_esm/* css */.iv)(_templateObject(), global_styles.BB, global_styles.BB);
}, function(param) {
    var displayBorder = param.displayBorder;
    return !displayBorder && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), global_styles/* GRAY30 */.zm, global_styles/* GRAY60 */.Ts);
});
var OptionListContainer = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "styles__OptionListContainer",
    componentId: "sc-de2348dd-1"
})(_templateObject3());
var OptionItemContainer = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "styles__OptionItemContainer",
    componentId: "sc-de2348dd-2"
})(_templateObject4(), global_styles/* GRAY70 */.Q2, global_styles.BB, global_styles/* GRAY30 */.zm);

// EXTERNAL MODULE: ../../packages/assets/icons.tsx
var icons = __webpack_require__(1089);
;// CONCATENATED MODULE: ../../packages/dropdown/Dropdown.tsx












var DropdownContext = /*#__PURE__*/ (0,react.createContext)({
    isOpen: false,
    toggle: function() {},
    onChange: function() {},
    disabled: false,
    container: null,
    toggleRef: null,
    optionListRef: null,
    changeStyle: false,
    displayBorder: true
});
var useDropdownContext = function() {
    var context = (0,react.useContext)(DropdownContext);
    if (!context) {
        throw new Error("Toggle compound components cannot be rendered outside the Toogle component.");
    }
    return context;
};
var Dropdown = function(param) {
    var children = param.children, _changeStyle = param.changeStyle, changeStyle = _changeStyle === void 0 ? false : _changeStyle, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _displayBorder = param.displayBorder, displayBorder = _displayBorder === void 0 ? true : _displayBorder, isPositionFixed = param.isPositionFixed, onChange = param.onChange;
    var ref = (0,react.useState)(null), container = ref[0], setContainer = ref[1];
    var containerUniqueId = (0,react.useId)();
    var isOpen = container !== null;
    var close = function() {
        var $container = document.getElementById(containerUniqueId);
        if ($container) {
            $container.remove();
        }
        setContainer(null);
    };
    var open = function() {
        var $container = document.getElementById(containerUniqueId);
        if ($container) {
            setContainer($container);
        } else {
            var $newContainer = document.createElement("div");
            $newContainer.id = containerUniqueId;
            document.body.appendChild($newContainer);
            setContainer($newContainer);
        }
    };
    var toggle = (0,react.useCallback)(function() {
        if (isOpen) close();
        else open();
    }, [
        isOpen,
        container
    ]);
    var toggleRef = (0,react.useRef)(null);
    var optionListRef = (0,react.useRef)(null);
    var providerValue = {
        isOpen: isOpen,
        disabled: disabled,
        onChange: onChange,
        toggle: toggle,
        container: container,
        toggleRef: toggleRef,
        optionListRef: optionListRef,
        changeStyle: changeStyle,
        displayBorder: displayBorder
    };
    useSetOptionListRendering({
        isOpen: isOpen,
        container: container,
        toggleRef: toggleRef,
        optionListRef: optionListRef,
        isPositionFixed: isPositionFixed
    }); // optionList 위치 조절 및 렌더링 관리
    useClick({
        toggleRef: toggleRef,
        optionListRef: optionListRef,
        close: close,
        toggle: toggle,
        onChange: onChange
    }); // click 이벤트 관리 hook
    useKeydown({
        toggleRef: toggleRef,
        optionListRef: optionListRef,
        close: close,
        toggle: toggle,
        onChange: onChange
    }); // keyboard 이벤트 관리 hook
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownContext.Provider, {
        value: providerValue,
        children: children
    });
};
// 하위 컴포넌트들을 Dropdown 컴포넌트의 property로 사용 -> Dropdown만 import 하면 나머지 컴포넌트들도 사용가능 + 네임스페이스 분리 효과
var Toggle = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var ref = useDropdownContext(), toggleRef = ref.toggleRef, isOpen = ref.isOpen, disabled = ref.disabled, changeStyle = ref.changeStyle, displayBorder = ref.displayBorder;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToggleContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        ref: toggleRef,
        "aria-expanded": isOpen,
        "aria-disabled": disabled,
        disabled: disabled,
        changeStyle: changeStyle,
        displayBorder: displayBorder,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* ButtonText2 */.zg, {
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ChevronIcon */.DV, {})
        ]
    }));
};
var OptionList = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var isOpen = useDropdownContext().isOpen;
    var optionListRef = useDropdownContext().optionListRef;
    return isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Portal, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionListContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
            ref: optionListRef,
            role: "listbox",
            children: children
        }))
    }) : null;
};
var OptionItem = function(_param) {
    var children = _param.children, selected = _param.selected, disabled = _param.disabled, value = _param.value, label = _param.label, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "selected",
        "disabled",
        "value",
        "label"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionItemContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        role: "option",
        "aria-selected": selected,
        "aria-disabled": disabled,
        tabIndex: disabled ? -1 : 0,
        "data-value": value,
        children: children || /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* ButtonText2 */.zg, {
            children: label
        })
    }));
};
Dropdown.Toggle = Toggle;
Dropdown.OptionList = OptionList;
Dropdown.OptionItem = OptionItem;
var Portal = function(param) {
    var children = param.children;
    var container = useDropdownContext().container;
    return /*#__PURE__*/ react_dom.createPortal(children, container);
};

;// CONCATENATED MODULE: ../../packages/dropdown/types.ts


;// CONCATENATED MODULE: ../../packages/dropdown/index.tsx




/***/ })

}]);